import { OhVueIcon as le, addIcons as Ge } from "oh-vue-icons";
import { defineComponent as D, openBlock as r, createElementBlock as d, normalizeClass as C, toDisplayString as v, ref as B, watchEffect as Qt, computed as g, onMounted as ne, watch as te, createBlock as L, resolveDynamicComponent as J, withCtx as F, createElementVNode as o, renderSlot as I, unref as N, Transition as dt, createTextVNode as z, createCommentVNode as m, resolveComponent as se, withDirectives as Oe, vShow as ut, Fragment as R, renderList as X, normalizeStyle as ue, normalizeProps as re, mergeProps as E, createVNode as G, withModifiers as W, pushScopeId as ct, popScopeId as ft, guardReactiveProps as je, useSlots as pt, useAttrs as Gt, withKeys as Kt, toRef as Wt, onUnmounted as be, Comment as Ut, cloneVNode as Zt, onBeforeUnmount as Jt, nextTick as xt, useCssVars as ea, reactive as ta, vModelSelect as aa, Teleport as na } from "vue";
const ra = /* @__PURE__ */ D({
  __name: "DsfrBackToTop",
  props: {
    label: { default: "Haut de page" },
    position: { default: "right" }
  },
  setup(s) {
    return (e, t) => (r(), d("a", {
      class: C(["fr-link fr-icon-arrow-up-fill", `fr-link--icon-${e.position}`]),
      href: "#top"
    }, v(e.label), 3));
  }
}), la = "abcdefghijklmnopqrstuvwyz0123456789", Ke = la.repeat(10), sa = () => {
  const s = Math.floor(Math.random() * Ke.length);
  return Ke[s];
}, oa = (s) => Array.from({ length: s }).map(sa).join(""), j = (s = "", e = "") => (s ? `${s}-` : "") + oa(5) + (e ? `-${e}` : ""), Ec = (s, e) => Array.from({ length: s }).map((t, a) => e(void 0, a, void 0)), ia = "(prefers-color-scheme: dark)", Me = "vue-dsfr-scheme", Ie = "light", _e = "dark", ge = "system", We = "data-fr-theme", Pe = (s) => {
  const e = s ?? (localStorage.getItem(Me) || ge);
  return [Ie, _e, ge].includes(e) ? e : ge;
}, Ue = (s, e) => (s = Pe(s), s === ge ? e != null && e.matches ? _e : Ie : s), Hc = (s) => {
  if (typeof window > "u")
    return;
  const e = {
    scheme: localStorage.getItem(Me) || ge,
    dataThemeAttribute: We,
    ...s
  }, t = window.matchMedia && window.matchMedia(ia), a = B(Pe(e.scheme));
  localStorage.setItem(Me, a.value);
  const n = B(Ue(a.value, t)), i = B(a.value !== ge);
  Qt(() => {
    var h;
    (h = document.body.parentElement) == null || h.setAttribute(
      e.dataThemeAttribute || We,
      n.value
    );
  }), t == null || t.addEventListener("change", (h) => {
    i.value || (h.matches ? n.value = _e : n.value = Ie);
  }), !i.value && (t != null && t.matches) && (n.value = _e);
  const l = (h) => {
    if (a.value = Pe(h), localStorage.setItem(Me, a.value), [Ie, _e].includes(a.value)) {
      n.value = a.value, i.value = !0;
      return;
    }
    n.value = Ue(a.value, t), i.value = !1;
  }, c = document.documentElement, u = {
    subtree: !1,
    childList: !1,
    attributes: !0
  }, p = new MutationObserver((h) => {
    for (const f of h)
      if (f.type === "attributes" && f.attributeName === "data-fr-theme") {
        const _ = f.target.getAttribute(f.attributeName);
        _ !== a.value && l(_);
      }
  });
  return p.observe(c, u), window.addEventListener("unload", () => p.disconnect()), l(a.value), {
    setScheme: l,
    theme: g(() => n.value),
    scheme: g(() => a.value)
  };
}, ce = () => {
  const s = B(), e = B(!1), t = B(!1), a = () => {
    if (!s.value)
      return;
    s.value.style.setProperty("--collapser", "none");
    const l = s.value.offsetHeight;
    s.value.style.setProperty("--collapse", `${-l}px`), s.value.style.setProperty("--collapser", "");
  };
  return {
    collapse: s,
    collapsing: e,
    cssExpanded: t,
    doExpand: (l) => {
      s.value && (l === !0 && s.value.style.setProperty("--collapse-max-height", "none"), window.requestAnimationFrame(() => {
        e.value = !0, a(), window.requestAnimationFrame(() => {
          t.value = l;
        });
      }));
    },
    adjust: a,
    onTransitionEnd: (l) => {
      e.value = !1, s.value && l === !1 && s.value.style.removeProperty("--collapse-max-height");
    }
  };
}, Bc = (s = !0, e = 0) => {
  const t = B(s), a = B(e);
  function n(i) {
    t.value = a.value < i, a.value = i;
  }
  return { ascendant: t, selected: a, select: n };
}, da = { class: "fr-accordion" }, ua = ["aria-expanded", "aria-controls"], ca = ["id"], fa = /* @__PURE__ */ D({
  __name: "DsfrAccordion",
  props: {
    id: { default: () => j("accordion") },
    expandedId: { default: void 0 },
    title: { default: "Sans intitulé" },
    titleTag: { default: "h3" }
  },
  emits: ["expand"],
  setup(s, { emit: e }) {
    const t = s, a = e, {
      collapse: n,
      collapsing: i,
      cssExpanded: l,
      doExpand: c,
      onTransitionEnd: u
    } = ce(), p = g(() => t.expandedId === t.id);
    ne(() => {
      p.value && c(!0);
    }), te(p, (f, _) => {
      f !== _ && c(f);
    });
    const h = () => {
      a("expand", p.value ? void 0 : t.id);
    };
    return (f, _) => (r(), d("section", da, [
      (r(), L(J(f.titleTag), { class: "fr-accordion__title" }, {
        default: F(() => [
          o("button", {
            class: "fr-accordion__btn",
            "aria-expanded": p.value,
            "aria-controls": f.id,
            type: "button",
            onClick: _[0] || (_[0] = ($) => h())
          }, [
            I(f.$slots, "title", {}, () => [
              o("span", null, v(f.title), 1)
            ])
          ], 8, ua)
        ]),
        _: 3
      })),
      o("div", {
        id: f.id,
        ref_key: "collapse",
        ref: n,
        class: C(["fr-collapse", {
          "fr-collapse--expanded": N(l),
          // Need to use a separate data to add/remove the class after a RAF
          "fr-collapsing": N(i)
        }]),
        onTransitionend: _[1] || (_[1] = ($) => N(u)(p.value))
      }, [
        I(f.$slots, "default")
      ], 42, ca)
    ]));
  }
}), pa = /* @__PURE__ */ D({
  __name: "DsfrAccordionsGroup",
  setup(s) {
    const e = B(), t = (a) => {
      e.value = a;
    };
    return (a, n) => (r(), d("ul", {
      class: "fr-accordions-group",
      onExpand: n[0] || (n[0] = (i) => t(i))
    }, [
      I(a.$slots, "default", { expandedId: e.value })
    ], 32));
  }
}), ha = ["id"], va = { class: "alert-content" }, ma = { class: "fr-alert__description" }, ga = ["title", "aria-label"], ba = /* @__PURE__ */ D({
  __name: "DsfrAlert",
  props: {
    closed: { type: Boolean },
    closeable: { type: Boolean },
    id: { default: () => j("basic", "alert") },
    title: { default: "" },
    description: {},
    small: { type: Boolean },
    titleTag: { default: "h3" },
    type: { default: "info" },
    closeButtonLabel: { default: "Fermer" }
  },
  emits: ["close"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = () => a("close"), i = g(
      () => [
        `fr-alert--${t.type}`,
        {
          "fr-alert--sm": t.small
        }
      ]
    );
    return (l, c) => (r(), L(dt, { name: "slide-fade" }, {
      default: F(() => [
        l.closed ? m("", !0) : (r(), d("div", {
          key: 0,
          id: l.id,
          class: C(["fr-alert", i.value])
        }, [
          o("div", va, [
            l.small ? m("", !0) : (r(), L(J(l.titleTag), {
              key: 0,
              class: "fr-alert__title"
            }, {
              default: F(() => [
                z(v(l.title), 1)
              ]),
              _: 1
            })),
            o("p", ma, [
              I(l.$slots, "default", {}, () => [
                z(v(l.description), 1)
              ])
            ])
          ]),
          l.closeable ? (r(), d("button", {
            key: 0,
            class: "fr-btn fr-btn--close",
            title: l.closeButtonLabel,
            "aria-label": l.closeButtonLabel,
            onClick: n
          }, null, 8, ga)) : m("", !0)
        ], 10, ha))
      ]),
      _: 3
    }));
  }
}), ya = ["title"], ht = /* @__PURE__ */ D({
  __name: "DsfrBadge",
  props: {
    label: {},
    type: { default: "info" },
    noIcon: { type: Boolean },
    small: { type: Boolean },
    ellipsis: { type: Boolean }
  },
  setup(s) {
    return (e, t) => (r(), d("p", {
      class: C(["fr-badge", {
        [`fr-badge--${e.type}`]: e.type,
        "fr-badge--no-icon": e.noIcon,
        "fr-badge--sm": e.small
      }]),
      title: e.ellipsis ? e.label : void 0
    }, [
      o("span", {
        class: C(e.ellipsis ? "fr-ellipsis" : "")
      }, v(e.label), 3)
    ], 10, ya));
  }
}), ka = ["aria-label"], wa = ["aria-expanded", "aria-controls"], _a = ["id"], $a = { class: "fr-breadcrumb__list" }, Da = ["aria-current"], Ma = /* @__PURE__ */ D({
  __name: "DsfrBreadcrumb",
  props: {
    breadcrumbId: { default: () => j("breadcrumb") },
    links: { default: () => [{ text: "" }] },
    navigationLabel: { default: "vous êtes ici :" },
    showBreadcrumbLabel: { default: "Voir le fil d’Ariane" }
  },
  setup(s) {
    const {
      collapse: e,
      collapsing: t,
      cssExpanded: a,
      doExpand: n,
      onTransitionEnd: i
    } = ce(), l = B(!1);
    return te(l, (c, u) => {
      c !== u && n(c);
    }), (c, u) => {
      const p = se("RouterLink");
      return r(), d("nav", {
        role: "navigation",
        class: "fr-breadcrumb",
        "aria-label": c.navigationLabel
      }, [
        Oe(o("button", {
          class: "fr-breadcrumb__button",
          "aria-expanded": l.value,
          "aria-controls": c.breadcrumbId,
          onClick: u[0] || (u[0] = (h) => l.value = !l.value)
        }, v(c.showBreadcrumbLabel), 9, wa), [
          [ut, !l.value]
        ]),
        o("div", {
          id: c.breadcrumbId,
          ref_key: "collapse",
          ref: e,
          class: C(["fr-collapse", {
            "fr-collapse--expanded": N(a),
            // Need to use a separate data to add/remove the class after a RAF
            "fr-collapsing": N(t)
          }]),
          onTransitionend: u[1] || (u[1] = (h) => N(i)(l.value))
        }, [
          o("ol", $a, [
            (r(!0), d(R, null, X(c.links, (h, f) => (r(), d("li", {
              key: f,
              class: "fr-breadcrumb__item",
              "data-testid": "lis"
            }, [
              h.to ? (r(), L(p, {
                key: 0,
                class: "fr-breadcrumb__link",
                to: h.to,
                "aria-current": f === c.links.length - 1 ? "page" : void 0
              }, {
                default: F(() => [
                  z(v(h.text), 1)
                ]),
                _: 2
              }, 1032, ["to", "aria-current"])) : m("", !0),
              h.to ? m("", !0) : (r(), d("a", {
                key: 1,
                class: "fr-breadcrumb__link",
                "aria-current": f === c.links.length - 1 ? "page" : void 0
              }, v(h.text), 9, Da))
            ]))), 128))
          ])
        ], 42, _a)
      ], 8, ka);
    };
  }
}), Ia = ["title", "disabled", "aria-disabled"], La = { key: 1 }, Ca = /* @__PURE__ */ D({
  __name: "DsfrButton",
  props: {
    disabled: { type: Boolean },
    label: { default: void 0 },
    secondary: { type: Boolean },
    tertiary: { type: Boolean },
    iconRight: { type: Boolean },
    iconOnly: { type: Boolean },
    noOutline: { type: Boolean },
    size: { default: "md" },
    icon: { default: void 0 },
    onClick: { type: Function, default: () => {
    } }
  },
  setup(s, { expose: e }) {
    const t = s, a = g(() => ["sm", "small"].includes(t.size)), n = g(() => ["md", "medium"].includes(t.size)), i = g(() => ["lg", "large"].includes(t.size)), l = B(null);
    e({ focus: () => {
      var f;
      (f = l.value) == null || f.focus();
    } });
    const u = g(() => typeof t.icon == "string" && t.icon.startsWith("fr-icon-")), p = g(() => t.iconOnly ? 1.25 : 0.8325), h = g(
      () => typeof t.icon == "string" ? { scale: p.value, name: t.icon } : { scale: p.value, ...t.icon }
    );
    return (f, _) => (r(), d("button", {
      ref_key: "btn",
      ref: l,
      class: C(["fr-btn", {
        "fr-btn--secondary": f.secondary && !f.tertiary,
        "fr-btn--tertiary": f.tertiary && !f.secondary && !f.noOutline,
        "fr-btn--tertiary-no-outline": f.tertiary && !f.secondary && f.noOutline,
        "fr-btn--sm": a.value,
        "fr-btn--md": n.value,
        "fr-btn--lg": i.value,
        "fr-btn--icon-right": !f.iconOnly && u.value && f.iconRight,
        "fr-btn--icon-left": !f.iconOnly && u.value && !f.iconRight,
        "inline-flex": !u.value,
        reverse: f.iconRight && !u.value,
        "justify-center": !u.value && f.iconOnly,
        [f.icon]: u.value
      }]),
      title: f.iconOnly ? f.label : void 0,
      disabled: f.disabled,
      "aria-disabled": f.disabled,
      style: ue(!u.value && f.iconOnly ? { "padding-inline": "0.5rem" } : {}),
      onClick: _[0] || (_[0] = ($) => f.onClick ? f.onClick($) : () => {
      })
    }, [
      f.icon && !u.value ? (r(), L(N(le), re(E({ key: 0 }, h.value)), null, 16)) : m("", !0),
      f.iconOnly ? m("", !0) : (r(), d("span", La, [
        z(v(f.label) + " ", 1),
        I(f.$slots, "default", {}, void 0, !0)
      ]))
    ], 14, Ia));
  }
}), ae = (s, e) => {
  const t = s.__vccOpts || s;
  for (const [a, n] of e)
    t[a] = n;
  return t;
}, Ae = /* @__PURE__ */ ae(Ca, [["__scopeId", "data-v-d2e9ceaf"]]), Ee = /* @__PURE__ */ D({
  __name: "DsfrButtonGroup",
  props: {
    buttons: { default: () => [] },
    reverse: { type: Boolean },
    equisized: { type: Boolean },
    iconRight: { type: Boolean },
    align: { default: void 0 },
    inlineLayoutWhen: { type: [String, Boolean], default: "never" },
    size: { default: "md" }
  },
  setup(s) {
    const e = s, t = B(null), a = g(() => ["sm", "small"].includes(e.size)), n = g(() => ["md", "medium"].includes(e.size)), i = g(() => ["lg", "large"].includes(e.size)), l = g(() => ["always", "", !0].includes(e.inlineLayoutWhen)), c = g(() => ["sm", "small"].includes(e.inlineLayoutWhen)), u = g(() => ["md", "medium"].includes(e.inlineLayoutWhen)), p = g(() => ["lg", "large"].includes(e.inlineLayoutWhen)), h = g(() => e.align === "center"), f = g(() => e.align === "right"), _ = B("auto"), $ = g(() => `--equisized-width: ${_.value};`), y = async () => {
      var b;
      let V = 0;
      await new Promise((M) => setTimeout(M, 100)), (b = t.value) == null || b.querySelectorAll(".fr-btn").forEach((M) => {
        const H = M, S = H.offsetWidth, A = window.getComputedStyle(H), q = +A.marginLeft.replace("px", ""), P = +A.marginRight.replace("px", "");
        H.style.width = "var(--equisized-width)";
        const Z = S + q + P;
        Z > V && (V = Z);
      }), _.value = `${V}px`;
    };
    return ne(async () => {
      !t.value || !e.equisized || await y();
    }), (V, b) => (r(), d("ul", {
      ref_key: "buttonsEl",
      ref: t,
      style: ue($.value),
      class: C(["fr-btns-group", {
        "fr-btns-group--equisized": V.equisized,
        "fr-btns-group--sm": a.value,
        "fr-btns-group--md": n.value,
        "fr-btns-group--lg": i.value,
        "fr-btns-group--inline-sm": l.value || c.value,
        "fr-btns-group--inline-md": l.value || u.value,
        "fr-btns-group--inline-lg": l.value || p.value,
        "fr-btns-group--center": h.value,
        "fr-btns-group--right": f.value,
        "fr-btns-group--icon-right": V.iconRight,
        "fr-btns-group--inline-reverse": V.reverse
      }]),
      "data-testid": "fr-btns"
    }, [
      (r(!0), d(R, null, X(V.buttons, ({ onClick: M, ...H }, S) => (r(), d("li", { key: S }, [
        G(Ae, E({ ref_for: !0 }, H, { onClick: M }), null, 16, ["onClick"])
      ]))), 128)),
      I(V.$slots, "default")
    ], 6));
  }
}), za = { class: "fr-callout__text" }, Sa = /* @__PURE__ */ D({
  __name: "DsfrCallout",
  props: {
    title: {},
    content: {},
    titleTag: { default: "h3" },
    button: { default: () => {
    } },
    icon: { default: void 0 }
  },
  setup(s) {
    const e = s, t = g(() => typeof e.icon == "string" && e.icon.startsWith("fr-icon-")), a = g(() => t.value ? void 0 : typeof e.icon == "string" ? { name: e.icon } : { ...e.icon ?? {} });
    return (n, i) => {
      const l = se("VIcon");
      return r(), d("div", {
        class: C(["fr-callout", { [String(n.icon)]: t.value }])
      }, [
        n.icon && a.value ? (r(), L(l, re(E({ key: 0 }, a.value)), null, 16)) : m("", !0),
        n.title ? (r(), L(J(n.titleTag), {
          key: 1,
          class: "fr-callout__title"
        }, {
          default: F(() => [
            z(v(n.title), 1)
          ]),
          _: 1
        })) : m("", !0),
        o("p", za, v(n.content), 1),
        n.button ? (r(), L(Ae, re(E({ key: 2 }, n.button)), null, 16)) : m("", !0),
        I(n.$slots, "default", {}, void 0, !0)
      ], 2);
    };
  }
}), Ta = /* @__PURE__ */ ae(Sa, [["__scopeId", "data-v-8d5c8ed4"]]), Ze = /* @__PURE__ */ D({
  __name: "DsfrCardDetail",
  props: {
    icon: {}
  },
  setup(s) {
    const e = s, t = g(() => e.icon && typeof e.icon == "string" && e.icon.startsWith("fr-") ? e.icon : ""), a = g(() => t.value ? void 0 : typeof e.icon == "string" ? { name: e.icon } : e.icon);
    return (n, i) => {
      const l = se("VIcon");
      return r(), d("p", {
        class: C(["fr-card__detail", t.value ? { [String(n.icon)]: t.value } : {}])
      }, [
        n.icon && !t.value ? (r(), L(l, re(E({ key: 0 }, a.value)), null, 16)) : m("", !0),
        I(n.$slots, "default")
      ], 2);
    };
  }
}), Aa = { class: "fr-card__body" }, Ea = { class: "fr-card__content" }, Ha = ["href"], Ba = { class: "fr-card__desc" }, Va = {
  key: 0,
  class: "fr-card__start"
}, Ra = {
  key: 1,
  class: "fr-card__end"
}, Pa = {
  key: 0,
  class: "fr-card__footer"
}, Fa = {
  key: 1,
  class: "fr-links-group"
}, Na = ["href"], Xa = {
  key: 0,
  class: "fr-card__header"
}, Ya = {
  key: 0,
  class: "fr-card__img"
}, Oa = ["src", "alt"], ja = {
  key: 1,
  class: "fr-badges-group",
  "data-testid": "card-badges"
}, qa = /* @__PURE__ */ D({
  __name: "DsfrCard",
  props: {
    imgSrc: { default: void 0 },
    link: { default: void 0 },
    title: {},
    description: {},
    size: { default: "md" },
    detail: { default: void 0 },
    detailIcon: { default: void 0 },
    endDetail: { default: void 0 },
    endDetailIcon: { default: void 0 },
    altImg: { default: "" },
    titleTag: { default: "h3" },
    badges: { default: () => [] },
    buttons: { default: () => [] },
    linksGroup: { default: () => [] },
    noArrow: { type: Boolean },
    horizontal: { type: Boolean },
    download: { type: Boolean }
  },
  setup(s, { expose: e }) {
    const t = s, a = g(() => ["sm", "small"].includes(t.size)), n = g(() => ["lg", "large"].includes(t.size)), i = g(() => ["sm", "small"].includes(t.imgRatio)), l = g(() => ["lg", "large"].includes(t.imgRatio)), c = g(() => typeof t.link == "string" && t.link.startsWith("http")), u = B(null);
    return e({ goToTargetLink: () => {
      var h;
      ((h = u.value) == null ? void 0 : h.querySelector(".fr-card__link")).click();
    } }), (h, f) => {
      const _ = se("RouterLink");
      return r(), d("div", {
        class: C(["fr-card", {
          "fr-card--horizontal": h.horizontal,
          "fr-enlarge-link": !h.noArrow,
          "fr-card--sm": a.value,
          "fr-card--lg": n.value,
          "fr-card--horizontal-tier": i.value,
          "fr-card--horizontal-half": l.value,
          "fr-card--download": h.download
        }]),
        "data-testid": "fr-card"
      }, [
        o("div", Aa, [
          o("div", Ea, [
            (r(), L(J(h.titleTag), { class: "fr-card__title" }, {
              default: F(() => [
                c.value ? (r(), d("a", {
                  key: 0,
                  href: h.link,
                  "data-testid": "card-link",
                  class: "fr-card__link"
                }, v(h.title), 9, Ha)) : h.link ? (r(), L(_, {
                  key: 1,
                  to: h.link,
                  class: "fr-card__link",
                  "data-testid": "card-link",
                  onClick: f[0] || (f[0] = ($) => $.stopPropagation())
                }, {
                  default: F(() => [
                    z(v(h.title), 1)
                  ]),
                  _: 1
                }, 8, ["to"])) : (r(), d(R, { key: 2 }, [
                  z(v(h.title), 1)
                ], 64))
              ]),
              _: 1
            })),
            o("p", Ba, v(h.description), 1),
            h.$slots["start-details"] || h.detail ? (r(), d("div", Va, [
              I(h.$slots, "start-details"),
              h.detail ? (r(), L(Ze, {
                key: 0,
                icon: h.detailIcon
              }, {
                default: F(() => [
                  z(v(h.detail), 1)
                ]),
                _: 1
              }, 8, ["icon"])) : m("", !0)
            ])) : m("", !0),
            h.$slots["end-details"] || h.endDetail ? (r(), d("div", Ra, [
              I(h.$slots, "end-details"),
              h.endDetail ? (r(), L(Ze, {
                key: 0,
                icon: h.endDetailIcon
              }, {
                default: F(() => [
                  z(v(h.endDetail), 1)
                ]),
                _: 1
              }, 8, ["icon"])) : m("", !0)
            ])) : m("", !0)
          ]),
          h.buttons.length || h.linksGroup.length ? (r(), d("div", Pa, [
            h.buttons.length ? (r(), L(Ee, {
              key: 0,
              buttons: h.buttons,
              "inline-layout-when": "always",
              size: h.size,
              reverse: ""
            }, null, 8, ["buttons", "size"])) : m("", !0),
            h.linksGroup.length ? (r(), d("ul", Fa, [
              (r(!0), d(R, null, X(h.linksGroup, ($, y) => (r(), d("li", {
                key: `card-link-${y}`
              }, [
                $.to ? (r(), L(_, {
                  key: 0,
                  to: $.to
                }, {
                  default: F(() => [
                    z(v($.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])) : (r(), d("a", {
                  key: 1,
                  href: $.link || $.href,
                  class: C(["fr-link fr-icon-arrow-right-line fr-link--icon-right", {
                    "fr-link--sm": a.value,
                    "fr-link--lg": n.value
                  }])
                }, v($.label), 11, Na))
              ]))), 128))
            ])) : m("", !0)
          ])) : m("", !0)
        ]),
        h.imgSrc || h.badges.length ? (r(), d("div", Xa, [
          h.imgSrc ? (r(), d("div", Ya, [
            o("img", {
              src: h.imgSrc,
              class: "fr-responsive-img",
              alt: h.altImg,
              "data-testid": "card-img"
            }, null, 8, Oa)
          ])) : m("", !0),
          h.badges.length ? (r(), d("ul", ja, [
            (r(!0), d(R, null, X(h.badges, ($, y) => (r(), d("li", { key: y }, [
              G(ht, E({ ref_for: !0 }, $), null, 16)
            ]))), 128))
          ])) : m("", !0)
        ])) : m("", !0)
      ], 2);
    };
  }
}), Qa = ["id", "name", "checked", "data-testid", "data-test"], Ga = ["for"], Ka = {
  key: 0,
  class: "required"
}, Wa = {
  key: 0,
  class: "fr-hint-text"
}, Ua = {
  key: 0,
  class: "fr-messages-group",
  "aria-live": "assertive",
  role: "alert"
}, vt = /* @__PURE__ */ D({
  inheritAttrs: !1,
  __name: "DsfrCheckbox",
  props: {
    id: { default: () => j("basic", "checkbox") },
    name: {},
    required: { type: Boolean },
    modelValue: { type: Boolean },
    small: { type: Boolean },
    inline: { type: Boolean },
    label: { default: "" },
    errorMessage: { default: "" },
    validMessage: { default: "" },
    hint: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = g(() => t.errorMessage || t.validMessage), i = g(() => t.errorMessage ? "fr-error-text" : "fr-valid-text"), l = (c) => {
      a("update:modelValue", c.target.checked);
    };
    return (c, u) => (r(), d("div", {
      class: C(["fr-fieldset__element", { "fr-fieldset__element--inline": c.inline }])
    }, [
      o("div", {
        class: C(["fr-checkbox-group", {
          "fr-checkbox-group--error": c.errorMessage,
          "fr-checkbox-group--valid": !c.errorMessage && c.validMessage,
          "fr-checkbox-group--sm": c.small
        }])
      }, [
        o("input", E({
          id: c.id,
          name: c.name,
          type: "checkbox",
          checked: c.modelValue
        }, c.$attrs, {
          "data-testid": `input-checkbox-${c.id}`,
          "data-test": `input-checkbox-${c.id}`,
          onChange: u[0] || (u[0] = (p) => l(p))
        }), null, 16, Qa),
        o("label", {
          for: c.id,
          class: "fr-label"
        }, [
          I(c.$slots, "label", {}, () => [
            z(v(c.label) + " ", 1),
            I(c.$slots, "required-tip", {}, () => [
              c.required ? (r(), d("span", Ka, " *")) : m("", !0)
            ])
          ]),
          c.hint ? (r(), d("span", Wa, v(c.hint), 1)) : m("", !0)
        ], 8, Ga),
        n.value ? (r(), d("div", Ua, [
          o("p", {
            class: C(["fr-message--info flex items-center", i.value])
          }, v(n.value), 3)
        ])) : m("", !0)
      ], 2)
    ], 2));
  }
}), Za = { class: "fr-form-group" }, Ja = ["disabled", "aria-labelledby", "aria-invalid", "role"], xa = ["id"], en = {
  key: 0,
  class: "required"
}, tn = ["id"], an = /* @__PURE__ */ D({
  __name: "DsfrCheckboxSet",
  props: {
    titleId: { default: () => j("checkbox", "group") },
    disabled: { type: Boolean },
    inline: { type: Boolean },
    required: { type: Boolean },
    small: { type: Boolean },
    errorMessage: { default: "" },
    validMessage: { default: "" },
    legend: { default: "" },
    options: { default: () => [] },
    modelValue: { default: () => [] },
    ariaInvalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = g(() => t.errorMessage || t.validMessage), i = g(() => t.errorMessage ? "fr-error-text" : "fr-valid-text"), l = ({ name: u, checked: p }) => {
      const h = p ? [...t.modelValue, u] : t.modelValue.filter((f) => f !== u);
      a("update:modelValue", h);
    }, c = g(() => n.value ? `${t.titleId} messages-${t.titleId}` : t.titleId);
    return (u, p) => (r(), d("div", Za, [
      o("fieldset", {
        class: C(["fr-fieldset", {
          "fr-fieldset--error": u.errorMessage,
          "fr-fieldset--valid": !u.errorMessage && u.validMessage
        }]),
        disabled: u.disabled,
        "aria-labelledby": c.value,
        "aria-invalid": u.ariaInvalid,
        role: u.errorMessage || u.validMessage ? "group" : void 0
      }, [
        o("legend", {
          id: u.titleId,
          class: "fr-fieldset__legend fr-text--regular"
        }, [
          I(u.$slots, "legend", {}, () => [
            z(v(u.legend) + " ", 1),
            I(u.$slots, "required-tip", {}, () => [
              u.required ? (r(), d("span", en, " *")) : m("", !0)
            ])
          ])
        ], 8, xa),
        I(u.$slots, "default", {}, () => [
          (r(!0), d(R, null, X(u.options, (h) => (r(), L(vt, {
            id: h.id,
            key: h.id || h.name,
            name: h.name,
            label: h.label,
            disabled: h.disabled,
            "aria-disabled": h.disabled,
            small: u.small,
            inline: u.inline,
            "model-value": u.modelValue.includes(h.name),
            hint: h.hint,
            "onUpdate:modelValue": (f) => l({ name: h.name, checked: f })
          }, null, 8, ["id", "name", "label", "disabled", "aria-disabled", "small", "inline", "model-value", "hint", "onUpdate:modelValue"]))), 128))
        ]),
        n.value ? (r(), d("div", {
          key: 0,
          id: `messages-${u.titleId}`,
          class: "fr-messages-group",
          role: "alert"
        }, [
          o("p", {
            class: C(["fr-message--info flex items-center", i.value])
          }, [
            o("span", null, v(n.value), 1)
          ], 2)
        ], 8, tn)) : m("", !0)
      ], 10, Ja)
    ]));
  }
}), nn = { class: "fr-consent-banner__content" }, rn = { class: "fr-text--sm" }, ln = { class: "fr-consent-banner__buttons fr-btns-group fr-btns-group--right fr-btns-group--inline-reverse fr-btns-group--inline-sm" }, sn = /* @__PURE__ */ D({
  __name: "DsfrConsent",
  props: {
    url: { default: "" }
  },
  emits: ["acceptAll", "refuseAll", "customize"],
  setup(s) {
    const e = s, t = g(() => typeof e.url == "string" && e.url.startsWith("http")), a = g(() => e.url ? t.value ? "a" : "RouterLink" : "a"), n = g(() => ({ [t.value ? "href" : "to"]: e.url }));
    return (i, l) => (r(), d(R, null, [
      o("div", nn, [
        o("p", rn, [
          I(i.$slots, "default", {}, () => [
            z(" Bienvenue ! Nous utilisons des cookies pour améliorer votre expérience et les services disponibles sur ce site. Pour en savoir plus, visitez la page "),
            (r(), L(J(a.value), E(n.value, { "data-testid": "link" }), {
              default: F(() => [
                z(" Données personnelles et cookies ")
              ]),
              _: 1
            }, 16)),
            z(". Vous pouvez, à tout moment, avoir le contrôle sur les cookies que vous souhaitez activer. ")
          ])
        ])
      ]),
      o("ul", ln, [
        o("li", null, [
          o("button", {
            class: "fr-btn",
            title: "Autoriser tous les cookies",
            onClick: l[0] || (l[0] = W((c) => i.$emit("acceptAll"), ["stop"]))
          }, " Tout accepter ")
        ]),
        o("li", null, [
          o("button", {
            class: "fr-btn",
            title: "Refuser tous les cookies",
            onClick: l[1] || (l[1] = W((c) => i.$emit("refuseAll"), ["stop"]))
          }, " Tout refuser ")
        ]),
        o("li", null, [
          o("button", {
            class: "fr-btn fr-btn--secondary",
            "data-fr-opened": "false",
            "aria-controls": "fr-consent-modal",
            title: "Personnaliser les cookies",
            onClick: l[2] || (l[2] = W((c) => i.$emit("customize"), ["stop"]))
          }, " Personnaliser ")
        ])
      ])
    ], 64));
  }
}), on = "data:image/png;base64,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", dn = (s) => (ct("data-v-0f6cf5b4"), s = s(), ft(), s), un = { class: "fr-container flex" }, cn = { class: "half" }, fn = { class: "fr-h1" }, pn = { class: "flex fr-my-md-3w" }, hn = { class: "fr-h6" }, vn = /* @__PURE__ */ dn(() => /* @__PURE__ */ o("div", { class: "half self-center text-center" }, [
  /* @__PURE__ */ o("img", {
    class: "error-img",
    src: on
  })
], -1)), mn = /* @__PURE__ */ D({
  __name: "DsfrErrorPage",
  props: {
    title: { default: "Page non trouvée" },
    subtitle: { default: "Erreur 404" },
    description: { default: "La page que vous cherchez est introuvable. Excusez-nous pour la gêne occasionnée." },
    help: { default: "Si vous avez tapé l'adresse web dans le navigateur, vérifiez qu'elle est correcte. La page n'est peut être plus disponible." },
    buttons: { default: void 0 }
  },
  setup(s) {
    return (e, t) => {
      var a;
      return r(), d("div", un, [
        o("div", cn, [
          o("h1", fn, v(e.title), 1),
          o("span", pn, v(e.subtitle), 1),
          o("p", hn, v(e.description), 1),
          o("p", null, v(e.help), 1),
          (a = e.buttons) != null && a.length ? (r(), L(Ee, {
            key: 0,
            buttons: e.buttons,
            "inline-layout-when": "always"
          }, null, 8, ["buttons"])) : m("", !0),
          I(e.$slots, "default", {}, void 0, !0)
        ]),
        vn
      ]);
    };
  }
}), gn = /* @__PURE__ */ ae(mn, [["__scopeId", "data-v-0f6cf5b4"]]), bn = { class: "fr-fieldset" }, yn = ["id"], kn = {
  key: 1,
  class: "fr-fieldset__element"
}, wn = { class: "fr-fieldset__element" }, _n = /* @__PURE__ */ D({
  __name: "DsfrFieldset",
  props: {
    legend: { default: "" },
    legendClass: { default: "" },
    legendId: { default: "" },
    hint: { default: "" },
    hintClass: { default: "" }
  },
  setup(s) {
    return (e, t) => {
      var a, n, i, l;
      return r(), d("fieldset", bn, [
        e.legend || (n = (a = e.$slots).legend) != null && n.call(a).length ? (r(), d("legend", {
          key: 0,
          id: e.legendId,
          class: C(["fr-fieldset__legend", e.legendClass])
        }, [
          z(v(e.legend) + " ", 1),
          I(e.$slots, "legend")
        ], 10, yn)) : m("", !0),
        e.hint || (l = (i = e.$slots).hint) != null && l.call(i).length ? (r(), d("div", kn, [
          o("span", {
            class: C(["fr-hint-text", e.hintClass])
          }, [
            z(v(e.hint) + " ", 1),
            I(e.$slots, "hint")
          ], 2)
        ])) : m("", !0),
        o("div", wn, [
          I(e.$slots, "default")
        ])
      ]);
    };
  }
}), $n = ["href", "download"], Dn = { class: "fr-link__detail" }, mt = /* @__PURE__ */ D({
  __name: "DsfrFileDownload",
  props: {
    title: { default: "Télécharger le document" },
    format: { default: "JPEG" },
    size: { default: "250 Ko" },
    href: { default: "#" },
    download: { default: "" }
  },
  setup(s) {
    return (e, t) => (r(), d("a", {
      href: e.href,
      download: e.download,
      class: "fr-link fr-link--download"
    }, [
      z(v(e.title) + " ", 1),
      o("span", Dn, v(e.format) + " – " + v(e.size), 1)
    ], 8, $n));
  }
}), Mn = { class: "fr-downloads-group fr-downloads-group--bordered" }, In = {
  key: 0,
  class: "fr-downloads-group__title"
}, Ln = /* @__PURE__ */ D({
  __name: "DsfrFileDownloadList",
  props: {
    files: { default: () => [] },
    title: { default: "" }
  },
  setup(s) {
    return (e, t) => (r(), d("div", Mn, [
      e.title ? (r(), d("h4", In, v(e.title), 1)) : m("", !0),
      o("ul", null, [
        (r(!0), d(R, null, X(e.files, (a, n) => (r(), d("li", { key: n }, [
          G(mt, {
            title: a.title,
            format: a.format,
            size: a.size,
            href: a.href,
            download: a.download
          }, null, 8, ["title", "format", "size", "href", "download"])
        ]))), 128))
      ])
    ]));
  }
}), Cn = ["for"], zn = {
  key: 0,
  class: "required"
}, Sn = {
  key: 1,
  class: "fr-hint-text"
}, Tn = ["id", "aria-describedby", "value", "disabled", "aria-disabled", "accept"], An = {
  key: 0,
  class: "fr-messages-group",
  role: "alert"
}, En = ["id"], Hn = /* @__PURE__ */ D({
  inheritAttrs: !1,
  __name: "DsfrFileUpload",
  props: {
    id: { default: () => j("file-upload") },
    label: { default: "Ajouter un fichier" },
    accept: { default: void 0 },
    hint: { default: "" },
    error: { default: "" },
    validMessage: { default: "" },
    disabled: { type: Boolean },
    modelValue: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = (l) => {
      var c, u;
      a("update:modelValue", (c = l.target) == null ? void 0 : c.value), a("change", (u = l.target) == null ? void 0 : u.files);
    }, i = g(() => Array.isArray(t.accept) ? t.accept.join(",") : t.accept);
    return (l, c) => (r(), d("div", {
      class: C(["fr-upload-group", {
        "fr-upload-group--error": l.error,
        "fr-upload-group--valid": l.validMessage,
        "fr-upload-group--disabled": l.disabled
      }])
    }, [
      o("label", {
        class: "fr-label",
        for: l.id
      }, [
        z(v(l.label) + " ", 1),
        "required" in l.$attrs && l.$attrs.required !== !1 ? (r(), d("span", zn, " *")) : m("", !0),
        l.hint ? (r(), d("span", Sn, v(l.hint), 1)) : m("", !0)
      ], 8, Cn),
      o("input", E({
        id: l.id,
        class: "fr-upload",
        type: "file",
        "aria-describedby": l.error || l.validMessage ? `${l.id}-desc` : void 0
      }, l.$attrs, {
        value: l.modelValue,
        disabled: l.disabled,
        "aria-disabled": l.disabled,
        accept: i.value,
        onChange: c[0] || (c[0] = (u) => n(u))
      }), null, 16, Tn),
      l.error || l.validMessage ? (r(), d("div", An, [
        l.error ? (r(), d("p", {
          key: 0,
          id: `${l.id}-desc`,
          class: "fr-error-text fr-mt-3v"
        }, v(l.error ?? l.validMessage), 9, En)) : m("", !0)
      ])) : m("", !0)
    ], 2));
  }
}), Bn = { class: "fr-follow__social" }, Vn = /* @__PURE__ */ o("br", null, null, -1), Rn = {
  key: 0,
  class: "fr-btns-group fr-btns-group--lg"
}, Pn = ["title", "href"], gt = /* @__PURE__ */ D({
  __name: "DsfrSocialNetworks",
  props: {
    networks: {},
    titleTag: { default: "h3" }
  },
  setup(s) {
    return (e, t) => (r(), d("div", Bn, [
      (r(), L(J(e.titleTag), { class: "fr-h5 fr-mb-3v fr-mb-3v" }, {
        default: F(() => [
          z(" Suivez-nous "),
          Vn,
          z(" sur les réseaux sociaux ")
        ]),
        _: 1
      })),
      e.networks.length ? (r(), d("ul", Rn, [
        (r(!0), d(R, null, X(e.networks, (a, n) => (r(), d("li", { key: n }, [
          o("a", {
            class: C(["fr-btn", `fr-btn--${a.type}`]),
            title: a.name,
            href: a.href,
            target: "_blank",
            rel: "noopener noreferrer"
          }, v(a.name), 11, Pn)
        ]))), 128))
      ])) : m("", !0)
    ]));
  }
}), Fn = { class: "fr-follow__newsletter" }, Nn = { class: "fr-h5 fr-follow__title" }, Xn = { class: "fr-text--sm fr-follow__desc" }, Yn = { key: 0 }, On = ["title"], jn = { key: 1 }, qn = { action: "" }, Qn = {
  class: "fr-label",
  for: "newsletter-email"
}, Gn = { class: "fr-input-wrap fr-input-wrap--addon" }, Kn = ["title", "placeholder", "value"], Wn = ["title"], Un = {
  key: 0,
  class: "fr-messages-group",
  role: "alert"
}, Zn = {
  id: "newsletter-email-desc-error",
  class: "fr-error-text"
}, Jn = {
  id: "fr-newsletter-hint-text",
  class: "fr-hint-text"
}, bt = /* @__PURE__ */ D({
  __name: "DsfrNewsLetter",
  props: {
    title: { default: "Abonnez-vous à notre lettre d’information" },
    description: { default: "" },
    email: { default: "" },
    error: { default: "" },
    labelEmail: { default: "Votre adresse électronique (ex. : prenom.nom@example.com)" },
    placeholder: { default: "prenom.nom@example.com" },
    hintText: { default: "" },
    inputTitle: { default: "Adresse courriel" },
    buttonText: { default: "S’abonner" },
    buttonTitle: { default: "S‘abonner à notre lettre d’information" },
    buttonAction: { type: Function, default: () => {
    } },
    onlyCallout: { type: Boolean, default: !1 }
  },
  emits: ["update:email"],
  setup(s, { emit: e }) {
    const t = e, a = (n) => t("update:email", n.target.value);
    return (n, i) => (r(), d("div", Fn, [
      o("div", null, [
        o("h3", Nn, v(n.title), 1),
        o("p", Xn, v(n.description), 1)
      ]),
      n.onlyCallout ? (r(), d("div", Yn, [
        o("button", {
          class: "fr-btn",
          title: n.buttonTitle,
          onClick: i[0] || (i[0] = (l) => n.buttonAction ? n.buttonAction(l) : () => {
          })
        }, v(n.buttonText), 9, On)
      ])) : (r(), d("div", jn, [
        o("form", qn, [
          o("label", Qn, v(n.labelEmail), 1),
          o("div", Gn, [
            o("input", {
              id: "newsletter-email",
              class: "fr-input",
              "aria-describedby": "fr-newsletter-hint-text",
              title: n.inputTitle || n.labelEmail,
              placeholder: n.placeholder || n.labelEmail,
              type: "email",
              name: "newsletter-email",
              value: n.email,
              autocomplete: "email",
              onInput: i[1] || (i[1] = (l) => a(l))
            }, null, 40, Kn),
            o("button", {
              id: "newsletter-button",
              class: "fr-btn",
              title: n.buttonTitle,
              type: "submit"
            }, v(n.buttonText), 9, Wn)
          ]),
          n.error ? (r(), d("div", Un, [
            o("p", Zn, v(n.error), 1)
          ])) : m("", !0),
          o("p", Jn, v(n.hintText), 1)
        ])
      ]))
    ]));
  }
}), xn = { class: "fr-follow" }, er = { class: "fr-container" }, tr = { class: "fr-grid-row" }, ar = /* @__PURE__ */ D({
  __name: "DsfrFollow",
  props: {
    newsletterData: { default: () => {
    } },
    networks: { default: () => [] }
  },
  setup(s) {
    const e = s, t = g(() => e.networks && e.networks.length), a = g(() => typeof e.newsletterData == "object");
    return (n, i) => (r(), d("div", xn, [
      o("div", er, [
        o("div", tr, [
          I(n.$slots, "default", {}, () => [
            n.newsletterData ? (r(), d("div", {
              key: 0,
              class: C(["fr-col-12", { "fr-col-md-8": t.value }])
            }, [
              G(bt, re(je(n.newsletterData)), null, 16)
            ], 2)) : m("", !0),
            t.value ? (r(), d("div", {
              key: 1,
              class: C(["fr-col-12", { "fr-col-md-4": a.value }])
            }, [
              G(gt, { networks: n.networks }, null, 8, ["networks"])
            ], 2)) : m("", !0)
          ])
        ])
      ])
    ]));
  }
}), nr = ["innerHTML"], Le = /* @__PURE__ */ D({
  __name: "DsfrLogo",
  props: {
    small: { type: Boolean },
    large: { type: Boolean },
    logoText: { default: () => "Gouvernement" }
  },
  setup(s) {
    const e = s, t = g(() => Array.isArray(e.logoText) ? e.logoText.join("<br>") : e.logoText);
    return (a, n) => (r(), d("p", {
      class: C(["fr-logo", {
        "fr-logo--sm": a.small && !a.large,
        "fr-logo--lg": a.large && !a.small
      }]),
      innerHTML: t.value
    }, null, 10, nr));
  }
}), rr = { class: "fr-footer__partners" }, lr = {
  key: 0,
  class: "fr-footer__partners-title"
}, sr = { class: "fr-footer__partners-logos" }, or = {
  key: 0,
  class: "fr-footer__partners-main"
}, ir = ["href"], dr = ["src", "alt"], ur = { class: "fr-footer__partners-sub" }, cr = ["href"], fr = ["src", "alt"], yt = /* @__PURE__ */ D({
  __name: "DsfrFooterPartners",
  props: {
    mainPartner: { default: void 0 },
    subPartners: { default: () => [] },
    title: { default: "" }
  },
  setup(s) {
    return (e, t) => (r(), d("div", rr, [
      e.title ? (r(), d("h4", lr, v(e.title), 1)) : m("", !0),
      o("div", sr, [
        e.mainPartner ? (r(), d("div", or, [
          o("a", {
            class: "fr-footer__partners-link",
            href: e.mainPartner.href,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            o("img", {
              class: "fr-footer__logo",
              src: e.mainPartner.logo,
              alt: e.mainPartner.name
            }, null, 8, dr)
          ], 8, ir)
        ])) : m("", !0),
        o("div", ur, [
          o("ul", null, [
            (r(!0), d(R, null, X(e.subPartners, (a, n) => (r(), d("li", { key: n }, [
              o("a", {
                class: "fr-footer__partners-link",
                href: a.href,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                o("img", {
                  class: "fr-footer__logo",
                  src: a.logo,
                  alt: a.name
                }, null, 8, fr)
              ], 8, cr)
            ]))), 128))
          ])
        ])
      ])
    ]));
  }
}), Je = 1, pr = /* @__PURE__ */ D({
  __name: "DsfrFooterLink",
  props: {
    button: { type: Boolean },
    icon: { default: void 0 },
    iconAttrs: { default: () => ({}) },
    iconRight: { type: Boolean },
    label: { default: "" },
    target: { default: void 0 },
    onClick: { type: Function, default: () => {
    } },
    to: { default: void 0 },
    href: { default: void 0 }
  },
  setup(s) {
    const e = s, t = g(() => {
      var h;
      return (h = e.href) == null ? void 0 : h.startsWith("http");
    }), a = g(() => {
      var h;
      return (h = e.href) == null ? void 0 : h.startsWith("mailto");
    }), n = g(() => e.button ? "button" : t.value || a.value ? "a" : "RouterLink"), i = g(() => {
      if (!(!t.value && !a.value))
        return e.href;
    }), l = g(() => {
      if (!(t.value || a.value))
        return e.to;
    }), c = g(() => l.value ? { to: l.value } : { href: i.value }), u = g(() => typeof e.icon == "string" && e.icon.startsWith("fr-icon-")), p = g(
      () => typeof e.icon == "string" ? { name: e.icon, scale: Je, ...e.iconAttrs ?? {} } : { scale: Je, ...e.icon ?? {}, ...e.iconAttrs ?? {} }
    );
    return (h, f) => (r(), L(J(n.value), E({
      class: ["fr-footer__bottom-link", {
        "fr-btn--icon-right": u.value && h.iconRight,
        "fr-btn--icon-left": u.value && !h.iconRight,
        [String(h.icon)]: u.value
      }]
    }, c.value, {
      target: h.target,
      onClick: W(h.onClick, ["stop"])
    }), {
      default: F(() => {
        var _, $;
        return [
          !u.value && (h.icon || (_ = h.iconAttrs) != null && _.name) && !h.iconRight ? (r(), L(N(le), E({
            key: 0,
            class: "fr-mr-1w"
          }, p.value), null, 16)) : m("", !0),
          z(" " + v(h.label) + " ", 1),
          !u.value && (h.icon || ($ = h.iconAttrs) != null && $.name) && h.iconRight ? (r(), L(N(le), E({
            key: 1,
            class: "fr-ml-1w"
          }, p.value), null, 16)) : m("", !0)
        ];
      }),
      _: 1
    }, 16, ["class", "target", "onClick"]));
  }
}), hr = {
  id: "footer",
  class: "fr-footer",
  role: "contentinfo"
}, vr = {
  key: 0,
  class: "fr-footer__top"
}, mr = { class: "fr-container" }, gr = { class: "fr-grid-row fr-grid-row--start fr-grid-row--gutters" }, br = { class: "fr-container" }, yr = { class: "fr-footer__body" }, kr = {
  key: 0,
  class: "fr-footer__brand fr-enlarge-link"
}, wr = ["href"], _r = ["src", "alt"], $r = ["src", "alt"], Dr = {
  key: 1,
  class: "fr-footer__brand fr-enlarge-link"
}, Mr = { class: "fr-footer__content" }, Ir = { class: "fr-footer__content-desc" }, Lr = { class: "fr-footer__content-list" }, Cr = ["href"], zr = { class: "fr-footer__bottom" }, Sr = { class: "fr-footer__bottom-list" }, Tr = {
  key: 0,
  class: "fr-footer__bottom-copy"
}, Ar = /* @__PURE__ */ D({
  __name: "DsfrFooter",
  props: {
    a11yCompliance: { default: "non conforme" },
    a11yComplianceLink: { default: "/a11y" },
    legalLink: { default: "/mentions-legales" },
    homeLink: { default: "/" },
    homeTitle: { default: "Retour à l’accueil" },
    partners: { default: () => {
    } },
    personalDataLink: { default: "/donnees-personnelles" },
    cookiesLink: { default: "/cookies" },
    logoText: { default: () => ["République", "Française"] },
    descText: { default: void 0 },
    beforeMandatoryLinks: { default: () => [] },
    afterMandatoryLinks: { default: () => [] },
    mandatoryLinks: { default: (s) => [
      {
        label: `Accessibilité : ${s.a11yCompliance}`,
        to: s.a11yComplianceLink
      },
      {
        label: "Mentions légales",
        to: s.legalLink,
        "data-testid": "/mentions-legales"
      },
      {
        label: "Données personnelles",
        to: s.personalDataLink
      },
      {
        label: "Gestion des cookies",
        to: s.cookiesLink
      }
    ] },
    ecosystemLinks: { default: () => [
      {
        label: "legifrance.gouv.fr",
        href: "https://legifrance.gouv.fr"
      },
      {
        label: "info.gouv.fr",
        href: "https://info.gouv.fr"
      },
      {
        label: "service-public.fr",
        href: "https://service-public.fr"
      },
      {
        label: "data.gouv.fr",
        href: "https://data.gouv.fr"
      }
    ] },
    operatorLinkText: { default: "Revenir à l’accueil" },
    operatorTo: { default: "/" },
    operatorImgStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    operatorImgSrc: { default: void 0 },
    operatorImgAlt: { default: "" },
    licenceTo: { default: "https://github.com/etalab/licence-ouverte/blob/master/LO.md" },
    licenceLinkProps: { default: () => {
    } },
    licenceText: { default: "Sauf mention contraire, tous les textes de ce site sont sous" },
    licenceName: { default: "licence etalab-2.0" }
  },
  setup(s) {
    const e = s, t = g(() => [
      ...e.beforeMandatoryLinks,
      ...e.mandatoryLinks,
      ...e.afterMandatoryLinks
    ]), a = pt(), n = g(() => {
      var p;
      return (p = a["footer-link-lists"]) == null ? void 0 : p.call(a).length;
    }), i = g(() => {
      const p = e.licenceTo || e.licenceLinkProps.to;
      return p && typeof p == "string" && p.startsWith("http");
    }), l = g(() => i.value ? "" : e.licenceTo), c = g(() => i.value ? e.licenceTo : ""), u = g(() => typeof e.operatorTo == "string" && e.operatorTo.startsWith("http"));
    return (p, h) => {
      const f = se("RouterLink");
      return r(), d("footer", hr, [
        n.value ? (r(), d("div", vr, [
          o("div", mr, [
            o("div", gr, [
              I(p.$slots, "footer-link-lists", {}, void 0, !0)
            ])
          ])
        ])) : m("", !0),
        o("div", br, [
          o("div", yr, [
            p.operatorImgSrc ? (r(), d("div", kr, [
              G(Le, { "logo-text": p.logoText }, null, 8, ["logo-text"]),
              u.value ? (r(), d("a", {
                key: 0,
                href: p.operatorTo,
                "data-testid": "card-link",
                class: "fr-footer__brand-link"
              }, [
                o("img", {
                  class: "fr-footer__logo",
                  style: ue(p.operatorImgStyle),
                  src: p.operatorImgSrc,
                  alt: p.operatorImgAlt
                }, null, 12, _r)
              ], 8, wr)) : (r(), L(f, {
                key: 1,
                class: "fr-footer__brand-link",
                to: p.homeLink,
                title: p.homeTitle
              }, {
                default: F(() => [
                  o("img", {
                    class: "fr-footer__logo",
                    style: ue(p.operatorImgStyle),
                    src: p.operatorImgSrc,
                    alt: p.operatorImgAlt
                  }, null, 12, $r)
                ]),
                _: 1
              }, 8, ["to", "title"]))
            ])) : (r(), d("div", Dr, [
              G(f, {
                to: p.homeLink,
                title: p.homeTitle
              }, {
                default: F(() => [
                  G(Le, { "logo-text": p.logoText }, null, 8, ["logo-text"])
                ]),
                _: 1
              }, 8, ["to", "title"])
            ])),
            o("div", Mr, [
              o("p", Ir, [
                I(p.$slots, "description", {}, () => [
                  z(v(p.descText), 1)
                ], !0)
              ]),
              o("ul", Lr, [
                (r(!0), d(R, null, X(p.ecosystemLinks, (_, $) => (r(), d("li", {
                  key: $,
                  class: "fr-footer__content-item"
                }, [
                  o("a", {
                    class: "fr-footer__content-link",
                    href: _.href,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, v(_.label), 9, Cr)
                ]))), 128))
              ])
            ])
          ]),
          p.partners ? (r(), L(yt, re(E({ key: 0 }, p.partners)), null, 16)) : m("", !0),
          o("div", zr, [
            o("ul", Sr, [
              (r(!0), d(R, null, X(t.value, (_, $) => (r(), d("li", {
                key: $,
                class: "fr-footer__bottom-item"
              }, [
                G(pr, E({ ref_for: !0 }, _), null, 16)
              ]))), 128))
            ]),
            p.licenceText ? (r(), d("div", Tr, [
              o("p", null, [
                z(v(p.licenceText) + " ", 1),
                (r(), L(J(i.value ? "a" : "RouterLink"), E({
                  class: "fr-link-licence no-content-after",
                  to: i.value ? null : l.value,
                  href: c.value,
                  target: i.value ? "_blank" : void 0,
                  rel: "noopener noreferrer"
                }, p.licenceLinkProps), {
                  default: F(() => [
                    z(v(p.licenceName), 1)
                  ]),
                  _: 1
                }, 16, ["to", "href", "target"]))
              ])
            ])) : m("", !0)
          ])
        ])
      ]);
    };
  }
}), Er = /* @__PURE__ */ ae(Ar, [["__scopeId", "data-v-a64fdd76"]]), Hr = { class: "fr-footer__top-cat" }, Br = { class: "fr-footer__top-list" }, Vr = ["href"], Rr = /* @__PURE__ */ D({
  __name: "DsfrFooterLinkList",
  props: {
    categoryName: { default: "Nom de la catégorie" },
    links: { default: () => [] }
  },
  setup(s) {
    return (e, t) => {
      const a = se("RouterLink");
      return r(), d("div", null, [
        o("h3", Hr, v(e.categoryName), 1),
        o("ul", Br, [
          (r(!0), d(R, null, X(e.links, (n, i) => (r(), d("li", { key: i }, [
            typeof n.to == "string" && n.to.startsWith("http") ? (r(), d("a", {
              key: 0,
              class: "fr-footer__top-link",
              target: "_blank",
              rel: "noopener noreferrer",
              href: n.to
            }, v(n.label), 9, Vr)) : m("", !0),
            typeof n.to == "object" || typeof n.to == "string" && !n.to.startsWith("http") ? (r(), L(a, {
              key: 1,
              class: "fr-footer__top-link",
              to: n.to
            }, {
              default: F(() => [
                z(v(n.label), 1)
              ]),
              _: 2
            }, 1032, ["to"])) : m("", !0)
          ]))), 128))
        ])
      ]);
    };
  }
}), Pr = { class: "fr-connect-group" }, Fr = /* @__PURE__ */ o("span", { class: "fr-connect__login" }, "S’identifier avec ", -1), Nr = { class: "fr-connect__brand" }, Xr = ["href", "title"], Yr = /* @__PURE__ */ D({
  __name: "DsfrFranceConnect",
  props: {
    secure: { type: Boolean },
    url: {}
  },
  setup(s) {
    return (e, t) => (r(), d("div", Pr, [
      o("button", {
        class: C(["fr-connect", [{ "fr-connect--plus": e.secure }]])
      }, [
        Fr,
        o("span", Nr, "FranceConnect" + v(e.secure ? "+" : ""), 1)
      ], 2),
      o("p", null, [
        o("a", {
          href: e.url ?? `https://franceconnect.gouv.fr/${e.secure ? "france-connect-plus" : ""}`,
          target: "_blank",
          rel: "noopener noreferrer",
          title: `Qu’est-ce que FranceConnect${e.secure ? "+" : ""} ? - nouvelle fenêtre`
        }, v(`Qu’est-ce que FranceConnect${e.secure ? "+" : ""} ?`), 9, Xr)
      ])
    ]));
  }
}), Or = ["for"], jr = {
  key: 0,
  class: "required"
}, qr = {
  key: 0,
  class: "fr-hint-text"
}, Qr = /* @__PURE__ */ D({
  inheritAttrs: !1,
  __name: "DsfrInput",
  props: {
    id: { default: () => j("basic", "input") },
    descriptionId: { default: void 0 },
    hint: { default: "" },
    isInvalid: { type: Boolean },
    isValid: { type: Boolean },
    isTextarea: { type: Boolean },
    isWithWrapper: { type: Boolean },
    labelVisible: { type: Boolean },
    label: { default: "" },
    labelClass: { default: "" },
    modelValue: { default: "" },
    wrapperClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(s, { expose: e }) {
    const t = s, a = Gt(), n = B(null), i = () => {
      var p;
      return (p = n.value) == null ? void 0 : p.focus();
    }, l = g(() => t.isTextarea ? "textarea" : "input"), c = g(() => t.isWithWrapper || a.type === "date" || !!t.wrapperClass), u = g(() => [
      "fr-label",
      { invisible: !t.labelVisible },
      t.labelClass
    ]);
    return e({
      focus: i
    }), (p, h) => (r(), d(R, null, [
      o("label", {
        class: C(u.value),
        for: p.id
      }, [
        I(p.$slots, "label", {}, () => [
          z(v(p.label) + " ", 1),
          I(p.$slots, "required-tip", {}, () => [
            "required" in p.$attrs && p.$attrs.required !== !1 ? (r(), d("span", jr, "*")) : m("", !0)
          ], !0)
        ], !0),
        p.hint ? (r(), d("span", qr, v(p.hint), 1)) : m("", !0)
      ], 10, Or),
      c.value ? (r(), d("div", {
        key: 1,
        class: C([
          { "fr-input-wrap": p.isWithWrapper || p.$attrs.type === "date" },
          p.wrapperClass
        ])
      }, [
        (r(), L(J(l.value), E({ id: p.id }, p.$attrs, {
          ref_key: "__input",
          ref: n,
          class: ["fr-input", {
            "fr-input--error": p.isInvalid,
            "fr-input--valid": p.isValid
          }],
          value: p.modelValue,
          "aria-describedby": p.descriptionId || void 0,
          onInput: h[1] || (h[1] = (f) => p.$emit("update:modelValue", f.target.value))
        }), null, 16, ["id", "class", "value", "aria-describedby"]))
      ], 2)) : (r(), L(J(l.value), E({
        key: 0,
        id: p.id
      }, p.$attrs, {
        ref_key: "__input",
        ref: n,
        class: ["fr-input", {
          "fr-input--error": p.isInvalid,
          "fr-input--valid": p.isValid
        }],
        value: p.modelValue,
        "aria-describedby": p.descriptionId || void 0,
        onInput: h[0] || (h[0] = (f) => p.$emit("update:modelValue", f.target.value))
      }), null, 16, ["id", "class", "value", "aria-describedby"]))
    ], 64));
  }
}), qe = /* @__PURE__ */ ae(Qr, [["__scopeId", "data-v-771f90df"]]), Fe = /* @__PURE__ */ D({
  __name: "DsfrSearchBar",
  props: {
    id: { default: () => j("search", "input") },
    label: { default: "" },
    labelVisible: { type: Boolean },
    large: { type: Boolean },
    buttonText: { default: "" },
    modelValue: { default: "" },
    placeholder: { default: "Rechercher" },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "search"],
  setup(s, { emit: e }) {
    const t = e;
    return (a, n) => (r(), d("div", {
      class: C(["fr-search-bar", { "fr-search-bar--lg": a.large }]),
      role: "search"
    }, [
      G(qe, {
        id: a.id,
        type: "search",
        placeholder: a.placeholder,
        "model-value": a.modelValue,
        "label-visible": a.labelVisible,
        label: a.label,
        disabled: a.disabled,
        "aria-disabled": a.disabled,
        "onUpdate:modelValue": n[0] || (n[0] = (i) => t("update:modelValue", i)),
        onKeydown: n[1] || (n[1] = Kt((i) => t("search", a.modelValue), ["enter"]))
      }, null, 8, ["id", "placeholder", "model-value", "label-visible", "label", "disabled", "aria-disabled"]),
      G(Ae, {
        title: "Rechercher",
        disabled: a.disabled,
        "aria-disabled": a.disabled,
        onClick: n[2] || (n[2] = (i) => t("search", a.modelValue))
      }, {
        default: F(() => [
          z(v(a.buttonText), 1)
        ]),
        _: 1
      }, 8, ["disabled", "aria-disabled"])
    ], 2));
  }
}), xe = 1, kt = /* @__PURE__ */ D({
  __name: "DsfrHeaderMenuLink",
  props: {
    button: { type: Boolean },
    icon: { default: void 0 },
    iconAttrs: { default: () => ({}) },
    iconRight: { type: Boolean },
    label: { default: "" },
    target: { default: "_self" },
    onClick: { type: Function, default: () => {
    } },
    to: { default: void 0 },
    href: { default: void 0 }
  },
  setup(s) {
    const e = s, t = g(() => typeof e.path == "string"), a = g(() => {
      var f;
      return ((f = e.href) == null ? void 0 : f.startsWith("http")) || t.value && e.path.startsWith("http");
    }), n = g(() => {
      var f;
      return ((f = e.href) == null ? void 0 : f.startsWith("mailto")) || t.value && e.path.startsWith("mailto");
    }), i = g(() => e.button ? "button" : a.value || n.value ? "a" : "RouterLink"), l = g(() => {
      if (!(!a.value && !n.value))
        return e.href !== void 0 ? e.href : e.path;
    }), c = g(() => {
      if (!(a.value || n.value))
        return e.to || e.path;
    }), u = g(() => c.value ? { to: c.value } : { href: l.value }), p = g(() => typeof e.icon == "string" && e.icon.startsWith("fr-icon-")), h = g(
      () => typeof e.icon == "string" ? { name: e.icon, scale: xe, ...e.iconAttrs ?? {} } : { scale: xe, ...e.icon ?? {}, ...e.iconAttrs ?? {} }
    );
    return (f, _) => (r(), L(J(i.value), E({
      class: ["fr-btn", {
        "fr-btn--icon-right": p.value && f.iconRight,
        "fr-btn--icon-left": p.value && !f.iconRight,
        [String(f.icon)]: p.value
      }]
    }, u.value, {
      target: f.target,
      onClick: W(f.onClick, ["stop"])
    }), {
      default: F(() => {
        var $, y;
        return [
          !p.value && (f.icon || ($ = f.iconAttrs) != null && $.name) && !f.iconRight ? (r(), L(N(le), E({
            key: 0,
            class: "fr-mr-1w"
          }, h.value), null, 16)) : m("", !0),
          z(" " + v(f.label) + " ", 1),
          !p.value && (f.icon || (y = f.iconAttrs) != null && y.name) && f.iconRight ? (r(), L(N(le), E({
            key: 1,
            class: "fr-ml-1w"
          }, h.value), null, 16)) : m("", !0)
        ];
      }),
      _: 1
    }, 16, ["class", "target", "onClick"]));
  }
}), Gr = ["aria-label"], Kr = { class: "fr-btns-group" }, Ne = /* @__PURE__ */ D({
  __name: "DsfrHeaderMenuLinks",
  props: {
    links: { default: () => [] },
    navAriaLabel: { default: "Menu secondaire" }
  },
  emits: ["linkClick"],
  setup(s, { emit: e }) {
    const t = e;
    return (a, n) => (r(), d("nav", {
      role: "navigation",
      "aria-label": a.navAriaLabel
    }, [
      o("ul", Kr, [
        (r(!0), d(R, null, X(a.links, (i, l) => (r(), d("li", { key: l }, [
          G(kt, E({ ref_for: !0 }, i, {
            "on-click": (c) => {
              var u;
              t("linkClick", c), (u = i.onClick) == null || u.call(i, c);
            }
          }), null, 16, ["on-click"])
        ]))), 128))
      ])
    ], 8, Gr));
  }
}), Wr = {
  role: "navigation",
  class: "fr-translate fr-nav"
}, Ur = { class: "fr-nav__item" }, Zr = ["aria-controls", "aria-expanded"], Jr = { class: "fr-hidden-lg" }, xr = ["id"], el = { class: "fr-menu__list" }, tl = ["hreflang", "lang", "aria-current", "href", "onClick"], Xe = /* @__PURE__ */ D({
  __name: "DsfrLanguageSelector",
  props: {
    id: { default: () => j("translate") },
    languages: { default: () => [] },
    currentLanguage: { default: "fr" }
  },
  emits: ["select"],
  setup(s, { emit: e }) {
    const t = s, a = e, {
      collapse: n,
      collapsing: i,
      cssExpanded: l,
      doExpand: c,
      onTransitionEnd: u
    } = ce(), p = B(!1);
    function h(_) {
      p.value = !1, a("select", _);
    }
    const f = g(
      () => t.languages.find(({ codeIso: _ }) => _ === t.currentLanguage)
    );
    return te(p, (_, $) => {
      _ !== $ && c(_);
    }), (_, $) => {
      var y, V;
      return r(), d("nav", Wr, [
        o("div", Ur, [
          o("button", {
            class: "fr-translate__btn fr-btn fr-btn--tertiary",
            "aria-controls": _.id,
            "aria-expanded": p.value,
            title: "Sélectionner une langue",
            type: "button",
            onClick: $[0] || ($[0] = W((b) => p.value = !p.value, ["prevent", "stop"]))
          }, [
            z(v((y = f.value) == null ? void 0 : y.codeIso.toUpperCase()), 1),
            o("span", Jr, " - " + v((V = f.value) == null ? void 0 : V.label), 1)
          ], 8, Zr),
          o("div", {
            id: _.id,
            ref_key: "collapse",
            ref: n,
            class: C(["fr-collapse fr-translate__menu fr-menu", { "fr-collapse--expanded": N(l), "fr-collapsing": N(i) }]),
            onTransitionend: $[1] || ($[1] = (b) => N(u)(p.value))
          }, [
            o("ul", el, [
              (r(!0), d(R, null, X(_.languages, (b, M) => (r(), d("li", { key: M }, [
                o("a", {
                  class: "fr-translate__language fr-nav__link",
                  hreflang: b.codeIso,
                  lang: b.codeIso,
                  "aria-current": _.currentLanguage === b.codeIso ? !0 : void 0,
                  href: `#${b.codeIso}`,
                  onClick: W((H) => h(b), ["prevent", "stop"])
                }, v(`${b.codeIso.toUpperCase()} - ${b.label}`), 9, tl)
              ]))), 128))
            ])
          ], 42, xr)
        ])
      ]);
    };
  }
}), al = {
  role: "banner",
  class: "fr-header"
}, nl = { class: "fr-header__body" }, rl = { class: "fr-container width-inherit" }, ll = { class: "fr-header__body-row" }, sl = { class: "fr-header__brand fr-enlarge-link" }, ol = { class: "fr-header__brand-top" }, il = { class: "fr-header__logo" }, dl = {
  key: 0,
  class: "fr-header__operator"
}, ul = ["src", "alt"], cl = {
  key: 1,
  class: "fr-header__navbar"
}, fl = ["aria-label", "title", "data-fr-opened"], pl = ["aria-label", "title"], hl = {
  key: 0,
  class: "fr-header__service"
}, vl = { class: "fr-header__service-title" }, ml = {
  key: 0,
  class: "fr-badge fr-badge--sm fr-badge--green-emeraude"
}, gl = {
  key: 0,
  class: "fr-header__service-tagline"
}, bl = {
  key: 1,
  class: "fr-header__service"
}, yl = /* @__PURE__ */ o("p", { class: "fr-header__service-title" }, [
  /* @__PURE__ */ o("span", { class: "fr-badge fr-badge--sm fr-badge--green-emeraude" }, "BETA")
], -1), kl = [
  yl
], wl = { class: "fr-header__tools" }, _l = {
  key: 0,
  class: "fr-header__tools-links"
}, $l = {
  key: 1,
  class: "fr-header__search fr-modal"
}, Dl = ["aria-label"], Ml = { class: "fr-container" }, Il = { class: "fr-header__menu-links" }, Ll = { role: "navigation" }, Cl = {
  key: 1,
  class: "flex justify-center items-center"
}, zl = {
  key: 1,
  class: "fr-hidden fr-unhidden-lg"
}, Sl = /* @__PURE__ */ D({
  __name: "DsfrHeader",
  props: {
    searchbarId: { default: "searchbar-header" },
    serviceTitle: { default: void 0 },
    serviceDescription: { default: void 0 },
    homeTo: { default: "/" },
    logoText: { default: () => "Gouvernement" },
    modelValue: { default: "" },
    operatorImgAlt: { default: "" },
    operatorImgSrc: { default: "" },
    operatorImgStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    placeholder: { default: "Rechercher..." },
    quickLinks: { default: () => [] },
    languageSelector: { default: void 0 },
    searchLabel: { default: "Recherche" },
    quickLinksAriaLabel: { default: "Menu secondaire" },
    showSearch: { type: Boolean },
    showSearchLabel: { default: "Recherche" },
    showBeta: { type: Boolean },
    menuLabel: { default: "Menu" },
    menuModalLabel: { default: "Menu modal" },
    closeMenuModalLabel: { default: "Fermer" },
    homeLabel: { default: "Accueil" }
  },
  emits: ["update:modelValue", "search", "language-select"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = Wt(t, "languageSelector"), i = B(!1), l = B(!1), c = B(!1), u = () => {
      var b;
      c.value = !1, i.value = !1, l.value = !1, (b = document.getElementById("button-menu")) == null || b.focus();
    }, p = (b) => {
      b.key === "Escape" && u();
    };
    ne(() => {
      document.addEventListener("keydown", p);
    }), be(() => {
      document.removeEventListener("keydown", p);
    });
    const h = () => {
      var b;
      c.value = !0, i.value = !0, l.value = !1, (b = document.getElementById("close-button")) == null || b.focus();
    }, f = () => {
      c.value = !0, i.value = !1, l.value = !0;
    }, _ = u, $ = pt(), y = g(() => {
      var b;
      return !!((b = $.operator) != null && b.call($).length) || !!t.operatorImgSrc;
    }), V = g(() => !!$.mainnav);
    return (b, M) => {
      var S, A, q;
      const H = se("RouterLink");
      return r(), d("header", al, [
        o("div", nl, [
          o("div", rl, [
            o("div", ll, [
              o("div", sl, [
                o("div", ol, [
                  o("div", il, [
                    G(Le, {
                      "logo-text": b.logoText,
                      "data-testid": "header-logo"
                    }, null, 8, ["logo-text"])
                  ]),
                  y.value ? (r(), d("div", dl, [
                    I(b.$slots, "operator", {}, () => [
                      b.operatorImgSrc ? (r(), d("img", {
                        key: 0,
                        class: "fr-responsive-img",
                        src: b.operatorImgSrc,
                        alt: b.operatorImgAlt,
                        style: ue(b.operatorImgStyle)
                      }, null, 12, ul)) : m("", !0)
                    ])
                  ])) : m("", !0),
                  b.showSearch || V.value || (S = b.quickLinks) != null && S.length ? (r(), d("div", cl, [
                    b.showSearch ? (r(), d("button", {
                      key: 0,
                      class: "fr-btn fr-btn--search",
                      "aria-controls": "header-search",
                      "aria-label": b.showSearchLabel,
                      title: b.showSearchLabel,
                      "data-fr-opened": l.value,
                      onClick: M[0] || (M[0] = W((P) => f(), ["prevent", "stop"]))
                    }, null, 8, fl)) : m("", !0),
                    V.value || (A = b.quickLinks) != null && A.length ? (r(), d("button", {
                      key: 1,
                      id: "button-menu",
                      class: "fr-btn--menu fr-btn",
                      "data-fr-opened": h,
                      "aria-controls": "header-navigation",
                      "aria-haspopup": "menu",
                      "aria-label": b.menuLabel,
                      title: b.menuLabel,
                      "data-testid": "open-menu-btn",
                      onClick: M[1] || (M[1] = W((P) => h(), ["prevent", "stop"]))
                    }, null, 8, pl)) : m("", !0)
                  ])) : m("", !0)
                ]),
                b.serviceTitle ? (r(), d("div", hl, [
                  G(H, E({
                    to: b.homeTo,
                    title: `${b.homeLabel} - ${b.serviceTitle}`
                  }, b.$attrs), {
                    default: F(() => [
                      o("p", vl, [
                        z(v(b.serviceTitle) + " ", 1),
                        b.showBeta ? (r(), d("span", ml, " BETA ")) : m("", !0)
                      ])
                    ]),
                    _: 1
                  }, 16, ["to", "title"]),
                  b.serviceDescription ? (r(), d("p", gl, v(b.serviceDescription), 1)) : m("", !0)
                ])) : m("", !0),
                !b.serviceTitle && b.showBeta ? (r(), d("div", bl, kl)) : m("", !0)
              ]),
              o("div", wl, [
                (q = b.quickLinks) != null && q.length || n.value ? (r(), d("div", _l, [
                  i.value ? m("", !0) : (r(), L(Ne, {
                    key: 0,
                    links: b.quickLinks,
                    "nav-aria-label": b.quickLinksAriaLabel
                  }, null, 8, ["links", "nav-aria-label"])),
                  n.value ? (r(), L(Xe, E({ key: 1 }, n.value, {
                    onSelect: M[2] || (M[2] = (P) => a("language-select", P))
                  }), null, 16)) : m("", !0)
                ])) : m("", !0),
                b.showSearch ? (r(), d("div", $l, [
                  G(Fe, {
                    "searchbar-id": b.searchbarId,
                    label: b.searchLabel,
                    "model-value": b.modelValue,
                    placeholder: b.placeholder,
                    style: { "justify-content": "flex-end" },
                    "onUpdate:modelValue": M[3] || (M[3] = (P) => a("update:modelValue", P)),
                    onSearch: M[4] || (M[4] = (P) => a("search", P))
                  }, null, 8, ["searchbar-id", "label", "model-value", "placeholder"])
                ])) : m("", !0)
              ])
            ]),
            b.showSearch || V.value || b.quickLinks && b.quickLinks.length || n.value ? (r(), d("div", {
              key: 0,
              id: "header-navigation",
              class: C(["fr-header__menu fr-modal", { "fr-modal--opened": c.value }]),
              "aria-label": b.menuModalLabel,
              role: "dialog",
              "aria-modal": "true"
            }, [
              o("div", Ml, [
                o("button", {
                  id: "close-button",
                  class: "fr-btn fr-btn--close",
                  "aria-controls": "header-navigation",
                  "data-testid": "close-modal-btn",
                  onClick: M[5] || (M[5] = W((P) => u(), ["prevent", "stop"]))
                }, v(b.closeMenuModalLabel), 1),
                o("div", Il, [
                  n.value ? (r(), L(Xe, E({ key: 0 }, n.value, {
                    onSelect: M[6] || (M[6] = (P) => n.value.currentLanguage = P.codeIso)
                  }), null, 16)) : m("", !0),
                  o("nav", Ll, [
                    i.value ? (r(), L(Ne, {
                      key: 0,
                      role: "navigation",
                      links: b.quickLinks,
                      "nav-aria-label": b.quickLinksAriaLabel,
                      onLinkClick: N(_)
                    }, null, 8, ["links", "nav-aria-label", "onLinkClick"])) : m("", !0)
                  ])
                ]),
                c.value ? I(b.$slots, "mainnav", {
                  key: 0,
                  hidemodal: u
                }) : m("", !0),
                l.value ? (r(), d("div", Cl, [
                  G(Fe, {
                    "searchbar-id": b.searchbarId,
                    "model-value": b.modelValue,
                    placeholder: b.placeholder,
                    "onUpdate:modelValue": M[7] || (M[7] = (P) => a("update:modelValue", P)),
                    onSearch: M[8] || (M[8] = (P) => a("search", P))
                  }, null, 8, ["searchbar-id", "model-value", "placeholder"])
                ])) : m("", !0)
              ])
            ], 10, Dl)) : m("", !0),
            V.value && !c.value ? (r(), d("div", zl, [
              I(b.$slots, "mainnav", { hidemodal: u })
            ])) : m("", !0),
            I(b.$slots, "default")
          ])
        ])
      ]);
    };
  }
}), Tl = { class: "fr-highlight" }, Al = /* @__PURE__ */ D({
  __name: "DsfrHighlight",
  props: {
    text: { default: void 0 },
    small: { type: Boolean },
    large: { type: Boolean }
  },
  setup(s) {
    return (e, t) => (r(), d("div", Tl, [
      o("p", {
        class: C({
          "fr-text--lg": e.large && !e.small,
          "fr-text--sm": e.small && !e.large
        })
      }, [
        z(v(e.text) + " ", 1),
        I(e.$slots, "default")
      ], 2)
    ]));
  }
}), El = {
  class: "fr-messages-group",
  role: "alert",
  "aria-live": "polite"
}, Hl = ["id", "data-testid"], Bl = ["id", "data-testid"], Vl = ["id", "data-testid"], Rl = ["id", "data-testid"], Pl = /* @__PURE__ */ D({
  inheritAttrs: !1,
  __name: "DsfrInputGroup",
  props: {
    descriptionId: { default: () => j("basic", "input") },
    hint: { default: "" },
    labelVisible: { type: Boolean },
    label: { default: "" },
    labelClass: { default: "" },
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    errorMessage: { default: void 0 },
    validMessage: { default: void 0 },
    wrapperClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(s) {
    return (e, t) => (r(), d("div", {
      class: C(["fr-input-group", [
        {
          "fr-input-group--error": e.errorMessage,
          "fr-input-group--valid": e.validMessage && !e.errorMessage
        },
        e.wrapperClass
      ]])
    }, [
      I(e.$slots, "before-input"),
      I(e.$slots, "default"),
      e.$slots.default ? m("", !0) : (r(), L(qe, E({ key: 0 }, e.$attrs, {
        "is-valid": !!e.validMessage,
        "is-invalid": !!e.errorMessage,
        label: e.label,
        hint: e.hint,
        "description-id": (e.errorMessage || e.validMessage) && e.descriptionId || void 0,
        "label-visible": e.labelVisible,
        "model-value": e.modelValue,
        placeholder: e.placeholder,
        "onUpdate:modelValue": t[0] || (t[0] = (a) => e.$emit("update:modelValue", a))
      }), null, 16, ["is-valid", "is-invalid", "label", "hint", "description-id", "label-visible", "model-value", "placeholder"])),
      o("div", El, [
        Array.isArray(e.errorMessage) ? (r(!0), d(R, { key: 0 }, X(e.errorMessage, (a) => (r(), d("p", {
          id: e.descriptionId,
          key: a,
          "data-testid": e.descriptionId,
          class: "fr-error-text"
        }, [
          o("span", null, v(a), 1)
        ], 8, Hl))), 128)) : e.errorMessage ? (r(), d("p", {
          id: e.descriptionId,
          key: e.errorMessage,
          "data-testid": e.descriptionId,
          class: "fr-error-text"
        }, [
          o("span", null, v(e.errorMessage), 1)
        ], 8, Bl)) : m("", !0),
        Array.isArray(e.validMessage) ? (r(!0), d(R, { key: 2 }, X(e.validMessage, (a) => (r(), d("p", {
          id: e.descriptionId,
          key: a,
          "data-testid": e.descriptionId,
          class: "fr-valid-text"
        }, [
          o("span", null, v(a), 1)
        ], 8, Vl))), 128)) : e.validMessage ? (r(), d("p", {
          id: e.descriptionId,
          key: e.validMessage,
          "data-testid": e.descriptionId,
          class: "fr-valid-text"
        }, [
          o("span", null, v(e.validMessage), 1)
        ], 8, Rl)) : m("", !0)
      ])
    ], 2));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var wt = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ce = /* @__PURE__ */ wt.join(","), _t = typeof Element > "u", ve = _t ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, ze = !_t && Element.prototype.getRootNode ? function(s) {
  var e;
  return s == null || (e = s.getRootNode) === null || e === void 0 ? void 0 : e.call(s);
} : function(s) {
  return s == null ? void 0 : s.ownerDocument;
}, Se = function s(e, t) {
  var a;
  t === void 0 && (t = !0);
  var n = e == null || (a = e.getAttribute) === null || a === void 0 ? void 0 : a.call(e, "inert"), i = n === "" || n === "true", l = i || t && e && s(e.parentNode);
  return l;
}, Fl = function(e) {
  var t, a = e == null || (t = e.getAttribute) === null || t === void 0 ? void 0 : t.call(e, "contenteditable");
  return a === "" || a === "true";
}, $t = function(e, t, a) {
  if (Se(e))
    return [];
  var n = Array.prototype.slice.apply(e.querySelectorAll(Ce));
  return t && ve.call(e, Ce) && n.unshift(e), n = n.filter(a), n;
}, Dt = function s(e, t, a) {
  for (var n = [], i = Array.from(e); i.length; ) {
    var l = i.shift();
    if (!Se(l, !1))
      if (l.tagName === "SLOT") {
        var c = l.assignedElements(), u = c.length ? c : l.children, p = s(u, !0, a);
        a.flatten ? n.push.apply(n, p) : n.push({
          scopeParent: l,
          candidates: p
        });
      } else {
        var h = ve.call(l, Ce);
        h && a.filter(l) && (t || !e.includes(l)) && n.push(l);
        var f = l.shadowRoot || // check for an undisclosed shadow
        typeof a.getShadowRoot == "function" && a.getShadowRoot(l), _ = !Se(f, !1) && (!a.shadowRootFilter || a.shadowRootFilter(l));
        if (f && _) {
          var $ = s(f === !0 ? l.children : f.children, !0, a);
          a.flatten ? n.push.apply(n, $) : n.push({
            scopeParent: l,
            candidates: $
          });
        } else
          i.unshift.apply(i, l.children);
      }
  }
  return n;
}, Mt = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, he = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || Fl(e)) && !Mt(e) ? 0 : e.tabIndex;
}, Nl = function(e, t) {
  var a = he(e);
  return a < 0 && t && !Mt(e) ? 0 : a;
}, Xl = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, It = function(e) {
  return e.tagName === "INPUT";
}, Yl = function(e) {
  return It(e) && e.type === "hidden";
}, Ol = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return t;
}, jl = function(e, t) {
  for (var a = 0; a < e.length; a++)
    if (e[a].checked && e[a].form === t)
      return e[a];
}, ql = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || ze(e), a = function(c) {
    return t.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, n;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    n = a(window.CSS.escape(e.name));
  else
    try {
      n = a(e.name);
    } catch (l) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", l.message), !1;
    }
  var i = jl(n, e.form);
  return !i || i === e;
}, Ql = function(e) {
  return It(e) && e.type === "radio";
}, Gl = function(e) {
  return Ql(e) && !ql(e);
}, Kl = function(e) {
  var t, a = e && ze(e), n = (t = a) === null || t === void 0 ? void 0 : t.host, i = !1;
  if (a && a !== e) {
    var l, c, u;
    for (i = !!((l = n) !== null && l !== void 0 && (c = l.ownerDocument) !== null && c !== void 0 && c.contains(n) || e != null && (u = e.ownerDocument) !== null && u !== void 0 && u.contains(e)); !i && n; ) {
      var p, h, f;
      a = ze(n), n = (p = a) === null || p === void 0 ? void 0 : p.host, i = !!((h = n) !== null && h !== void 0 && (f = h.ownerDocument) !== null && f !== void 0 && f.contains(n));
    }
  }
  return i;
}, et = function(e) {
  var t = e.getBoundingClientRect(), a = t.width, n = t.height;
  return a === 0 && n === 0;
}, Wl = function(e, t) {
  var a = t.displayCheck, n = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var i = ve.call(e, "details>summary:first-of-type"), l = i ? e.parentElement : e;
  if (ve.call(l, "details:not([open]) *"))
    return !0;
  if (!a || a === "full" || a === "legacy-full") {
    if (typeof n == "function") {
      for (var c = e; e; ) {
        var u = e.parentElement, p = ze(e);
        if (u && !u.shadowRoot && n(u) === !0)
          return et(e);
        e.assignedSlot ? e = e.assignedSlot : !u && p !== e.ownerDocument ? e = p.host : e = u;
      }
      e = c;
    }
    if (Kl(e))
      return !e.getClientRects().length;
    if (a !== "legacy-full")
      return !0;
  } else if (a === "non-zero-area")
    return et(e);
  return !1;
}, Ul = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var a = 0; a < t.children.length; a++) {
          var n = t.children.item(a);
          if (n.tagName === "LEGEND")
            return ve.call(t, "fieldset[disabled] *") ? !0 : !n.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, Te = function(e, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Se(t) || Yl(t) || Wl(t, e) || // For a details element with a summary, the summary element gets the focus
  Ol(t) || Ul(t));
}, Ye = function(e, t) {
  return !(Gl(t) || he(t) < 0 || !Te(e, t));
}, Zl = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, Jl = function s(e) {
  var t = [], a = [];
  return e.forEach(function(n, i) {
    var l = !!n.scopeParent, c = l ? n.scopeParent : n, u = Nl(c, l), p = l ? s(n.candidates) : c;
    u === 0 ? l ? t.push.apply(t, p) : t.push(c) : a.push({
      documentOrder: i,
      tabIndex: u,
      item: n,
      isScope: l,
      content: p
    });
  }), a.sort(Xl).reduce(function(n, i) {
    return i.isScope ? n.push.apply(n, i.content) : n.push(i.content), n;
  }, []).concat(t);
}, xl = function(e, t) {
  t = t || {};
  var a;
  return t.getShadowRoot ? a = Dt([e], t.includeContainer, {
    filter: Ye.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: Zl
  }) : a = $t(e, t.includeContainer, Ye.bind(null, t)), Jl(a);
}, es = function(e, t) {
  t = t || {};
  var a;
  return t.getShadowRoot ? a = Dt([e], t.includeContainer, {
    filter: Te.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : a = $t(e, t.includeContainer, Te.bind(null, t)), a;
}, me = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return ve.call(e, Ce) === !1 ? !1 : Ye(t, e);
}, ts = /* @__PURE__ */ wt.concat("iframe").join(","), Re = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return ve.call(e, ts) === !1 ? !1 : Te(t, e);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function tt(s, e) {
  var t = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(s);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(s, n).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function at(s) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tt(Object(t), !0).forEach(function(a) {
      as(s, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(t)) : tt(Object(t)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return s;
}
function as(s, e, t) {
  return e = rs(e), e in s ? Object.defineProperty(s, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[e] = t, s;
}
function ns(s, e) {
  if (typeof s != "object" || s === null) return s;
  var t = s[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(s, e || "default");
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(s);
}
function rs(s) {
  var e = ns(s, "string");
  return typeof e == "symbol" ? e : String(e);
}
var nt = {
  activateTrap: function(e, t) {
    if (e.length > 0) {
      var a = e[e.length - 1];
      a !== t && a.pause();
    }
    var n = e.indexOf(t);
    n === -1 || e.splice(n, 1), e.push(t);
  },
  deactivateTrap: function(e, t) {
    var a = e.indexOf(t);
    a !== -1 && e.splice(a, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, ls = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, ss = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, $e = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, os = function(e) {
  return $e(e) && !e.shiftKey;
}, is = function(e) {
  return $e(e) && e.shiftKey;
}, rt = function(e) {
  return setTimeout(e, 0);
}, lt = function(e, t) {
  var a = -1;
  return e.every(function(n, i) {
    return t(n) ? (a = i, !1) : !0;
  }), a;
}, we = function(e) {
  for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    a[n - 1] = arguments[n];
  return typeof e == "function" ? e.apply(void 0, a) : e;
}, De = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, ds = [], us = function(e, t) {
  var a = (t == null ? void 0 : t.document) || document, n = (t == null ? void 0 : t.trapStack) || ds, i = at({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: os,
    isKeyBackward: is
  }, t), l = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, c, u = function(w, k, T) {
    return w && w[k] !== void 0 ? w[k] : i[T || k];
  }, p = function(w, k) {
    var T = typeof (k == null ? void 0 : k.composedPath) == "function" ? k.composedPath() : void 0;
    return l.containerGroups.findIndex(function(Y) {
      var O = Y.container, K = Y.tabbableNodes;
      return O.contains(w) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (T == null ? void 0 : T.includes(O)) || K.find(function(U) {
        return U === w;
      });
    });
  }, h = function(w) {
    var k = i[w];
    if (typeof k == "function") {
      for (var T = arguments.length, Y = new Array(T > 1 ? T - 1 : 0), O = 1; O < T; O++)
        Y[O - 1] = arguments[O];
      k = k.apply(void 0, Y);
    }
    if (k === !0 && (k = void 0), !k) {
      if (k === void 0 || k === !1)
        return k;
      throw new Error("`".concat(w, "` was specified but was not a node, or did not return a node"));
    }
    var K = k;
    if (typeof k == "string" && (K = a.querySelector(k), !K))
      throw new Error("`".concat(w, "` as selector refers to no known node"));
    return K;
  }, f = function() {
    var w = h("initialFocus");
    if (w === !1)
      return !1;
    if (w === void 0 || !Re(w, i.tabbableOptions))
      if (p(a.activeElement) >= 0)
        w = a.activeElement;
      else {
        var k = l.tabbableGroups[0], T = k && k.firstTabbableNode;
        w = T || h("fallbackFocus");
      }
    if (!w)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return w;
  }, _ = function() {
    if (l.containerGroups = l.containers.map(function(w) {
      var k = xl(w, i.tabbableOptions), T = es(w, i.tabbableOptions), Y = k.length > 0 ? k[0] : void 0, O = k.length > 0 ? k[k.length - 1] : void 0, K = T.find(function(x) {
        return me(x);
      }), U = T.slice().reverse().find(function(x) {
        return me(x);
      }), ee = !!k.find(function(x) {
        return he(x) > 0;
      });
      return {
        container: w,
        tabbableNodes: k,
        focusableNodes: T,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ee,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: Y,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: O,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: K,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: U,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(pe) {
          var ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, de = k.indexOf(pe);
          return de < 0 ? ye ? T.slice(T.indexOf(pe) + 1).find(function(ke) {
            return me(ke);
          }) : T.slice(0, T.indexOf(pe)).reverse().find(function(ke) {
            return me(ke);
          }) : k[de + (ye ? 1 : -1)];
        }
      };
    }), l.tabbableGroups = l.containerGroups.filter(function(w) {
      return w.tabbableNodes.length > 0;
    }), l.tabbableGroups.length <= 0 && !h("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (l.containerGroups.find(function(w) {
      return w.posTabIndexesFound;
    }) && l.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, $ = function Q(w) {
    var k = w.activeElement;
    if (k)
      return k.shadowRoot && k.shadowRoot.activeElement !== null ? Q(k.shadowRoot) : k;
  }, y = function Q(w) {
    if (w !== !1 && w !== $(document)) {
      if (!w || !w.focus) {
        Q(f());
        return;
      }
      w.focus({
        preventScroll: !!i.preventScroll
      }), l.mostRecentlyFocusedNode = w, ls(w) && w.select();
    }
  }, V = function(w) {
    var k = h("setReturnFocus", w);
    return k || (k === !1 ? !1 : w);
  }, b = function(w) {
    var k = w.target, T = w.event, Y = w.isBackward, O = Y === void 0 ? !1 : Y;
    k = k || De(T), _();
    var K = null;
    if (l.tabbableGroups.length > 0) {
      var U = p(k, T), ee = U >= 0 ? l.containerGroups[U] : void 0;
      if (U < 0)
        O ? K = l.tabbableGroups[l.tabbableGroups.length - 1].lastTabbableNode : K = l.tabbableGroups[0].firstTabbableNode;
      else if (O) {
        var x = lt(l.tabbableGroups, function(Be) {
          var Ve = Be.firstTabbableNode;
          return k === Ve;
        });
        if (x < 0 && (ee.container === k || Re(k, i.tabbableOptions) && !me(k, i.tabbableOptions) && !ee.nextTabbableNode(k, !1)) && (x = U), x >= 0) {
          var pe = x === 0 ? l.tabbableGroups.length - 1 : x - 1, ye = l.tabbableGroups[pe];
          K = he(k) >= 0 ? ye.lastTabbableNode : ye.lastDomTabbableNode;
        } else $e(T) || (K = ee.nextTabbableNode(k, !1));
      } else {
        var de = lt(l.tabbableGroups, function(Be) {
          var Ve = Be.lastTabbableNode;
          return k === Ve;
        });
        if (de < 0 && (ee.container === k || Re(k, i.tabbableOptions) && !me(k, i.tabbableOptions) && !ee.nextTabbableNode(k)) && (de = U), de >= 0) {
          var ke = de === l.tabbableGroups.length - 1 ? 0 : de + 1, Qe = l.tabbableGroups[ke];
          K = he(k) >= 0 ? Qe.firstTabbableNode : Qe.firstDomTabbableNode;
        } else $e(T) || (K = ee.nextTabbableNode(k));
      }
    } else
      K = h("fallbackFocus");
    return K;
  }, M = function(w) {
    var k = De(w);
    if (!(p(k, w) >= 0)) {
      if (we(i.clickOutsideDeactivates, w)) {
        c.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      we(i.allowOutsideClick, w) || w.preventDefault();
    }
  }, H = function(w) {
    var k = De(w), T = p(k, w) >= 0;
    if (T || k instanceof Document)
      T && (l.mostRecentlyFocusedNode = k);
    else {
      w.stopImmediatePropagation();
      var Y, O = !0;
      if (l.mostRecentlyFocusedNode)
        if (he(l.mostRecentlyFocusedNode) > 0) {
          var K = p(l.mostRecentlyFocusedNode), U = l.containerGroups[K].tabbableNodes;
          if (U.length > 0) {
            var ee = U.findIndex(function(x) {
              return x === l.mostRecentlyFocusedNode;
            });
            ee >= 0 && (i.isKeyForward(l.recentNavEvent) ? ee + 1 < U.length && (Y = U[ee + 1], O = !1) : ee - 1 >= 0 && (Y = U[ee - 1], O = !1));
          }
        } else
          l.containerGroups.some(function(x) {
            return x.tabbableNodes.some(function(pe) {
              return he(pe) > 0;
            });
          }) || (O = !1);
      else
        O = !1;
      O && (Y = b({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: l.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(l.recentNavEvent)
      })), y(Y || l.mostRecentlyFocusedNode || f());
    }
    l.recentNavEvent = void 0;
  }, S = function(w) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    l.recentNavEvent = w;
    var T = b({
      event: w,
      isBackward: k
    });
    T && ($e(w) && w.preventDefault(), y(T));
  }, A = function(w) {
    if (ss(w) && we(i.escapeDeactivates, w) !== !1) {
      w.preventDefault(), c.deactivate();
      return;
    }
    (i.isKeyForward(w) || i.isKeyBackward(w)) && S(w, i.isKeyBackward(w));
  }, q = function(w) {
    var k = De(w);
    p(k, w) >= 0 || we(i.clickOutsideDeactivates, w) || we(i.allowOutsideClick, w) || (w.preventDefault(), w.stopImmediatePropagation());
  }, P = function() {
    if (l.active)
      return nt.activateTrap(n, c), l.delayInitialFocusTimer = i.delayInitialFocus ? rt(function() {
        y(f());
      }) : y(f()), a.addEventListener("focusin", H, !0), a.addEventListener("mousedown", M, {
        capture: !0,
        passive: !1
      }), a.addEventListener("touchstart", M, {
        capture: !0,
        passive: !1
      }), a.addEventListener("click", q, {
        capture: !0,
        passive: !1
      }), a.addEventListener("keydown", A, {
        capture: !0,
        passive: !1
      }), c;
  }, Z = function() {
    if (l.active)
      return a.removeEventListener("focusin", H, !0), a.removeEventListener("mousedown", M, !0), a.removeEventListener("touchstart", M, !0), a.removeEventListener("click", q, !0), a.removeEventListener("keydown", A, !0), c;
  }, fe = function(w) {
    var k = w.some(function(T) {
      var Y = Array.from(T.removedNodes);
      return Y.some(function(O) {
        return O === l.mostRecentlyFocusedNode;
      });
    });
    k && y(f());
  }, ie = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(fe) : void 0, oe = function() {
    ie && (ie.disconnect(), l.active && !l.paused && l.containers.map(function(w) {
      ie.observe(w, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return c = {
    get active() {
      return l.active;
    },
    get paused() {
      return l.paused;
    },
    activate: function(w) {
      if (l.active)
        return this;
      var k = u(w, "onActivate"), T = u(w, "onPostActivate"), Y = u(w, "checkCanFocusTrap");
      Y || _(), l.active = !0, l.paused = !1, l.nodeFocusedBeforeActivation = a.activeElement, k == null || k();
      var O = function() {
        Y && _(), P(), oe(), T == null || T();
      };
      return Y ? (Y(l.containers.concat()).then(O, O), this) : (O(), this);
    },
    deactivate: function(w) {
      if (!l.active)
        return this;
      var k = at({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, w);
      clearTimeout(l.delayInitialFocusTimer), l.delayInitialFocusTimer = void 0, Z(), l.active = !1, l.paused = !1, oe(), nt.deactivateTrap(n, c);
      var T = u(k, "onDeactivate"), Y = u(k, "onPostDeactivate"), O = u(k, "checkCanReturnFocus"), K = u(k, "returnFocus", "returnFocusOnDeactivate");
      T == null || T();
      var U = function() {
        rt(function() {
          K && y(V(l.nodeFocusedBeforeActivation)), Y == null || Y();
        });
      };
      return K && O ? (O(V(l.nodeFocusedBeforeActivation)).then(U, U), this) : (U(), this);
    },
    pause: function(w) {
      if (l.paused || !l.active)
        return this;
      var k = u(w, "onPause"), T = u(w, "onPostPause");
      return l.paused = !0, k == null || k(), Z(), oe(), T == null || T(), this;
    },
    unpause: function(w) {
      if (!l.paused || !l.active)
        return this;
      var k = u(w, "onUnpause"), T = u(w, "onPostUnpause");
      return l.paused = !1, k == null || k(), _(), P(), oe(), T == null || T(), this;
    },
    updateContainerElements: function(w) {
      var k = [].concat(w).filter(Boolean);
      return l.containers = k.map(function(T) {
        return typeof T == "string" ? a.querySelector(T) : T;
      }), l.active && _(), oe(), this;
    }
  }, c.updateContainerElements(e), c;
};
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const cs = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, fs = D({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, cs),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(s, { slots: e, emit: t }) {
    let a;
    const n = B(null), i = g(() => {
      const c = n.value;
      return c && (c instanceof HTMLElement ? c : c.$el);
    });
    function l() {
      return a || (a = us(i.value, {
        escapeDeactivates: s.escapeDeactivates,
        allowOutsideClick: s.allowOutsideClick,
        returnFocusOnDeactivate: s.returnFocusOnDeactivate,
        clickOutsideDeactivates: s.clickOutsideDeactivates,
        onActivate: () => {
          t("update:active", !0), t("activate");
        },
        onDeactivate: () => {
          t("update:active", !1), t("deactivate");
        },
        onPostActivate: () => t("postActivate"),
        onPostDeactivate: () => t("postDeactivate"),
        initialFocus: s.initialFocus,
        fallbackFocus: s.fallbackFocus,
        tabbableOptions: s.tabbableOptions,
        delayInitialFocus: s.delayInitialFocus,
        preventScroll: s.preventScroll
      }));
    }
    return ne(() => {
      te(() => s.active, (c) => {
        c && i.value ? l().activate() : a && (a.deactivate(), (!i.value || i.value.nodeType === Node.COMMENT_NODE) && (a = null));
      }, { immediate: !0, flush: "post" });
    }), be(() => {
      a && a.deactivate(), a = null;
    }), {
      activate() {
        l().activate();
      },
      deactivate() {
        a && a.deactivate();
      },
      renderImpl() {
        if (!e.default)
          return null;
        const c = e.default().filter((p) => p.type !== Ut);
        return !c || !c.length || c.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), c) : Zt(c[0], { ref: n });
      }
    };
  }
}), ps = ["aria-labelledby", "role", "open"], hs = { class: "fr-container fr-container--fluid fr-container-md" }, vs = { class: "fr-grid-row fr-grid-row--center" }, ms = { class: "fr-modal__body" }, gs = { class: "fr-modal__header" }, bs = ["title"], ys = { class: "fr-modal__content" }, ks = ["id"], ws = {
  key: 0,
  class: "fr-modal__footer"
}, st = 2, _s = /* @__PURE__ */ D({
  __name: "DsfrModal",
  props: {
    modalId: { default: () => j("modal", "dialog") },
    opened: { type: Boolean },
    actions: { default: () => [] },
    isAlert: { type: Boolean },
    origin: { default: () => ({ focus() {
    } }) },
    title: {},
    icon: { default: void 0 },
    size: { default: "md" },
    closeButtonLabel: { default: "Fermer" },
    closeButtonTitle: { default: "Fermer la fenêtre modale" }
  },
  emits: ["close"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = (y) => {
      y.key === "Escape" && f();
    }, i = g(() => t.isAlert ? "alertdialog" : "dialog"), l = B(null), c = B();
    te(() => t.opened, (y) => {
      var V, b;
      y ? ((V = c.value) == null || V.showModal(), setTimeout(() => {
        var M;
        (M = l.value) == null || M.focus();
      }, 100)) : (b = c.value) == null || b.close(), u(y);
    });
    function u(y) {
      typeof window < "u" && document.body.classList.toggle("modal-open", y);
    }
    ne(() => {
      p(), u(t.opened);
    }), Jt(() => {
      h(), u(!1);
    });
    function p() {
      document.addEventListener("keydown", n);
    }
    function h() {
      document.removeEventListener("keydown", n);
    }
    async function f() {
      var y;
      await xt(), (y = t.origin) == null || y.focus(), a("close");
    }
    const _ = g(() => typeof t.icon == "string" && t.icon.startsWith("fr-icon-")), $ = g(
      () => _.value ? void 0 : typeof t.icon == "string" ? { name: t.icon, scale: st } : { scale: st, ...t.icon ?? {} }
    );
    return (y, V) => y.opened ? (r(), L(N(fs), { key: 0 }, {
      default: F(() => {
        var b, M;
        return [
          o("dialog", {
            id: "fr-modal-1",
            ref_key: "modal",
            ref: c,
            "aria-labelledby": y.modalId,
            role: i.value,
            class: C(["fr-modal", { "fr-modal--opened": y.opened }]),
            open: y.opened
          }, [
            o("div", hs, [
              o("div", vs, [
                o("div", {
                  class: C(["fr-col-12", {
                    "fr-col-md-8": y.size === "lg",
                    "fr-col-md-6": y.size === "md",
                    "fr-col-md-4": y.size === "sm"
                  }])
                }, [
                  o("div", ms, [
                    o("div", gs, [
                      o("button", {
                        ref_key: "closeBtn",
                        ref: l,
                        class: "fr-btn fr-btn--close",
                        title: y.closeButtonTitle,
                        "aria-controls": "fr-modal-1",
                        type: "button",
                        onClick: V[0] || (V[0] = (H) => f())
                      }, [
                        o("span", null, v(y.closeButtonLabel), 1)
                      ], 8, bs)
                    ]),
                    o("div", ys, [
                      o("h1", {
                        id: y.modalId,
                        class: "fr-modal__title"
                      }, [
                        _.value || $.value ? (r(), d("span", {
                          key: 0,
                          class: C({
                            [String(y.icon)]: _.value
                          })
                        }, [
                          y.icon && $.value ? (r(), L(N(le), re(E({ key: 0 }, $.value)), null, 16)) : m("", !0)
                        ], 2)) : m("", !0),
                        z(" " + v(y.title), 1)
                      ], 8, ks),
                      I(y.$slots, "default", {}, void 0, !0)
                    ]),
                    (b = y.actions) != null && b.length || y.$slots.footer ? (r(), d("div", ws, [
                      I(y.$slots, "footer", {}, void 0, !0),
                      (M = y.actions) != null && M.length ? (r(), L(Ee, {
                        key: 0,
                        align: "right",
                        buttons: y.actions,
                        "inline-layout-when": "large",
                        reverse: ""
                      }, null, 8, ["buttons"])) : m("", !0)
                    ])) : m("", !0)
                  ])
                ], 2)
              ])
            ])
          ], 10, ps)
        ];
      }),
      _: 3
    })) : m("", !0);
  }
}), $s = /* @__PURE__ */ ae(_s, [["__scopeId", "data-v-43ec81d5"]]), Ds = ["id", "aria-current"], Ms = /* @__PURE__ */ D({
  __name: "DsfrNavigationItem",
  props: {
    id: { default: () => j("nav", "item") },
    active: { type: Boolean }
  },
  setup(s) {
    return (e, t) => (r(), d("li", {
      id: e.id,
      class: "fr-nav__item",
      "aria-current": e.active ? "page" : void 0
    }, [
      I(e.$slots, "default", {}, void 0, !0)
    ], 8, Ds));
  }
}), Lt = /* @__PURE__ */ ae(Ms, [["__scopeId", "data-v-5909c19f"]]), Is = ["href"], ot = 2, He = /* @__PURE__ */ D({
  __name: "DsfrNavigationMenuLink",
  props: {
    id: { default: () => j("menu-link") },
    to: { default: "#" },
    text: { default: "" },
    icon: { default: void 0 },
    onClick: { type: Function, default: () => {
    } }
  },
  emits: ["toggleId"],
  setup(s) {
    const e = s, t = g(() => typeof e.to == "string" && e.to.startsWith("http")), a = g(() => e.icon && typeof e.icon == "string" && e.icon.startsWith("fr-icon-")), n = g(
      () => a.value || !e.icon ? void 0 : typeof e.icon == "string" ? { scale: ot, name: e.icon } : { scale: ot, ...e.icon || {} }
    );
    return (i, l) => {
      const c = se("RouterLink");
      return t.value ? (r(), d("a", {
        key: 0,
        class: "fr-nav__link",
        "data-testid": "nav-external-link",
        href: i.to,
        onClick: l[0] || (l[0] = (u) => i.$emit("toggleId", i.id))
      }, v(i.text), 9, Is)) : (r(), L(c, {
        key: 1,
        class: C(["fr-nav__link", {
          [String(i.icon)]: a.value
        }]),
        "data-testid": "nav-router-link",
        to: i.to,
        onClick: l[1] || (l[1] = (u) => i.$emit("toggleId", i.id))
      }, {
        default: F(() => [
          i.icon && n.value ? (r(), L(N(le), re(E({ key: 0 }, n.value)), null, 16)) : m("", !0),
          z(" " + v(i.text), 1)
        ]),
        _: 1
      }, 8, ["to", "class"]));
    };
  }
}), Ls = ["id", "aria-current"], Ct = /* @__PURE__ */ D({
  __name: "DsfrNavigationMenuItem",
  props: {
    id: { default: () => j("menu", "item") },
    active: { type: Boolean }
  },
  setup(s) {
    return (e, t) => (r(), d("li", {
      id: e.id,
      class: "fr-menu__item",
      "aria-current": e.active ? "page" : void 0
    }, [
      I(e.$slots, "default")
    ], 8, Ls));
  }
}), Cs = ["aria-expanded", "aria-current", "aria-controls"], zs = ["id"], Ss = { class: "fr-menu__list" }, zt = /* @__PURE__ */ D({
  __name: "DsfrNavigationMenu",
  props: {
    id: { default: () => j("menu") },
    title: {},
    links: { default: () => [] },
    expandedId: { default: "" },
    active: { type: Boolean }
  },
  emits: ["toggleId"],
  setup(s) {
    const e = s, {
      collapse: t,
      collapsing: a,
      cssExpanded: n,
      doExpand: i,
      onTransitionEnd: l
    } = ce(), c = g(() => e.id === e.expandedId);
    return te(c, (u, p) => {
      u !== p && i(u);
    }), ne(() => {
      c.value && i(!0);
    }), (u, p) => (r(), d(R, null, [
      o("button", {
        class: "fr-nav__btn",
        "aria-expanded": c.value,
        "aria-current": u.active || void 0,
        "aria-controls": u.id,
        onClick: p[0] || (p[0] = (h) => u.$emit("toggleId", u.id))
      }, [
        o("span", null, v(u.title), 1)
      ], 8, Cs),
      o("div", {
        id: u.id,
        ref_key: "collapse",
        ref: t,
        class: C(["fr-collapse fr-menu", { "fr-collapse--expanded": N(n), "fr-collapsing": N(a) }]),
        "data-testid": "navigation-menu",
        onTransitionend: p[2] || (p[2] = (h) => N(l)(c.value))
      }, [
        o("ul", Ss, [
          I(u.$slots, "default"),
          (r(!0), d(R, null, X(u.links, (h, f) => (r(), L(Ct, { key: f }, {
            default: F(() => [
              G(He, E({ ref_for: !0 }, h, {
                onToggleId: p[1] || (p[1] = (_) => u.$emit("toggleId", u.expandedId))
              }), null, 16)
            ]),
            _: 2
          }, 1024))), 128))
        ])
      ], 42, zs)
    ], 64));
  }
}), Ts = { class: "fr-col-12 fr-col-lg-3" }, As = { class: "fr-mega-menu__category" }, Es = { class: "fr-mega-menu__list" }, St = /* @__PURE__ */ D({
  __name: "DsfrNavigationMegaMenuCategory",
  props: {
    title: {},
    active: { type: Boolean },
    links: {}
  },
  setup(s) {
    return (e, t) => (r(), d("div", Ts, [
      o("h5", As, [
        o("a", {
          class: "fr-nav__link",
          href: "#",
          onClick: t[0] || (t[0] = W(() => {
          }, ["prevent"]))
        }, v(e.title), 1)
      ]),
      o("ul", Es, [
        (r(!0), d(R, null, X(e.links, (a, n) => (r(), d("li", {
          key: n,
          class: "fr-nav__link"
        }, [
          G(He, E({ ref_for: !0 }, a), null, 16)
        ]))), 128))
      ])
    ]));
  }
}), Hs = ["aria-expanded", "aria-current", "aria-controls"], Bs = ["id"], Vs = { class: "fr-container fr-container--fluid fr-container-lg" }, Rs = { class: "fr-grid-row fr-grid-row-lg--gutters" }, Ps = { class: "fr-col-12 fr-col-lg-8 fr-col-offset-lg-4--right fr-mb-4v" }, Fs = { class: "fr-mega-menu__leader" }, Ns = { class: "fr-h4 fr-mb-2v" }, Xs = { class: "fr-hidden fr-displayed-lg" }, Ys = /* @__PURE__ */ D({
  __name: "DsfrNavigationMegaMenu",
  props: {
    id: { default: () => j("menu") },
    title: {},
    description: { default: "" },
    link: { default: () => ({ to: "#", text: "Voir toute la rubrique" }) },
    menus: { default: () => [] },
    expandedId: { default: "" },
    active: { type: Boolean }
  },
  emits: ["toggleId"],
  setup(s) {
    const e = s, {
      collapse: t,
      collapsing: a,
      cssExpanded: n,
      doExpand: i,
      onTransitionEnd: l
    } = ce(), c = g(() => e.id === e.expandedId);
    return te(c, (u, p) => {
      u !== p && i(u);
    }), ne(() => {
      c.value && i(!0);
    }), (u, p) => {
      const h = se("RouterLink");
      return r(), d(R, null, [
        o("button", {
          class: "fr-nav__btn",
          "aria-expanded": c.value,
          "aria-current": u.active || void 0,
          "aria-controls": u.id,
          onClick: p[0] || (p[0] = (f) => u.$emit("toggleId", u.id))
        }, v(u.title), 9, Hs),
        o("div", {
          id: u.id,
          ref_key: "collapse",
          ref: t,
          "data-testid": "mega-menu-wrapper",
          class: C(["fr-collapse fr-mega-menu", {
            "fr-collapse--expanded": N(n),
            // Need to use a separate data to add/remove the class after a RAF
            "fr-collapsing": N(a)
          }]),
          tabindex: "-1",
          onTransitionend: p[2] || (p[2] = (f) => N(l)(c.value))
        }, [
          o("div", Vs, [
            o("button", {
              class: "fr-link--close fr-link",
              "aria-controls": "mega-menu-695",
              onClick: p[1] || (p[1] = (f) => u.$emit("toggleId", u.id))
            }, " Fermer "),
            o("div", Rs, [
              o("div", Ps, [
                o("div", Fs, [
                  o("h4", Ns, v(u.title), 1),
                  o("p", Xs, [
                    z(v(u.description) + " ", 1),
                    I(u.$slots, "description", {}, void 0, !0)
                  ]),
                  G(h, {
                    class: "fr-link fr-icon-arrow-right-line fr-link--icon-right fr-link--align-on-content",
                    to: u.link.to
                  }, {
                    default: F(() => [
                      z(v(u.link.text), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              I(u.$slots, "default", {}, void 0, !0),
              (r(!0), d(R, null, X(u.menus, (f, _) => (r(), L(St, E({
                key: _,
                ref_for: !0
              }, f), null, 16))), 128))
            ])
          ])
        ], 42, Bs)
      ], 64);
    };
  }
}), Tt = /* @__PURE__ */ ae(Ys, [["__scopeId", "data-v-020a2672"]]), Os = ["id", "aria-label"], js = { class: "fr-nav__list" }, qs = /* @__PURE__ */ D({
  __name: "DsfrNavigation",
  props: {
    id: { default: () => j("menu") },
    label: { default: "Menu principal" },
    navItems: { default: () => [] }
  },
  setup(s) {
    const e = s, t = B(void 0), a = (c) => {
      if (c === t.value) {
        t.value = void 0;
        return;
      }
      t.value = c;
    }, n = (c) => {
      if (c !== document.getElementById(e.id)) {
        if (!(c != null && c.parentNode)) {
          a(t.value);
          return;
        }
        n(c.parentNode);
      }
    }, i = (c) => {
      n(c.target);
    }, l = (c) => {
      c.key === "Escape" && a(t.value);
    };
    return ne(() => {
      document.addEventListener("click", i), document.addEventListener("keydown", l);
    }), be(() => {
      document.removeEventListener("click", i), document.removeEventListener("keydown", l);
    }), (c, u) => (r(), d("nav", {
      id: c.id,
      class: "fr-nav",
      role: "navigation",
      "aria-label": c.label
    }, [
      o("ul", js, [
        I(c.$slots, "default"),
        (r(!0), d(R, null, X(c.navItems, (p, h) => (r(), L(Lt, { key: h }, {
          default: F(() => [
            p.to && p.text ? (r(), L(He, E({
              key: 0,
              ref_for: !0
            }, p, {
              "expanded-id": t.value,
              onToggleId: u[0] || (u[0] = (f) => a(f))
            }), null, 16, ["expanded-id"])) : p.title && p.links ? (r(), L(zt, E({
              key: 1,
              ref_for: !0
            }, p, {
              "expanded-id": t.value,
              onToggleId: u[1] || (u[1] = (f) => a(f))
            }), null, 16, ["expanded-id"])) : p.title && p.menus ? (r(), L(Tt, E({
              key: 2,
              ref_for: !0
            }, p, {
              "expanded-id": t.value,
              onToggleId: u[2] || (u[2] = (f) => a(f))
            }), null, 16, ["expanded-id"])) : m("", !0)
          ]),
          _: 2
        }, 1024))), 128))
      ])
    ], 8, Os));
  }
}), Qs = { class: "fr-notice fr-notice--info" }, Gs = { class: "fr-container" }, Ks = { class: "fr-notice__body" }, Ws = { class: "fr-notice__title" }, Us = /* @__PURE__ */ D({
  __name: "DsfrNotice",
  props: {
    title: { default: "" },
    closeable: { type: Boolean }
  },
  emits: ["close"],
  setup(s) {
    return (e, t) => (r(), d("div", Qs, [
      o("div", Gs, [
        o("div", Ks, [
          o("p", Ws, [
            I(e.$slots, "default", {}, () => [
              z(v(e.title), 1)
            ])
          ]),
          e.closeable ? (r(), d("button", {
            key: 0,
            class: "fr-btn--close fr-btn",
            title: "Masquer le message",
            onClick: t[0] || (t[0] = (a) => e.$emit("close"))
          }, " Masquer le message ")) : m("", !0)
        ])
      ])
    ]));
  }
}), Zs = {
  role: "navigation",
  class: "fr-pagination",
  "aria-label": "Pagination"
}, Js = { class: "fr-pagination__list" }, xs = ["href", "title", "disabled", "aria-disabled"], eo = ["href", "title", "disabled", "aria-disabled"], to = ["href", "title", "aria-current", "onClick"], ao = { key: 0 }, no = { key: 1 }, ro = ["href", "title", "disabled", "aria-disabled"], lo = ["href", "title", "disabled", "aria-disabled"], so = /* @__PURE__ */ D({
  __name: "DsfrPagination",
  props: {
    pages: {},
    currentPage: { default: 0 },
    firstPageTitle: { default: "Première page" },
    lastPageTitle: { default: "Dernière page" },
    nextPageTitle: { default: "Page suivante" },
    prevPageTitle: { default: "Page précédente" },
    truncLimit: { default: 5 }
  },
  emits: ["update:currentPage"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = g(() => Math.min(t.pages.length - 1 - t.truncLimit, Math.max(t.currentPage - (t.truncLimit - t.truncLimit % 2) / 2, 0))), i = g(() => Math.min(t.pages.length - 1, n.value + t.truncLimit)), l = g(() => t.pages.length > t.truncLimit ? t.pages.slice(n.value, i.value + 1) : t.pages), c = (y) => a("update:currentPage", y), u = (y) => c(y), p = () => u(0), h = () => u(Math.max(0, t.currentPage - 1)), f = () => u(Math.min(t.pages.length - 1, t.currentPage + 1)), _ = () => u(t.pages.length - 1), $ = (y) => t.pages.indexOf(y) === t.currentPage;
    return (y, V) => {
      var b, M, H, S;
      return r(), d("nav", Zs, [
        o("ul", Js, [
          o("li", null, [
            o("a", {
              href: (b = y.pages[0]) == null ? void 0 : b.href,
              class: "fr-pagination__link fr-pagination__link--first",
              title: y.firstPageTitle,
              disabled: y.currentPage === 0 ? !0 : void 0,
              "aria-disabled": y.currentPage === 0 ? !0 : void 0,
              onClick: V[0] || (V[0] = W((A) => p(), ["prevent"]))
            }, null, 8, xs)
          ]),
          o("li", null, [
            o("a", {
              href: (M = y.pages[Math.max(y.currentPage - 1, 0)]) == null ? void 0 : M.href,
              class: "fr-pagination__link fr-pagination__link--prev fr-pagination__link--lg-label",
              title: y.prevPageTitle,
              disabled: y.currentPage === 0 ? !0 : void 0,
              "aria-disabled": y.currentPage === 0 ? !0 : void 0,
              onClick: V[1] || (V[1] = W((A) => h(), ["prevent"]))
            }, v(y.prevPageTitle), 9, eo)
          ]),
          (r(!0), d(R, null, X(l.value, (A, q) => (r(), d("li", { key: q }, [
            o("a", {
              href: A == null ? void 0 : A.href,
              class: "fr-pagination__link fr-unhidden-lg",
              title: A.title,
              "aria-current": $(A) ? "page" : void 0,
              onClick: W((P) => u(y.pages.indexOf(A)), ["prevent"])
            }, [
              l.value.indexOf(A) === 0 && n.value > 0 ? (r(), d("span", ao, "...")) : m("", !0),
              z(" " + v(A.label) + " ", 1),
              l.value.indexOf(A) === l.value.length - 1 && i.value < y.pages.length - 1 ? (r(), d("span", no, "...")) : m("", !0)
            ], 8, to)
          ]))), 128)),
          o("li", null, [
            o("a", {
              href: (H = y.pages[Math.min(y.currentPage + 1, y.pages.length - 1)]) == null ? void 0 : H.href,
              class: "fr-pagination__link fr-pagination__link--next fr-pagination__link--lg-label",
              title: y.nextPageTitle,
              disabled: y.currentPage === y.pages.length - 1 ? !0 : void 0,
              "aria-disabled": y.currentPage === y.pages.length - 1 ? !0 : void 0,
              onClick: V[2] || (V[2] = W((A) => f(), ["prevent"]))
            }, v(y.nextPageTitle), 9, ro)
          ]),
          o("li", null, [
            o("a", {
              class: "fr-pagination__link fr-pagination__link--last",
              href: (S = y.pages[y.pages.length - 1]) == null ? void 0 : S.href,
              title: y.lastPageTitle,
              disabled: y.currentPage === y.pages.length - 1 ? !0 : null,
              "aria-disabled": y.currentPage === y.pages.length - 1 ? !0 : void 0,
              onClick: V[3] || (V[3] = W((A) => _(), ["prevent"]))
            }, null, 8, lo)
          ])
        ])
      ]);
    };
  }
}), oo = /* @__PURE__ */ ae(so, [["__scopeId", "data-v-da6fd85b"]]), io = ["aria-label"], uo = { class: "fr-content-media__img" }, co = ["src", "alt", "title", "ratio"], fo = { class: "fr-content-media__caption" }, po = /* @__PURE__ */ D({
  __name: "DsfrPicture",
  props: {
    alt: { default: "" },
    legend: { default: "" },
    size: { default: "medium" },
    src: {},
    title: { default: "" },
    ratio: { default: "16x9" }
  },
  setup(s) {
    return (e, t) => (r(), d("figure", {
      class: C(["fr-content-media", {
        "fr-content-media--sm": e.size === "small",
        "fr-content-media--lg": e.size === "large"
      }]),
      role: "group",
      "aria-label": e.legend
    }, [
      o("div", uo, [
        I(e.$slots, "default", {}, () => [
          e.src ? (r(), d("img", {
            key: 0,
            src: e.src,
            class: C(["fr-responsive-img", `fr-ratio-${e.ratio}`]),
            alt: e.alt,
            title: e.title,
            ratio: e.ratio
          }, null, 10, co)) : m("", !0)
        ])
      ]),
      o("figcaption", fo, v(e.legend), 1)
    ], 10, io));
  }
}), ho = { class: "fr-quote fr-quote--column" }, vo = ["cite"], mo = { class: "fr-quote__author" }, go = { class: "fr-quote__source" }, bo = ["href"], yo = {
  key: 0,
  class: "fr-quote__image"
}, ko = ["src"], wo = /* @__PURE__ */ D({
  __name: "DsfrQuote",
  props: {
    quote: { default: void 0 },
    author: { default: void 0 },
    details: { default: () => [] },
    source: { default: "" },
    sourceUrl: { default: "" },
    quoteImage: { default: "" }
  },
  setup(s) {
    return (e, t) => (r(), d("figure", ho, [
      e.source ? (r(), d("blockquote", {
        key: 0,
        cite: e.sourceUrl
      }, [
        o("p", null, "« " + v(e.quote) + " »", 1)
      ], 8, vo)) : m("", !0),
      o("figcaption", null, [
        o("p", mo, v(e.author), 1),
        o("ul", go, [
          o("li", null, [
            o("cite", null, v(e.source), 1)
          ]),
          (r(!0), d(R, null, X(e.details, (a, n) => (r(), d("li", { key: n }, [
            typeof a == "object" ? (r(), d("a", {
              key: 0,
              target: "_blank",
              rel: "noopener noreferrer",
              href: a.url
            }, v(a.label), 9, bo)) : m("", !0),
            z(" " + v(typeof a != "object" ? a : ""), 1)
          ]))), 128))
        ]),
        e.quoteImage ? (r(), d("div", yo, [
          o("img", {
            src: e.quoteImage,
            class: "fr-responsive-img",
            alt: ""
          }, null, 8, ko)
        ])) : m("", !0)
      ])
    ]));
  }
}), _o = ["id", "name", "value", "checked", "disabled"], $o = ["for"], Do = {
  key: 0,
  class: "required"
}, Mo = {
  key: 0,
  class: "fr-hint-text"
}, Io = {
  key: 0,
  class: "fr-radio-rich__pictogram"
}, Lo = ["src"], Co = ["href"], zo = ["href"], So = ["href"], At = /* @__PURE__ */ D({
  __name: "DsfrRadioButton",
  props: {
    id: { default: () => j("basic", "radio") },
    name: {},
    modelValue: { type: [String, Number, Boolean], default: "" },
    disabled: { type: Boolean },
    small: { type: Boolean },
    inline: { type: Boolean },
    value: { type: [String, Number, Boolean] },
    label: { default: "" },
    hint: { default: "" },
    img: { default: void 0 },
    svgPath: { default: void 0 },
    svgAttrs: { default: () => ({ viewBox: "0 0 80 80", width: "80px", height: "80px" }) }
  },
  emits: ["update:modelValue"],
  setup(s) {
    const e = s, t = { viewBox: "0 0 80 80", width: "80px", height: "80px" }, a = g(() => !!e.img || !!e.svgPath);
    return (n, i) => (r(), d("div", {
      class: C(["fr-fieldset__element", { "fr-fieldset__element--inline": n.inline }])
    }, [
      o("div", {
        class: C(["fr-radio-group", {
          "fr-radio-rich": a.value,
          "fr-radio-group--sm": n.small
        }])
      }, [
        o("input", E({
          id: n.id,
          type: "radio",
          name: n.name,
          value: n.value,
          checked: n.modelValue === n.value,
          disabled: n.disabled
        }, n.$attrs, {
          onClick: i[0] || (i[0] = (l) => n.$emit("update:modelValue", n.value))
        }), null, 16, _o),
        o("label", {
          for: n.id,
          class: "fr-label"
        }, [
          I(n.$slots, "label", {}, () => [
            z(v(n.label) + " ", 1),
            I(n.$slots, "required-tip", {}, () => [
              n.$attrs.required ? (r(), d("span", Do, " *")) : m("", !0)
            ])
          ]),
          n.hint ? (r(), d("span", Mo, v(n.hint), 1)) : m("", !0)
        ], 8, $o),
        n.img || n.svgPath ? (r(), d("div", Io, [
          n.img ? (r(), d("img", {
            key: 0,
            src: n.img,
            class: "fr-artwork",
            alt: ""
          }, null, 8, Lo)) : (r(), d("svg", E({
            key: 1,
            "aria-hidden": "true",
            class: "fr-artwork"
          }, { ...t, ...n.svgAttrs }), [
            o("use", {
              class: "fr-artwork-decorative",
              href: `${n.svgPath}#artwork-decorative`
            }, null, 8, Co),
            o("use", {
              class: "fr-artwork-minor",
              href: `${n.svgPath}#artwork-minor`
            }, null, 8, zo),
            o("use", {
              class: "fr-artwork-major",
              href: `${n.svgPath}#artwork-major`
            }, null, 8, So)
          ], 16))
        ])) : m("", !0)
      ], 2)
    ], 2));
  }
}), To = { class: "fr-form-group" }, Ao = ["disabled", "aria-labelledby", "aria-invalid", "role"], Eo = ["id"], Ho = {
  key: 0,
  class: "fr-hint-text"
}, Bo = {
  key: 0,
  class: "required"
}, Vo = ["id"], Ro = { class: "line-1" }, Po = /* @__PURE__ */ D({
  __name: "DsfrRadioButtonSet",
  props: {
    titleId: { default: () => j("radio-button", "group") },
    disabled: { type: Boolean },
    required: { type: Boolean },
    small: { type: Boolean },
    inline: { type: Boolean },
    name: {},
    errorMessage: { default: "" },
    validMessage: { default: "" },
    legend: { default: "" },
    hint: { default: "" },
    modelValue: { type: [String, Number, Boolean] },
    options: { default: () => [] },
    ariaInvalid: { type: [Boolean, String] }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = g(() => t.errorMessage || t.validMessage), i = g(() => t.errorMessage ? "fr-error-text" : "fr-valid-text"), l = (u) => {
      u !== t.modelValue && a("update:modelValue", u);
    }, c = g(() => n.value ? `${t.titleId} messages-${t.titleId}` : t.titleId);
    return (u, p) => (r(), d("div", To, [
      o("fieldset", {
        class: C(["fr-fieldset", {
          "fr-fieldset--error": u.errorMessage,
          "fr-fieldset--valid": u.validMessage
        }]),
        disabled: u.disabled,
        "aria-labelledby": c.value,
        "aria-invalid": u.ariaInvalid,
        role: u.errorMessage || u.validMessage ? "group" : void 0
      }, [
        u.legend || u.$slots.legend || u.hint || u.$slots.hint ? (r(), d("legend", {
          key: 0,
          id: u.titleId,
          class: "fr-fieldset__legend fr-fieldset__legend--regular"
        }, [
          I(u.$slots, "legend", {}, () => [
            z(v(u.legend) + " ", 1),
            u.hint || u.$slots.hint ? (r(), d("span", Ho, [
              I(u.$slots, "hint", {}, () => [
                z(v(u.hint), 1)
              ])
            ])) : m("", !0),
            I(u.$slots, "required-tip", {}, () => [
              u.required ? (r(), d("span", Bo, " *")) : m("", !0)
            ])
          ])
        ], 8, Eo)) : m("", !0),
        I(u.$slots, "default", {}, () => [
          (r(!0), d(R, null, X(u.options, (h, f) => (r(), L(At, E({
            key: typeof h.value == "boolean" ? f : h.value || f,
            name: u.name,
            "aria-disabled": h.disabled,
            ref_for: !0
          }, h, {
            small: u.small,
            inline: u.inline,
            "model-value": u.modelValue,
            "onUpdate:modelValue": p[0] || (p[0] = (_) => l(_))
          }), null, 16, ["name", "aria-disabled", "small", "inline", "model-value"]))), 128))
        ]),
        n.value ? (r(), d("div", {
          key: 1,
          id: `messages-${u.titleId}`,
          class: "fr-messages-group",
          "aria-live": "assertive",
          role: "alert"
        }, [
          o("p", {
            class: C(["fr-message--info flex items-center", i.value])
          }, [
            o("span", Ro, v(n.value), 1)
          ], 2)
        ], 8, Vo)) : m("", !0)
      ], 10, Ao)
    ]));
  }
}), Fo = ["id"], No = ["id"], Xo = { class: "fr-hint-text" }, Yo = ["data-fr-prefix", "data-fr-suffix"], Oo = ["id", "min", "max", "step", "value", "disabled", "aria-disabled", "aria-labelledby", "aria-describedby"], jo = ["id", "min", "max", "step", "value", "disabled", "aria-disabled", "aria-labelledby", "aria-describedby"], qo = {
  key: 1,
  class: "fr-range__min",
  "aria-hidden": "true",
  "data-fr-js-range-limit": "true"
}, Qo = {
  key: 2,
  class: "fr-range__max",
  "aria-hidden": "true",
  "data-fr-js-range-limit": "true"
}, Go = ["id"], Ko = ["id"], Wo = /* @__PURE__ */ D({
  __name: "DsfrRange",
  props: {
    id: { default: () => j("range") },
    min: { default: 0 },
    max: { default: 100 },
    modelValue: { default: 0 },
    lowerValue: { default: void 0 },
    label: {},
    hint: { default: void 0 },
    message: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    small: { type: Boolean },
    hideIndicators: { type: Boolean },
    step: { default: void 0 },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "update:lowerValue"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = B(), i = B(), l = B(), c = g(() => t.lowerValue !== void 0), u = g(() => t.lowerValue === void 0 ? `transform: translateX(${(t.modelValue - t.min) / (t.max - t.min) * l.value}px) translateX(-${t.modelValue}%);` : `transform: translateX(${(t.modelValue + t.lowerValue - t.min) / 2 / (t.max - t.min) * l.value}px) translateX(-${t.lowerValue + (t.modelValue - t.lowerValue) / 2}%);`), p = g(() => {
      const f = (t.modelValue - t.min) / (t.max - t.min) * l.value - (c.value ? 12 : 0), _ = ((t.lowerValue ?? 0) - t.min) / (t.max - t.min) * l.value;
      return {
        "--progress-right": `${f + 24}px`,
        ...c.value ? { "--progress-left": `${_ + 12}px` } : {}
      };
    });
    te([() => t.modelValue, () => t.lowerValue], ([f, _]) => {
      _ !== void 0 && (c.value && f < _ && a("update:lowerValue", f), c.value && _ > f && a("update:modelValue", _));
    });
    const h = g(() => (t.prefix ?? "").concat(c.value ? `${t.lowerValue} - ` : "").concat(`${t.modelValue}`).concat(t.suffix ?? ""));
    return ne(() => {
      var f;
      l.value = (f = n.value) == null ? void 0 : f.offsetWidth;
    }), (f, _) => (r(), d("div", {
      id: `${f.id}-group`,
      class: C(["fr-range-group", { "fr-range-group--error": f.message }])
    }, [
      o("label", {
        id: `${f.id}-label`,
        class: "fr-label"
      }, [
        I(f.$slots, "label", {}, () => [
          z(v(f.label), 1)
        ]),
        o("span", Xo, [
          I(f.$slots, "hint", {}, () => [
            z(v(f.hint), 1)
          ])
        ])
      ], 8, No),
      o("div", {
        class: C(["fr-range", {
          "fr-range--sm": f.small,
          "fr-range--double": c.value,
          "fr-range-group--disabled": f.disabled
        }]),
        "data-fr-js-range": "true",
        "data-fr-prefix": f.prefix ?? void 0,
        "data-fr-suffix": f.suffix ?? void 0,
        style: ue(p.value)
      }, [
        o("span", {
          ref_key: "output",
          ref: i,
          class: "fr-range__output",
          "data-fr-js-range-output": "true",
          style: ue(u.value)
        }, v(h.value), 5),
        c.value ? (r(), d("input", {
          key: 0,
          id: `${f.id}-2`,
          type: "range",
          min: f.min,
          max: f.max,
          step: f.step,
          value: f.lowerValue,
          disabled: f.disabled,
          "aria-disabled": f.disabled,
          "aria-labelledby": `${f.id}-label`,
          "aria-describedby": `${f.id}-messages`,
          onInput: _[0] || (_[0] = ($) => {
            var y;
            return a("update:lowerValue", +((y = $.target) == null ? void 0 : y.value));
          })
        }, null, 40, Oo)) : m("", !0),
        o("input", {
          id: f.id,
          ref_key: "input",
          ref: n,
          type: "range",
          min: f.min,
          max: f.max,
          step: f.step,
          value: f.modelValue,
          disabled: f.disabled,
          "aria-disabled": f.disabled,
          "aria-labelledby": `${f.id}-label`,
          "aria-describedby": `${f.id}-messages`,
          onInput: _[1] || (_[1] = ($) => {
            var y;
            return a("update:modelValue", +((y = $.target) == null ? void 0 : y.value));
          })
        }, null, 40, jo),
        f.hideIndicators ? m("", !0) : (r(), d("span", qo, v(f.min), 1)),
        f.hideIndicators ? m("", !0) : (r(), d("span", Qo, v(f.max), 1))
      ], 14, Yo),
      f.message || f.$slots.messages ? (r(), d("div", {
        key: 0,
        id: `${f.id}-messages`,
        class: "fr-messages-group",
        "aria-live": "polite",
        role: "alert"
      }, [
        I(f.$slots, "messages", {}, () => [
          f.message ? (r(), d("p", {
            key: 0,
            id: `${f.id}-message-error`,
            class: "fr-message fr-message--error"
          }, v(f.message), 9, Ko)) : m("", !0)
        ])
      ], 8, Go)) : m("", !0)
    ], 10, Fo));
  }
}), Uo = { class: "fr-segmented__element" }, Zo = ["id", "name", "value", "checked", "disabled", "aria-disabled"], Jo = ["for"], xo = { key: 1 }, Et = /* @__PURE__ */ D({
  __name: "DsfrSegmented",
  props: {
    id: { default: () => j("basic", "checkbox") },
    name: { default: void 0 },
    modelValue: { default: "" },
    value: {},
    label: { default: "" },
    disabled: { type: Boolean },
    icon: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(s) {
    const e = s, t = g(() => typeof e.icon == "string" ? { name: e.icon } : e.icon), a = g(() => e.icon && typeof e.icon == "string" && e.icon.startsWith("fr-") ? e.icon : "");
    return (n, i) => (r(), d("div", Uo, [
      o("input", E({
        id: n.id,
        type: "radio",
        name: n.name,
        value: n.value,
        checked: n.modelValue === n.value,
        disabled: n.disabled,
        "aria-disabled": n.disabled
      }, n.$attrs, {
        onClick: i[0] || (i[0] = (l) => n.$emit("update:modelValue", n.value))
      }), null, 16, Zo),
      o("label", {
        for: n.id,
        class: C(["fr-label", { [a.value]: a.value }])
      }, [
        n.icon && !a.value ? (r(), L(N(le), re(E({ key: 0 }, t.value)), null, 16)) : m("", !0),
        n.icon ? (r(), d("span", xo, " ")) : m("", !0),
        z(" " + v(n.label), 1)
      ], 10, Jo)
    ]));
  }
}), ei = { class: "fr-form-group" }, ti = ["disabled"], ai = ["id"], ni = {
  key: 0,
  class: "fr-hint-text"
}, ri = { class: "fr-segmented__elements" }, li = /* @__PURE__ */ D({
  __name: "DsfrSegmentedSet",
  props: {
    titleId: { default: () => j("radio-button", "group") },
    disabled: { type: Boolean },
    small: { type: Boolean },
    inline: { type: Boolean },
    name: { default: "no-name" },
    hint: {},
    legend: { default: "" },
    modelValue: {},
    options: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = (i) => {
      i !== t.modelValue && a("update:modelValue", i);
    };
    return (i, l) => (r(), d("div", ei, [
      o("fieldset", {
        class: C(["fr-segmented", {
          "fr-segmented--sm": i.small,
          "fr-segmented--no-legend": !i.legend
        }]),
        disabled: i.disabled
      }, [
        i.legend ? (r(), d("legend", {
          key: 0,
          id: i.titleId,
          class: C(["fr-segmented__legend", {
            "fr-segmented__legend--inline": i.inline
          }])
        }, [
          I(i.$slots, "legend", {}, () => [
            z(v(i.legend), 1)
          ]),
          i.hint ? (r(), d("span", ni, v(i.hint), 1)) : m("", !0)
        ], 10, ai)) : m("", !0),
        o("div", ri, [
          I(i.$slots, "default", {}, () => [
            (r(!0), d(R, null, X(i.options, (c, u) => (r(), L(Et, E({
              key: c.value || u,
              name: i.name || c.name,
              ref_for: !0
            }, { ...c, disabled: i.disabled || c.disabled }, {
              "model-value": i.modelValue,
              "onUpdate:modelValue": l[0] || (l[0] = (p) => n(p))
            }), null, 16, ["name", "model-value"]))), 128))
          ])
        ])
      ], 10, ti)
    ]));
  }
}), si = ["for"], oi = {
  key: 0,
  class: "required"
}, ii = {
  key: 0,
  class: "fr-hint-text"
}, di = ["id", "name", "disabled", "aria-disabled", "required"], ui = ["selected"], ci = ["selected", "value", "disabled", "aria-disabled"], fi = ["id"], pi = /* @__PURE__ */ D({
  inheritAttrs: !1,
  __name: "DsfrSelect",
  props: {
    required: { type: Boolean },
    disabled: { type: Boolean },
    selectId: { default: () => j("select") },
    name: { default: void 0 },
    description: { default: void 0 },
    modelValue: { default: void 0 },
    label: { default: "" },
    options: { default: () => [] },
    successMessage: { default: "" },
    errorMessage: { default: "" },
    defaultUnselectedText: { default: "Sélectionner une option" }
  },
  emits: ["update:modelValue"],
  setup(s) {
    const e = s, t = g(() => e.errorMessage || e.successMessage), a = g(() => e.errorMessage ? "error" : "valid");
    return (n, i) => (r(), d("div", {
      class: C(["fr-select-group", { [`fr-select-group--${a.value}`]: t.value }])
    }, [
      o("label", {
        class: "fr-label",
        for: n.selectId
      }, [
        I(n.$slots, "label", {}, () => [
          z(v(n.label) + " ", 1),
          I(n.$slots, "required-tip", {}, () => [
            n.required ? (r(), d("span", oi, " *")) : m("", !0)
          ])
        ]),
        n.description ? (r(), d("span", ii, v(n.description), 1)) : m("", !0)
      ], 8, si),
      o("select", E({
        id: n.selectId,
        class: [{ [`fr-select--${a.value}`]: t.value }, "fr-select"],
        name: n.name || n.selectId,
        disabled: n.disabled,
        "aria-disabled": n.disabled,
        required: n.required
      }, n.$attrs, {
        onChange: i[0] || (i[0] = (l) => {
          var c;
          return n.$emit("update:modelValue", (c = l.target) == null ? void 0 : c.value);
        })
      }), [
        o("option", {
          selected: n.modelValue == null,
          disabled: "",
          hidden: ""
        }, v(n.defaultUnselectedText), 9, ui),
        (r(!0), d(R, null, X(n.options, (l, c) => (r(), d("option", {
          key: c,
          selected: n.modelValue === l || typeof l == "object" && l.value === n.modelValue,
          value: typeof l == "object" ? l.value : l,
          disabled: !!(typeof l == "object" && l.disabled),
          "aria-disabled": !!(typeof l == "object" && l.disabled)
        }, v(typeof l == "object" ? l.text : l), 9, ci))), 128))
      ], 16, di),
      t.value ? (r(), d("p", {
        key: 0,
        id: `select-${a.value}-desc-${a.value}`,
        class: C(`fr-${a.value}-text`)
      }, v(t.value), 11, fi)) : m("", !0)
    ], 2));
  }
}), hi = { class: "fr-share" }, vi = { class: "fr-share__title" }, mi = { class: "fr-btns-group" }, gi = ["title", "href", "onClick"], bi = { key: 0 }, yi = ["href", "title"], ki = ["title"], wi = /* @__PURE__ */ D({
  __name: "DsfrShare",
  props: {
    title: { default: "Partager la page" },
    copyLabel: { default: "Copier dans le presse-papier" },
    mail: { default: () => {
    } },
    networks: { default: () => [] }
  },
  setup(s) {
    const e = () => {
      const a = window.location.href;
      navigator.clipboard.writeText(a);
    }, t = ({ url: a, label: n }) => {
      window.open(
        a,
        n,
        "toolbar=no,location=yes,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=450"
      );
    };
    return (a, n) => {
      var i;
      return r(), d("div", hi, [
        o("p", vi, v(a.title), 1),
        o("ul", mi, [
          (r(!0), d(R, null, X(a.networks, (l, c) => (r(), d("li", { key: c }, [
            o("a", {
              class: C(`fr-btn fr-btn--${l.name}`),
              title: `${l.label} - nouvelle fenêtre`,
              href: l.url,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: W((u) => t(l), ["prevent"])
            }, v(l.label), 11, gi)
          ]))), 128)),
          (i = a.mail) != null && i.to ? (r(), d("li", bi, [
            o("a", {
              class: "fr-btn fr-btn--mail",
              href: a.mail.to,
              title: a.mail.label,
              target: "_blank",
              rel: "noopener noreferrer"
            }, v(a.mail.label), 9, yi)
          ])) : m("", !0),
          o("li", null, [
            o("button", {
              class: "fr-btn fr-btn--copy",
              title: a.copyLabel,
              onClick: n[0] || (n[0] = (l) => e())
            }, v(a.copyLabel), 9, ki)
          ])
        ])
      ]);
    };
  }
}), Ht = /* @__PURE__ */ D({
  __name: "DsfrSideMenuListItem",
  props: {
    active: { type: Boolean }
  },
  setup(s) {
    return (e, t) => (r(), d("li", {
      class: C(["fr-sidemenu__item", { "fr-sidemenu__item--active": e.active }])
    }, [
      I(e.$slots, "default")
    ], 2));
  }
}), _i = ["aria-current", "aria-expanded", "aria-controls"], Bt = /* @__PURE__ */ D({
  __name: "DsfrSideMenuButton",
  props: {
    active: { type: Boolean },
    expanded: { type: Boolean },
    controlId: {}
  },
  emits: ["toggleExpand"],
  setup(s) {
    return (e, t) => (r(), d("button", {
      class: "fr-sidemenu__btn",
      "aria-current": e.active ? "page" : void 0,
      "aria-expanded": !!e.expanded,
      "aria-controls": e.controlId,
      onClick: t[0] || (t[0] = (a) => e.$emit("toggleExpand", e.controlId))
    }, [
      I(e.$slots, "default")
    ], 8, _i));
  }
}), $i = ["id"], Di = { class: "fr-sidemenu__list" }, Vt = /* @__PURE__ */ D({
  __name: "DsfrSideMenuList",
  props: {
    id: {},
    collapsable: { type: Boolean },
    expanded: { type: Boolean },
    menuItems: { default: () => [] }
  },
  emits: ["toggleExpand"],
  setup(s) {
    const e = s, {
      collapse: t,
      collapsing: a,
      cssExpanded: n,
      doExpand: i,
      onTransitionEnd: l
    } = ce();
    te(() => e.expanded, (h, f) => {
      h !== f && i(h);
    }), ne(() => {
      e.expanded && i(!0);
    });
    const c = (h) => typeof h == "string" && h.startsWith("http"), u = (h) => c(h) ? "a" : "RouterLink", p = (h) => ({ [c(h) ? "href" : "to"]: h });
    return (h, f) => {
      const _ = se("DsfrSideMenuList", !0);
      return r(), d("div", {
        id: h.id,
        ref_key: "collapse",
        ref: t,
        class: C({
          "fr-collapse": h.collapsable,
          "fr-collapsing": N(a),
          "fr-collapse--expanded": N(n)
        }),
        onTransitionend: f[2] || (f[2] = ($) => N(l)(!!h.expanded))
      }, [
        o("ul", Di, [
          I(h.$slots, "default"),
          (r(!0), d(R, null, X(h.menuItems, ($, y) => (r(), L(Ht, {
            key: y,
            active: $.active
          }, {
            default: F(() => [
              $.menuItems ? m("", !0) : (r(), L(J(u($.to)), E({
                key: 0,
                class: "fr-sidemenu__link",
                "aria-current": $.active ? "page" : void 0,
                ref_for: !0
              }, p($.to)), {
                default: F(() => [
                  z(v($.text), 1)
                ]),
                _: 2
              }, 1040, ["aria-current"])),
              $.menuItems ? (r(), d(R, { key: 1 }, [
                G(Bt, {
                  active: !!$.active,
                  expanded: !!$.expanded,
                  "control-id": $.id,
                  onToggleExpand: f[0] || (f[0] = (V) => h.$emit("toggleExpand", V))
                }, {
                  default: F(() => [
                    z(v($.text), 1)
                  ]),
                  _: 2
                }, 1032, ["active", "expanded", "control-id"]),
                $.menuItems ? (r(), L(_, {
                  key: 0,
                  id: $.id,
                  collapsable: "",
                  expanded: $.expanded,
                  "menu-items": $.menuItems,
                  onToggleExpand: f[1] || (f[1] = (V) => h.$emit("toggleExpand", V))
                }, null, 8, ["id", "expanded", "menu-items"])) : m("", !0)
              ], 64)) : m("", !0)
            ]),
            _: 2
          }, 1032, ["active"]))), 128))
        ])
      ], 42, $i);
    };
  }
}), Mi = ["aria-labelledby"], Ii = { class: "fr-sidemenu__inner" }, Li = ["aria-controls", "aria-expanded"], Ci = ["id"], zi = { class: "fr-sidemenu__title" }, Si = /* @__PURE__ */ D({
  __name: "DsfrSideMenu",
  props: {
    buttonLabel: { default: "Dans cette rubrique" },
    id: { default: () => j("sidemenu") },
    sideMenuListId: { default: () => j("sidemenu", "list") },
    collapseValue: { default: "-492px" },
    menuItems: { default: () => {
    } },
    headingTitle: { default: "" }
  },
  emits: ["toggleExpand"],
  setup(s) {
    const {
      collapse: e,
      collapsing: t,
      cssExpanded: a,
      doExpand: n,
      onTransitionEnd: i
    } = ce(), l = B(!1);
    return te(l, (c, u) => {
      c !== u && n(c);
    }), (c, u) => (r(), d("nav", {
      class: "fr-sidemenu",
      "aria-labelledby": c.id
    }, [
      o("div", Ii, [
        o("button", {
          class: "fr-sidemenu__btn",
          "aria-controls": c.id,
          "aria-expanded": l.value,
          onClick: u[0] || (u[0] = W((p) => l.value = !l.value, ["prevent", "stop"]))
        }, v(c.buttonLabel), 9, Li),
        o("div", {
          id: c.id,
          ref_key: "collapse",
          ref: e,
          class: C(["fr-collapse", {
            "fr-collapse--expanded": N(a),
            // Need to use a separate data to add/remove the class after a RAF
            "fr-collapsing": N(t)
          }]),
          onTransitionend: u[2] || (u[2] = (p) => N(i)(l.value))
        }, [
          o("div", zi, v(c.headingTitle), 1),
          I(c.$slots, "default", {}, () => [
            G(Vt, {
              id: c.sideMenuListId,
              "menu-items": c.menuItems,
              onToggleExpand: u[1] || (u[1] = (p) => c.$emit("toggleExpand", p))
            }, null, 8, ["id", "menu-items"])
          ])
        ], 42, Ci)
      ])
    ], 8, Mi));
  }
}), Ti = /* @__PURE__ */ D({
  __name: "DsfrSideMenuLink",
  props: {
    active: { type: Boolean },
    to: { default: "" }
  },
  emits: ["toggle-expand"],
  setup(s) {
    const e = s, t = g(() => typeof e.to == "string" && e.to.startsWith("http")), a = g(() => t.value ? "a" : "RouterLink"), n = g(() => ({ [t.value ? "href" : "to"]: e.to }));
    return (i, l) => (r(), L(J(a.value), E({
      "aria-current": i.active ? "page" : void 0,
      class: "fr-sidemenu__link"
    }, n.value), {
      default: F(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-current"]));
  }
}), Ai = { class: "fr-skiplinks" }, Ei = {
  class: "fr-container",
  role: "navigation",
  "aria-label": "Accès rapide"
}, Hi = { class: "fr-skiplinks__list" }, Bi = ["href", "onClick"], Vi = /* @__PURE__ */ D({
  __name: "DsfrSkipLinks",
  props: {
    links: {}
  },
  setup(s) {
    const e = (t) => {
      const a = document.getElementById(t);
      a == null || a.focus();
    };
    return (t, a) => (r(), d("div", Ai, [
      o("nav", Ei, [
        o("ul", Hi, [
          (r(!0), d(R, null, X(t.links, (n) => (r(), d("li", {
            key: n.id
          }, [
            o("a", {
              class: "fr-link",
              href: `#${n.id}`,
              onClick: W((i) => e(n.id), ["prevent"])
            }, v(n.text), 9, Bi)
          ]))), 128))
        ])
      ])
    ]));
  }
}), Ri = { class: "fr-stepper" }, Pi = { class: "fr-stepper__title" }, Fi = { class: "fr-stepper__state" }, Ni = ["data-fr-current-step", "data-fr-steps"], Xi = { class: "fr-stepper__details" }, Yi = {
  key: 0,
  class: "fr-text--bold"
}, Oi = /* @__PURE__ */ D({
  __name: "DsfrStepper",
  props: {
    steps: { default: () => [] },
    currentStep: { default: 1 }
  },
  setup(s) {
    return (e, t) => (r(), d("div", Ri, [
      o("h2", Pi, [
        z(v(e.steps[e.currentStep - 1]) + " ", 1),
        o("span", Fi, "Étape " + v(e.currentStep) + " sur " + v(e.steps.length), 1)
      ]),
      o("div", {
        class: "fr-stepper__steps",
        "data-fr-current-step": e.currentStep,
        "data-fr-steps": e.steps.length
      }, null, 8, Ni),
      o("p", Xi, [
        e.currentStep < e.steps.length ? (r(), d("span", Yi, "Étape suivante :")) : m("", !0),
        z(" " + v(e.steps[e.currentStep]), 1)
      ])
    ]));
  }
}), ji = {
  class: "fr-summary",
  role: "navigation",
  "aria-labelledby": "fr-summary-title"
}, qi = {
  id: "fr-summary-title",
  class: "fr-summary__title"
}, Qi = { class: "fr-summary__list" }, Gi = ["href"], Ki = /* @__PURE__ */ D({
  __name: "DsfrSummary",
  props: {
    title: { default: "Sommaire" },
    anchors: { default: () => [] }
  },
  setup(s) {
    return (e, t) => (r(), d("nav", ji, [
      o("h2", qi, v(e.title), 1),
      o("ol", Qi, [
        (r(!0), d(R, null, X(e.anchors, (a, n) => (r(), d("li", { key: n }, [
          o("a", {
            class: "fr-summary__link",
            href: a.link
          }, v(a.name), 9, Gi)
        ]))), 128))
      ])
    ]));
  }
}), Wi = { role: "presentation" }, Ui = ["id", "data-testid", "tabindex", "aria-selected", "aria-controls"], Zi = {
  key: 0,
  style: { "margin-left": "-0.25rem", "margin-right": "0.5rem", "font-size": "0.95rem" }
}, Rt = /* @__PURE__ */ D({
  __name: "DsfrTabItem",
  props: {
    panelId: {},
    tabId: {},
    selected: { type: Boolean },
    icon: { default: void 0 }
  },
  emits: ["click", "next", "previous", "first", "last"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = B(null);
    te(() => t.selected, (c) => {
      var u;
      c && ((u = n.value) == null || u.focus());
    });
    const i = {
      ArrowRight: "next",
      ArrowLeft: "previous",
      ArrowDown: "next",
      ArrowUp: "previous",
      Home: "first",
      End: "last"
    };
    function l(c) {
      const u = c == null ? void 0 : c.key, p = i[u];
      p && a(p);
    }
    return (c, u) => (r(), d("li", Wi, [
      o("button", {
        id: c.tabId,
        ref_key: "button",
        ref: n,
        "data-testid": `test-${c.tabId}`,
        class: "fr-tabs__tab",
        tabindex: c.selected ? 0 : -1,
        role: "tab",
        type: "button",
        "aria-selected": c.selected,
        "aria-controls": c.panelId,
        onClick: u[0] || (u[0] = W((p) => c.$emit("click", p), ["prevent"])),
        onKeydown: u[1] || (u[1] = (p) => l(p))
      }, [
        c.icon ? (r(), d("span", Zi, [
          G(N(le), { name: c.icon }, null, 8, ["name"])
        ])) : m("", !0),
        I(c.$slots, "default")
      ], 40, Ui)
    ]));
  }
}), Ji = ["id", "aria-labelledby", "tabindex"], xi = /* @__PURE__ */ D({
  __name: "DsfrTabContent",
  props: {
    asc: { type: Boolean },
    selected: { type: Boolean },
    panelId: {},
    tabId: {}
  },
  setup(s) {
    ea((i) => ({
      "71a34239": a.value,
      "6beade6c": n.value
    }));
    const e = s, t = { true: "100%", false: "-100%" }, a = g(() => t[String(e.asc)]), n = g(() => t[String(!e.asc)]);
    return (i, l) => (r(), L(dt, {
      name: "slide-fade",
      mode: "in-out"
    }, {
      default: F(() => [
        Oe(o("div", {
          id: i.panelId,
          class: C(["fr-tabs__panel", {
            "fr-tabs__panel--selected": i.selected
          }]),
          role: "tabpanel",
          "aria-labelledby": i.tabId,
          tabindex: i.selected ? 0 : -1
        }, [
          I(i.$slots, "default", {}, void 0, !0)
        ], 10, Ji), [
          [ut, i.selected]
        ])
      ]),
      _: 3
    }));
  }
}), Pt = /* @__PURE__ */ ae(xi, [["__scopeId", "data-v-f60b34d7"]]), ed = ["aria-label"], td = /* @__PURE__ */ D({
  __name: "DsfrTabs",
  props: {
    tabListName: {},
    tabTitles: { default: () => [] },
    tabContents: { default: () => [] },
    initialSelectedIndex: { default: 0 }
  },
  emits: ["selectTab"],
  setup(s, { expose: e, emit: t }) {
    const a = s, n = t, i = B(a.initialSelectedIndex || 0), l = ta({}), c = B(!0), u = B(null), p = B(null), h = B(null), f = (S) => i.value === S, _ = () => {
      var P, Z;
      if (i.value < 0 || !h.value || !h.value.offsetHeight)
        return;
      const S = h.value.offsetHeight, A = (P = p.value) == null ? void 0 : P.querySelectorAll(".fr-tabs__panel")[i.value];
      if (!A || !A.offsetHeight)
        return;
      const q = A.offsetHeight;
      (Z = p.value) == null || Z.style.setProperty("--tabs-height", `${S + q}px`);
    }, $ = (S) => {
      if (l[S])
        return l[S];
      const A = j("tab");
      return l[S] = A, A;
    }, y = async (S) => {
      c.value = S > i.value, i.value = S, n("selectTab", S);
    }, V = async () => {
      const S = i.value === 0 ? a.tabTitles.length - 1 : i.value - 1;
      await y(S);
    }, b = async () => {
      const S = i.value === a.tabTitles.length - 1 ? 0 : i.value + 1;
      await y(S);
    }, M = async () => {
      await y(0);
    }, H = async () => {
      await y(a.tabTitles.length - 1);
    };
    return ne(() => {
      var S;
      window.ResizeObserver && (u.value = new window.ResizeObserver(() => {
        _();
      })), (S = p.value) == null || S.querySelectorAll(".fr-tabs__panel").forEach((A) => {
        var q;
        A && ((q = u.value) == null || q.observe(A));
      });
    }), be(() => {
      var S;
      (S = p.value) == null || S.querySelectorAll(".fr-tabs__panel").forEach((A) => {
        var q;
        A && ((q = u.value) == null || q.unobserve(A));
      });
    }), e({
      renderTabs: _,
      selectIndex: y,
      selectFirst: M,
      selectLast: H
    }), (S, A) => (r(), d("div", {
      ref_key: "$el",
      ref: p,
      class: "fr-tabs"
    }, [
      o("ul", {
        ref_key: "tablist",
        ref: h,
        class: "fr-tabs__list",
        role: "tablist",
        "aria-label": S.tabListName
      }, [
        I(S.$slots, "tab-items", {}, () => [
          (r(!0), d(R, null, X(S.tabTitles, (q, P) => (r(), L(Rt, {
            key: P,
            icon: q.icon,
            "panel-id": q.panelId || `${$(P)}-panel`,
            "tab-id": q.tabId || $(P),
            selected: f(P),
            onClick: (Z) => y(P),
            onNext: A[0] || (A[0] = (Z) => b()),
            onPrevious: A[1] || (A[1] = (Z) => V()),
            onFirst: A[2] || (A[2] = (Z) => M()),
            onLast: A[3] || (A[3] = (Z) => H())
          }, {
            default: F(() => [
              z(v(q.title), 1)
            ]),
            _: 2
          }, 1032, ["icon", "panel-id", "tab-id", "selected", "onClick"]))), 128))
        ])
      ], 8, ed),
      (r(!0), d(R, null, X(S.tabContents, (q, P) => {
        var Z, fe, ie, oe;
        return r(), L(Pt, {
          key: P,
          "panel-id": ((fe = (Z = S.tabTitles) == null ? void 0 : Z[P]) == null ? void 0 : fe.panelId) || `${$(P)}-panel`,
          "tab-id": ((oe = (ie = S.tabTitles) == null ? void 0 : ie[P]) == null ? void 0 : oe.tabId) || $(P),
          selected: f(P),
          asc: c.value
        }, {
          default: F(() => [
            o("p", null, v(q), 1)
          ]),
          _: 2
        }, 1032, ["panel-id", "tab-id", "selected", "asc"]);
      }), 128)),
      I(S.$slots, "default")
    ], 512));
  }
}), Ft = /* @__PURE__ */ D({
  __name: "DsfrTableCell",
  props: {
    field: {},
    cellAttrs: { default: () => ({}) },
    component: {},
    text: {},
    title: {},
    class: {},
    onClick: {}
  },
  setup(s) {
    const e = s, t = g(() => typeof e.field == "object" && e.field !== null && e.field.component ? e.field.component : !1), a = g(() => ["string", "number", "boolean"].includes(typeof e.field));
    return (n, i) => (r(), d("td", re(je(n.cellAttrs)), [
      t.value ? (r(), L(J(t.value), re(E({ key: 0 }, typeof n.field == "object" ? n.field : {})), {
        default: F(() => [
          z(v(n.field.text), 1)
        ]),
        _: 1
      }, 16)) : (r(), d(R, { key: 1 }, [
        z(v(a.value ? n.field : n.field.text), 1)
      ], 64))
    ], 16));
  }
}), Nt = /* @__PURE__ */ D({
  __name: "DsfrTableRow",
  props: {
    rowData: { default: () => [] },
    rowAttrs: { default: () => ({}) }
  },
  setup(s) {
    return (e, t) => (r(), d("tr", re(je(e.rowAttrs)), [
      I(e.$slots, "default"),
      (r(!0), d(R, null, X(e.rowData, (a, n) => (r(), L(Ft, {
        key: n,
        field: a ?? "",
        "cell-attrs": typeof a == "object" && a !== null && !a.component ? a.cellAttrs : {}
      }, null, 8, ["field", "cell-attrs"]))), 128))
    ], 16));
  }
}), Xt = /* @__PURE__ */ D({
  __name: "DsfrTableHeader",
  props: {
    header: { default: "" },
    headerAttrs: { default: () => ({}) },
    icon: { default: void 0 }
  },
  setup(s) {
    const e = s, t = g(() => e.icon && typeof e.icon == "string" && e.icon.startsWith("fr-") ? e.icon : ""), a = g(() => t.value ? void 0 : typeof e.icon == "string" ? { name: e.icon } : e.icon);
    return (n, i) => (r(), d("th", E(n.headerAttrs, { scope: "col" }), [
      z(v(n.header) + " ", 1),
      n.icon && !t.value ? (r(), L(N(le), re(E({ key: 0 }, a.value)), null, 16)) : m("", !0),
      t.value ? (r(), d("span", {
        key: 1,
        class: C({ [String(n.icon)]: t.value })
      }, null, 2)) : m("", !0)
    ], 16));
  }
}), ad = { key: 0 }, Yt = /* @__PURE__ */ D({
  __name: "DsfrTableHeaders",
  props: {
    headers: {}
  },
  setup(s) {
    return (e, t) => e.headers ? (r(), d("tr", ad, [
      (r(!0), d(R, null, X(e.headers, (a, n) => (r(), L(Xt, {
        key: n,
        header: (typeof a == "object" ? a : {}).text || a,
        "header-attrs": a.headerAttrs
      }, null, 8, ["header", "header-attrs"]))), 128))
    ])) : m("", !0);
  }
}), nd = (s) => (ct("data-v-d7bee41c"), s = s(), ft(), s), rd = { class: "caption" }, ld = { key: 1 }, sd = ["colspan"], od = { class: "flex justify-right" }, id = { class: "self-center" }, dd = /* @__PURE__ */ nd(() => /* @__PURE__ */ o("span", null, "Résultats par page : ", -1)), ud = ["value"], cd = { class: "flex ml-1" }, fd = { class: "self-center" }, pd = { class: "flex ml-1" }, hd = /* @__PURE__ */ D({
  __name: "DsfrTable",
  props: {
    title: {},
    headers: { default: () => [] },
    rows: { default: () => [] },
    rowKey: { type: [Function, String], default: void 0 },
    noCaption: { type: Boolean },
    pagination: { type: Boolean },
    currentPage: { default: 1 },
    resultsDisplayed: { default: 10 }
  },
  emits: ["update:currentPage"],
  setup(s, { emit: e }) {
    const t = s, a = e, n = (b) => Array.isArray(b) ? b : b.rowData, i = B(t.currentPage), l = B(t.resultsDisplayed), c = B(
      t.rows.length > l.value ? Math.ceil(t.rows.length / l.value) : 1
    ), u = [5, 10, 25, 50, 100], p = () => i.value * l.value - l.value, h = () => i.value * l.value;
    te(
      () => l.value,
      (b) => {
        c.value = t.rows.length > l.value ? Math.ceil(t.rows.length / b) : 1;
      }
    );
    const f = g(() => t.pagination ? t.rows.slice(p(), h()) : t.rows), _ = () => {
      i.value = 1, a("update:currentPage");
    }, $ = () => {
      i.value > 1 && (i.value -= 1, a("update:currentPage"));
    }, y = () => {
      i.value < c.value && (i.value += 1, a("update:currentPage"));
    }, V = () => {
      i.value = c.value, a("update:currentPage");
    };
    return (b, M) => (r(), d("div", {
      class: C(["fr-table", { "fr-table--no-caption": b.noCaption }])
    }, [
      o("table", null, [
        o("caption", rd, v(b.title), 1),
        o("thead", null, [
          I(b.$slots, "header", {}, () => [
            b.headers && b.headers.length ? (r(), L(Yt, {
              key: 0,
              headers: b.headers
            }, null, 8, ["headers"])) : m("", !0)
          ], !0)
        ]),
        o("tbody", null, [
          I(b.$slots, "default", {}, void 0, !0),
          b.rows && b.rows.length ? (r(!0), d(R, { key: 0 }, X(f.value, (H, S) => (r(), L(Nt, {
            key: b.rowKey && n(H) ? typeof b.rowKey == "string" ? n(H)[b.headers.indexOf(b.rowKey)].toString() : b.rowKey(n(H)) : S,
            "row-data": n(H),
            "row-attrs": "rowAttrs" in H ? H.rowAttrs : {}
          }, null, 8, ["row-data", "row-attrs"]))), 128)) : m("", !0),
          b.pagination ? (r(), d("tr", ld, [
            o("td", {
              colspan: b.headers.length
            }, [
              o("div", od, [
                o("div", id, [
                  dd,
                  Oe(o("select", {
                    "onUpdate:modelValue": M[0] || (M[0] = (H) => l.value = H),
                    onChange: M[1] || (M[1] = (H) => a("update:currentPage"))
                  }, [
                    (r(), d(R, null, X(u, (H, S) => o("option", {
                      key: S,
                      value: H
                    }, v(H), 9, ud)), 64))
                  ], 544), [
                    [aa, l.value]
                  ])
                ]),
                o("div", cd, [
                  o("span", fd, "Page " + v(i.value) + " sur " + v(c.value), 1)
                ]),
                o("div", pd, [
                  o("button", {
                    class: "fr-icon-arrow-left-s-first-line",
                    onClick: M[2] || (M[2] = (H) => _())
                  }),
                  o("button", {
                    class: "fr-icon-arrow-left-s-line",
                    onClick: M[3] || (M[3] = (H) => $())
                  }),
                  o("button", {
                    class: "fr-icon-arrow-right-s-line",
                    onClick: M[4] || (M[4] = (H) => y())
                  }),
                  o("button", {
                    class: "fr-icon-arrow-right-s-last-line",
                    onClick: M[5] || (M[5] = (H) => V())
                  })
                ])
              ])
            ], 8, sd)
          ])) : m("", !0)
        ])
      ])
    ], 2));
  }
}), vd = /* @__PURE__ */ ae(hd, [["__scopeId", "data-v-d7bee41c"]]), it = 0.9, md = /* @__PURE__ */ D({
  __name: "DsfrTag",
  props: {
    label: { default: void 0 },
    link: { default: void 0 },
    tagName: { default: "p" },
    icon: { default: void 0 },
    disabled: { type: Boolean },
    small: { type: Boolean },
    iconOnly: { type: Boolean }
  },
  setup(s) {
    const e = s, t = g(() => typeof e.link == "string" && e.link.startsWith("http")), a = g(() => e.link ? t.value ? "a" : "RouterLink" : e.disabled && e.tagName === "p" ? "button" : e.tagName), n = g(() => ({ [t.value ? "href" : "to"]: e.link })), i = g(() => typeof e.icon == "string" && e.icon.startsWith("fr-icon-")), l = g(() => i.value ? void 0 : typeof e.icon == "string" ? { name: e.icon, scale: it } : { scale: it, ...e.icon ?? {} });
    return (c, u) => (r(), L(J(a.value), E({
      class: ["fr-tag", {
        "fr-tag--sm": c.small,
        [c.icon]: i.value,
        "fr-tag--icon-left": i.value
      }],
      disabled: c.disabled
    }, n.value), {
      default: F(() => [
        e.icon && !i.value ? (r(), L(N(le), E({
          key: 0,
          label: c.iconOnly ? c.label : void 0,
          class: "fr-mr-1v"
        }, l.value), null, 16, ["label"])) : m("", !0),
        c.iconOnly ? m("", !0) : (r(), d(R, { key: 1 }, [
          z(v(c.label), 1)
        ], 64)),
        I(c.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["disabled", "class"]));
  }
}), Ot = /* @__PURE__ */ ae(md, [["__scopeId", "data-v-a225f0e1"]]), gd = { class: "fr-tags-group" }, bd = /* @__PURE__ */ D({
  __name: "DsfrTags",
  props: {
    tags: { default: () => [] }
  },
  setup(s) {
    return (e, t) => (r(), d("ul", gd, [
      (r(!0), d(R, null, X(e.tags, ({ icon: a, label: n, ...i }, l) => (r(), d("li", { key: l }, [
        G(Ot, E({ ref_for: !0 }, i, {
          icon: a,
          label: n
        }), null, 16, ["icon", "label"])
      ]))), 128))
    ]));
  }
}), yd = { class: "fr-tile__body" }, kd = { class: "fr-tile__content" }, wd = ["download", "href"], _d = {
  key: 0,
  class: "fr-tile__desc"
}, $d = {
  key: 1,
  class: "fr-tile__detail"
}, Dd = {
  key: 2,
  class: "fr-tile__start"
}, Md = { class: "fr-tile__header" }, Id = {
  key: 0,
  class: "fr-tile__pictogram"
}, Ld = ["src"], Cd = ["href"], zd = ["href"], Sd = ["href"], Td = /* @__PURE__ */ D({
  __name: "DsfrTile",
  props: {
    title: { default: "Titre de la tuile" },
    imgSrc: { default: void 0 },
    svgPath: { default: void 0 },
    svgAttrs: { default: () => ({ viewBox: "0 0 80 80", width: "80px", height: "80px" }) },
    description: { default: void 0 },
    details: { default: void 0 },
    disabled: { type: Boolean },
    horizontal: { type: Boolean, default: !1 },
    vertical: { default: void 0 },
    to: { default: "#" },
    titleTag: { default: "h3" },
    download: { type: Boolean },
    small: { type: Boolean },
    icon: { type: Boolean, default: !0 },
    noBorder: { type: Boolean },
    shadow: { type: Boolean },
    noBackground: { type: Boolean },
    grey: { type: Boolean }
  },
  setup(s) {
    const e = s, t = { viewBox: "0 0 80 80", width: "80px", height: "80px" }, a = g(() => typeof e.to == "string" && e.to.startsWith("http"));
    return (n, i) => {
      const l = se("RouterLink");
      return r(), d("div", {
        class: C(["fr-tile fr-enlarge-link", [{
          "fr-tile--disabled": n.disabled,
          "fr-tile--sm": n.small === !0,
          "fr-tile--horizontal": n.horizontal === !0,
          "fr-tile--vertical": n.horizontal === !1 || n.vertical === "md" || n.vertical === "lg",
          "fr-tile--vertical@md": n.vertical === "md",
          "fr-tile--vertical@lg": n.vertical === "lg",
          "fr-tile--download": n.download,
          "fr-tile--no-icon": n.icon === !1,
          "fr-tile--no-border": n.noBorder,
          "fr-tile--no-background": n.noBackground,
          "fr-tile--shadow": n.shadow,
          "fr-tile--grey": n.grey
        }]])
      }, [
        o("div", yd, [
          o("div", kd, [
            (r(), L(J(n.titleTag), { class: "fr-tile__title" }, {
              default: F(() => [
                a.value ? (r(), d("a", {
                  key: 0,
                  class: "fr-tile__link",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  download: n.download,
                  href: n.disabled ? "" : n.to
                }, v(n.title), 9, wd)) : m("", !0),
                a.value ? m("", !0) : (r(), L(l, {
                  key: 1,
                  download: n.download,
                  class: "fr-tile__link",
                  to: n.disabled ? "" : n.to
                }, {
                  default: F(() => [
                    z(v(n.title), 1)
                  ]),
                  _: 1
                }, 8, ["download", "to"]))
              ]),
              _: 1
            })),
            n.description ? (r(), d("p", _d, v(n.description), 1)) : m("", !0),
            n.details ? (r(), d("p", $d, v(n.details), 1)) : m("", !0),
            n.$slots["start-details"] ? (r(), d("div", Dd, [
              I(n.$slots, "start-details", {}, void 0, !0)
            ])) : m("", !0)
          ])
        ]),
        o("div", Md, [
          I(n.$slots, "header", {}, void 0, !0),
          n.imgSrc || n.svgPath ? (r(), d("div", Id, [
            n.imgSrc ? (r(), d("img", {
              key: 0,
              src: n.imgSrc,
              class: "fr-artwork",
              alt: ""
            }, null, 8, Ld)) : (r(), d("svg", E({
              key: 1,
              "aria-hidden": "true",
              class: "fr-artwork"
            }, { ...t, ...n.svgAttrs }), [
              o("use", {
                class: "fr-artwork-decorative",
                href: `${n.svgPath}#artwork-decorative`
              }, null, 8, Cd),
              o("use", {
                class: "fr-artwork-minor",
                href: `${n.svgPath}#artwork-minor`
              }, null, 8, zd),
              o("use", {
                class: "fr-artwork-major",
                href: `${n.svgPath}#artwork-major`
              }, null, 8, Sd)
            ], 16))
          ])) : m("", !0)
        ])
      ], 2);
    };
  }
}), jt = /* @__PURE__ */ ae(Td, [["__scopeId", "data-v-4653a118"]]), Ad = { class: "fr-grid-row fr-grid-row--gutters" }, Ed = /* @__PURE__ */ D({
  __name: "DsfrTiles",
  props: {
    tiles: { default: () => [] },
    horizontal: { type: Boolean }
  },
  setup(s) {
    return (e, t) => (r(), d("div", Ad, [
      (r(!0), d(R, null, X(e.tiles, (a, n) => (r(), d("div", {
        key: n,
        class: C({
          [a.containerClass]: a.containerClass,
          "fr-col-6 fr-col-md-4 fr-col-lg-3": !a.containerClass && !e.horizontal,
          "fr-col-12": e.horizontal
        })
      }, [
        G(jt, E({
          horizontal: e.horizontal,
          ref_for: !0
        }, a), null, 16, ["horizontal"])
      ], 2))), 128))
    ]));
  }
}), Hd = ["id", "disabled", "aria-disabled", "checked", "data-testid", "aria-describedby"], Bd = ["id", "for", "data-fr-checked-label", "data-fr-unchecked-label"], Vd = ["id"], Rd = /* @__PURE__ */ D({
  __name: "DsfrToggleSwitch",
  props: {
    modelValue: { type: Boolean },
    inputId: { default: () => j("toggle") },
    hint: { default: "" },
    label: { default: "" },
    disabled: { type: Boolean },
    labelLeft: { type: Boolean, default: !1 },
    borderBottom: { type: Boolean, default: !1 },
    activeText: { default: "Activé" },
    inactiveText: { default: "Désactivé" },
    noText: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(s) {
    const e = s, t = g(() => `${e.inputId}-hint-text`);
    return (a, n) => (r(), d("div", {
      class: C(["fr-toggle", {
        "fr-toggle--label-left": a.labelLeft,
        "fr-toggle--border-bottom": a.borderBottom
      }])
    }, [
      o("input", {
        id: a.inputId,
        disabled: a.disabled,
        "aria-disabled": a.disabled,
        type: "checkbox",
        checked: a.modelValue,
        "data-testid": a.inputId,
        class: "fr-toggle__input",
        "aria-describedby": t.value,
        onInput: n[0] || (n[0] = (i) => a.$emit("update:modelValue", i.target.checked))
      }, null, 40, Hd),
      o("label", {
        id: t.value,
        class: "fr-toggle__label",
        for: a.inputId,
        "data-fr-checked-label": a.noText ? void 0 : a.activeText,
        "data-fr-unchecked-label": a.noText ? void 0 : a.inactiveText,
        style: { "--toggle-status-width": "3.55208125rem" }
      }, v(a.label), 9, Bd),
      a.hint ? (r(), d("p", {
        key: 0,
        id: `${a.inputId}-hint-text`,
        class: "fr-hint-text"
      }, v(a.hint), 9, Vd)) : m("", !0)
    ], 2));
  }
}), Pd = ["id"], Fd = /* @__PURE__ */ D({
  __name: "DsfrTooltip",
  props: {
    content: {},
    onHover: { type: Boolean },
    id: { default: () => j("tooltip") }
  },
  setup(s) {
    const e = s, t = B(!1), a = B(null), n = B(null), i = B("0px"), l = B("0px"), c = B("0px"), u = B(!1), p = B(0);
    async function h() {
      var Q, w, k, T, Y, O;
      if (typeof document > "u" || !t.value)
        return;
      await new Promise((K) => setTimeout(K, 100));
      const M = (Q = a.value) == null ? void 0 : Q.getBoundingClientRect().top, H = (w = a.value) == null ? void 0 : w.offsetHeight, S = (k = a.value) == null ? void 0 : k.offsetWidth, A = (T = a.value) == null ? void 0 : T.getBoundingClientRect().left, q = (Y = n.value) == null ? void 0 : Y.offsetHeight, P = (O = n.value) == null ? void 0 : O.offsetWidth, fe = !(M - q < 0) && M + H + q >= document.documentElement.offsetHeight;
      u.value = fe;
      const ie = A + S >= document.documentElement.offsetWidth, oe = A + S / 2 - P / 2 <= 0;
      l.value = fe ? `${M - q + 8}px` : `${M + H - 8}px`, p.value = 1, i.value = ie ? `${A + S - P - 4}px` : oe ? `${A + 4}px` : `${A + S / 2 - P / 2}px`, c.value = ie ? `${P / 2 - S / 2 + 4}px` : oe ? `${-(P / 2) + S / 2 - 4}px` : "0px";
    }
    te(t, h, { immediate: !0 }), ne(() => {
      window.addEventListener("scroll", h);
    }), be(() => {
      window.removeEventListener("scroll", h);
    });
    const f = g(() => `transform: translate(${i.value}, ${l.value}); --arrow-x: ${c.value}; opacity: ${p.value};'`), _ = g(() => ({
      "fr-tooltip--shown": t.value,
      "fr-placement--top": u.value,
      "fr-placement--bottom": !u.value
    })), $ = (M) => {
      var H, S;
      t.value && (M.target === a.value || (H = a.value) != null && H.contains(M.target) || M.target === n.value || (S = n.value) != null && S.contains(M.target) || (t.value = !1));
    };
    ne(() => {
      document.documentElement.addEventListener("click", $);
    }), be(() => {
      document.documentElement.removeEventListener("click", $);
    });
    const y = () => {
      e.onHover && (t.value = !0);
    }, V = () => {
      e.onHover && (t.value = !1);
    }, b = () => {
      e.onHover || (t.value = !t.value);
    };
    return (M, H) => (r(), d(R, null, [
      (r(), L(J(M.onHover ? "a" : "button"), {
        id: `link-${M.id}`,
        ref_key: "source",
        ref: a,
        class: C(M.onHover ? "fr-link" : "fr-btn  fr-btn--tooltip"),
        "aria-describedby": M.id,
        href: M.onHover ? "#" : void 0,
        onClick: H[0] || (H[0] = (S) => b()),
        onMouseenter: H[1] || (H[1] = (S) => y()),
        onMouseleave: H[2] || (H[2] = (S) => V())
      }, {
        default: F(() => [
          I(M.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 40, ["id", "class", "aria-describedby", "href"])),
      o("span", {
        id: M.id,
        ref_key: "tooltip",
        ref: n,
        class: C(["fr-tooltip fr-placement", _.value]),
        style: ue(f.value),
        role: "tooltip",
        "aria-hidden": "true"
      }, v(M.content), 15, Pd)
    ], 64));
  }
}), Nd = /* @__PURE__ */ ae(Fd, [["__scopeId", "data-v-c54626f2"]]), Xd = { class: "fr-transcription" }, Yd = ["aria-expanded", "aria-controls"], Od = ["id"], jd = ["id", "aria-labelledby"], qd = { class: "fr-container fr-container--fluid fr-container-md" }, Qd = { class: "fr-grid-row fr-grid-row--center" }, Gd = { class: "fr-col-12 fr-col-md-10 fr-col-lg-8" }, Kd = { class: "fr-modal__body" }, Wd = { class: "fr-modal__header" }, Ud = ["aria-controls"], Zd = { class: "fr-modal__content" }, Jd = ["id"], xd = { class: "fr-transcription__footer" }, eu = { class: "fr-transcription__actions-group" }, tu = ["aria-controls"], qt = /* @__PURE__ */ D({
  __name: "DsfrTranscription",
  props: {
    id: { default: () => j("transcription") },
    title: { default: "Titre de la vidéo" },
    content: { default: "Transcription du contenu de la vidéo" }
  },
  setup(s) {
    const e = s, {
      collapse: t,
      collapsing: a,
      cssExpanded: n,
      doExpand: i,
      onTransitionEnd: l
    } = ce(), c = B(!1), u = B(!1), p = g(() => `fr-transcription__modal-${e.id}`), h = g(() => `fr-transcription__collapse-${e.id}`);
    return te(u, (f, _) => {
      f !== _ && i(f);
    }), (f, _) => {
      const $ = se("DsfrModal");
      return r(), d("div", Xd, [
        o("button", {
          class: "fr-transcription__btn",
          "aria-expanded": u.value,
          "aria-controls": h.value,
          onClick: _[0] || (_[0] = (y) => u.value = !u.value)
        }, " Transcription ", 8, Yd),
        o("div", {
          id: h.value,
          ref_key: "collapse",
          ref: t,
          class: C(["fr-collapse", { "fr-collapse--expanded": N(n), "fr-collapsing": N(a) }]),
          onTransitionend: _[2] || (_[2] = (y) => N(l)(u.value))
        }, [
          o("dialog", {
            id: p.value,
            class: "fr-modal",
            role: "dialog",
            "aria-labelledby": `${p.value}-title`
          }, [
            o("div", qd, [
              o("div", Qd, [
                o("div", Gd, [
                  o("div", Kd, [
                    o("div", Wd, [
                      o("button", {
                        class: "fr-btn--close fr-btn",
                        "aria-controls": p.value,
                        title: "Fermer"
                      }, " Fermer ", 8, Ud)
                    ]),
                    o("div", Zd, [
                      o("h1", {
                        id: `${p.value}-title`,
                        class: "fr-modal__title"
                      }, v(f.title), 9, Jd),
                      z(" " + v(f.content), 1)
                    ]),
                    o("div", xd, [
                      o("div", eu, [
                        o("button", {
                          class: "fr-btn fr-btn--fullscreen",
                          "aria-controls": p.value,
                          "data-fr-opened": "false",
                          title: "",
                          onClick: _[1] || (_[1] = (y) => c.value = !0)
                        }, " Agrandir ", 8, tu)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], 8, jd)
        ], 42, Od),
        (r(), L(na, { to: "body" }, [
          G($, {
            title: f.title,
            opened: c.value,
            onClose: _[3] || (_[3] = (y) => c.value = !1)
          }, {
            default: F(() => [
              I(f.$slots, "default", {}, () => [
                z(v(f.content), 1)
              ])
            ]),
            _: 3
          }, 8, ["title", "opened"])
        ]))
      ]);
    };
  }
}), au = ["src"], nu = { class: "fr-content-media__caption" }, ru = /* @__PURE__ */ D({
  __name: "DsfrVideo",
  props: {
    src: {},
    legend: { default: "" },
    size: { default: "medium" },
    transcriptionTitle: { default: "" },
    transcriptionContent: { default: "" },
    ratio: { default: "16x9" }
  },
  setup(s) {
    return (e, t) => (r(), d("figure", {
      class: C(["fr-content-media", {
        "fr-content-media--sm": e.size === "small",
        "fr-content-media--lg": e.size === "large"
      }])
    }, [
      o("div", {
        class: C(["fr-responsive-vid", `fr-ratio-${e.ratio}`])
      }, [
        o("iframe", {
          src: e.src,
          class: "fr-responsive-vid__player",
          width: "100%",
          height: "100%",
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        }, null, 8, au)
      ], 2),
      o("div", nu, v(e.legend), 1),
      G(qt, {
        title: e.transcriptionTitle,
        content: e.transcriptionContent
      }, null, 8, ["title", "content"])
    ], 2));
  }
}), lu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DsfrAccordion: fa,
  DsfrAccordionsGroup: pa,
  DsfrAlert: ba,
  DsfrBackToTop: ra,
  DsfrBadge: ht,
  DsfrBreadcrumb: Ma,
  DsfrButton: Ae,
  DsfrButtonGroup: Ee,
  DsfrCallout: Ta,
  DsfrCard: qa,
  DsfrCheckbox: vt,
  DsfrCheckboxSet: an,
  DsfrConsent: sn,
  DsfrErrorPage: gn,
  DsfrFieldset: _n,
  DsfrFileDownload: mt,
  DsfrFileDownloadList: Ln,
  DsfrFileUpload: Hn,
  DsfrFollow: ar,
  DsfrFooter: Er,
  DsfrFooterLinkList: Rr,
  DsfrFooterPartners: yt,
  DsfrFranceConnect: Yr,
  DsfrHeader: Sl,
  DsfrHeaderMenuLink: kt,
  DsfrHeaderMenuLinks: Ne,
  DsfrHighlight: Al,
  DsfrInput: qe,
  DsfrInputGroup: Pl,
  DsfrLanguageSelector: Xe,
  DsfrLogo: Le,
  DsfrModal: $s,
  DsfrNavigation: qs,
  DsfrNavigationItem: Lt,
  DsfrNavigationMegaMenu: Tt,
  DsfrNavigationMegaMenuCategory: St,
  DsfrNavigationMenu: zt,
  DsfrNavigationMenuItem: Ct,
  DsfrNavigationMenuLink: He,
  DsfrNewsLetter: bt,
  DsfrNotice: Us,
  DsfrPagination: oo,
  DsfrPicture: po,
  DsfrQuote: wo,
  DsfrRadioButton: At,
  DsfrRadioButtonSet: Po,
  DsfrRange: Wo,
  DsfrSearchBar: Fe,
  DsfrSegmented: Et,
  DsfrSegmentedSet: li,
  DsfrSelect: pi,
  DsfrShare: wi,
  DsfrSideMenu: Si,
  DsfrSideMenuButton: Bt,
  DsfrSideMenuLink: Ti,
  DsfrSideMenuList: Vt,
  DsfrSideMenuListItem: Ht,
  DsfrSkipLinks: Vi,
  DsfrSocialNetworks: gt,
  DsfrStepper: Oi,
  DsfrSummary: Ki,
  DsfrTabContent: Pt,
  DsfrTabItem: Rt,
  DsfrTable: vd,
  DsfrTableCell: Ft,
  DsfrTableHeader: Xt,
  DsfrTableHeaders: Yt,
  DsfrTableRow: Nt,
  DsfrTabs: td,
  DsfrTag: Ot,
  DsfrTags: bd,
  DsfrTile: jt,
  DsfrTiles: Ed,
  DsfrToggleSwitch: Rd,
  DsfrTooltip: Nd,
  DsfrTranscription: qt,
  DsfrVideo: ru
}, Symbol.toStringTag, { value: "Module" })), su = { name: "ri-account-circle-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zM6.023 15.416C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0012.16 13a8.968 8.968 0 00-6.137 2.416zM12 11a3 3 0 100-6 3 3 0 000 6z"/>' }, ou = { name: "ri-account-circle-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-4.987-3.744A7.966 7.966 0 0012 20a7.97 7.97 0 005.167-1.892A6.979 6.979 0 0012.16 16a6.981 6.981 0 00-5.147 2.256zM5.616 16.82A8.975 8.975 0 0112.16 14a8.972 8.972 0 016.362 2.634 8 8 0 10-12.906.187zM12 13a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"/>' }, iu = { name: "ri-add-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"/>' }, du = { name: "ri-alert-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12.866 3l9.526 16.5a1 1 0 01-.866 1.5H2.474a1 1 0 01-.866-1.5L11.134 3a1 1 0 011.732 0zM11 16v2h2v-2h-2zm0-7v5h2V9h-2z"/>' }, uu = { name: "ri-alert-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12.866 3l9.526 16.5a1 1 0 01-.866 1.5H2.474a1 1 0 01-.866-1.5L11.134 3a1 1 0 011.732 0zm-8.66 16h15.588L12 5.5 4.206 19zM11 16h2v2h-2v-2zm0-7h2v5h-2V9z"/>' }, cu = { name: "ri-arrow-down-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M13 16.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172z"/>' }, fu = { name: "ri-arrow-down-s-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/>' }, pu = { name: "ri-arrow-drop-down-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 15l-4.243-4.243 1.415-1.414L12 12.172l2.828-2.829 1.415 1.414z"/>' }, hu = { name: "ri-arrow-left-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"/>' }, vu = { name: "ri-arrow-left-s-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z"/>' }, mu = { name: "ri-arrow-right-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"/>' }, gu = { name: "ri-arrow-right-s-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"/>' }, bu = { name: "ri-arrow-up-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"/>' }, yu = { name: "ri-arrow-up-s-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"/>' }, ku = { name: "ri-chat-1-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M10 3h4a8 8 0 110 16v3.5c-5-2-12-5-12-11.5a8 8 0 018-8zm2 14h2a6 6 0 100-12h-4a6 6 0 00-6 6c0 3.61 2.462 5.966 8 8.48V17z"/>' }, wu = { name: "ri-chat-quote-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M21 3a1 1 0 011 1v14a1 1 0 01-1 1H6.455L2 22.5V4a1 1 0 011-1h18zm-1 2H4v13.385L5.763 17H20V5zm-9.485 2.412l.447.688c-1.668.903-1.639 2.352-1.639 2.664.155-.02.318-.024.48-.009a1.761 1.761 0 011.613 1.745 1.75 1.75 0 01-1.75 1.75c-.537 0-1.05-.245-1.374-.59-.515-.546-.792-1.16-.792-2.155 0-1.75 1.228-3.318 3.015-4.093zm5 0l.447.688c-1.668.903-1.639 2.352-1.639 2.664.155-.02.318-.024.48-.009a1.761 1.761 0 011.613 1.745 1.75 1.75 0 01-1.75 1.75c-.537 0-1.05-.245-1.374-.59-.515-.546-.792-1.16-.792-2.155 0-1.75 1.228-3.318 3.015-4.093z"/>' }, _u = { name: "ri-check-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"/>' }, $u = { name: "ri-checkbox-circle-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"/>' }, Du = { name: "ri-checkbox-circle-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z"/>' }, Mu = { name: "ri-close-circle-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"/>' }, Iu = { name: "ri-close-circle-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"/>' }, Lu = { name: "ri-close-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/>' }, Cu = { name: "ri-delete-bin-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M17 6h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5V3a1 1 0 011-1h8a1 1 0 011 1v3zm-8 5v6h2v-6H9zm4 0v6h2v-6h-2zM9 4v2h6V4H9z"/>' }, zu = { name: "ri-delete-bin-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M17 6h5v2h-2v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H2V6h5V3a1 1 0 011-1h8a1 1 0 011 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z"/>' }, Su = { name: "ri-double-quotes-l", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5 3.871 3.871 0 01-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5 3.871 3.871 0 01-2.748-1.179z"/>' }, Tu = { name: "ri-download-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z"/>' }, Au = { name: "ri-edit-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M7.243 18H3v-4.243L14.435 2.322a1 1 0 011.414 0l2.829 2.829a1 1 0 010 1.414L7.243 18zM3 20h18v2H3v-2z"/>' }, Eu = { name: "ri-edit-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M6.414 16L16.556 5.858l-1.414-1.414L5 14.586V16h1.414zm.829 2H3v-4.243L14.435 2.322a1 1 0 011.414 0l2.829 2.829a1 1 0 010 1.414L7.243 18zM3 20h18v2H3v-2z"/>' }, Hu = { name: "ri-error-warning-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z"/>' }, Bu = { name: "ri-error-warning-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z"/>' }, Vu = { name: "ri-external-link-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z"/>' }, Ru = { name: "ri-eye-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16a9.005 9.005 0 008.777-7 9.005 9.005 0 00-17.554 0A9.005 9.005 0 0012 19zm0-2.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-2a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"/>' }, Pu = { name: "ri-eye-off-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M17.882 19.297A10.949 10.949 0 0112 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 013.34-6.066L1.392 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31zM5.935 7.35A8.965 8.965 0 003.223 12a9.005 9.005 0 0013.201 5.838l-2.028-2.028A4.5 4.5 0 018.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 003.241 3.241zm7.893 2.264l-1.431-1.43A8.935 8.935 0 0020.777 12 9.005 9.005 0 009.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 01-2.012 4.592zm-9.084-9.084a4.5 4.5 0 014.769 4.769l-4.77-4.769z"/>' }, Fu = { name: "ri-facebook-circle-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/>' }, Nu = { name: "ri-file-download-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M16 2l5 5v14.008a.993.993 0 01-.993.992H3.993A1 1 0 013 21.008V2.992C3 2.444 3.445 2 3.993 2H16zm-3 10V8h-2v4H8l4 4 4-4h-3z"/>' }, Xu = { name: "ri-file-download-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M13 12h3l-4 4-4-4h3V8h2v4zm2-8H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0120.007 22H3.993A1 1 0 013 21.008V2.992z"/>' }, Yu = { name: "ri-file-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M3 8l6.003-6h10.995C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 01-.993.992H3.993A1 1 0 013 20.993V8zm7-4.5L4.5 9H10V3.5z"/>' }, Ou = { name: "ri-file-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M9 2.003V2h10.998C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 01-.993.992H3.993A1 1 0 013 20.993V8l6-5.997zM5.83 8H9V4.83L5.83 8zM11 4v5a1 1 0 01-1 1H5v10h14V4h-8z"/>' }, ju = { name: "ri-file-pdf-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M16 2l5 5v14.008a.993.993 0 01-.993.992H3.993A1 1 0 013 21.008V2.992C3 2.444 3.445 2 3.993 2H16zm-4 14a4 4 0 100-8H8v8h4zm-2-6h2a2 2 0 110 4h-2v-4z"/>' }, qu = { name: "ri-file-pdf-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 16H8V8h4a4 4 0 110 8zm-2-6v4h2a2 2 0 100-4h-2zm5-6H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0120.007 22H3.993A1 1 0 013 21.008V2.992z"/>' }, Qu = { name: "ri-information-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z"/>' }, Gu = { name: "ri-information-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"/>' }, Ku = { name: "ri-instagram-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 011.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772 4.915 4.915 0 01-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 100 10 5 5 0 000-10zm6.5-.25a1.25 1.25 0 00-2.5 0 1.25 1.25 0 002.5 0zM12 9a3 3 0 110 6 3 3 0 010-6z"/>' }, Wu = { name: "ri-linkedin-box-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M18.335 18.339H15.67v-4.177c0-.996-.02-2.278-1.39-2.278-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387 2.7 0 3.2 1.778 3.2 4.091v4.715zM7.003 8.575a1.546 1.546 0 01-1.548-1.549 1.548 1.548 0 111.547 1.549zm1.336 9.764H5.666V9.75H8.34v8.589zM19.67 3H4.329C3.593 3 3 3.58 3 4.297v15.406C3 20.42 3.594 21 4.328 21h15.338C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3h.003z"/>' }, Uu = { name: "ri-loader-4-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M18.364 5.636L16.95 7.05A7 7 0 1019 12h2a9 9 0 11-2.636-6.364z"/>' }, Zu = { name: "ri-lock-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M19 10h1a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 1114 0v1zm-2 0V9A5 5 0 007 9v1h10zm-6 4v4h2v-4h-2z"/>' }, Ju = { name: "ri-lock-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M19 10h1a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 1114 0v1zM5 12v8h14v-8H5zm6 2h2v4h-2v-4zm6-4V9A5 5 0 007 9v1h10z"/>' }, xu = { name: "ri-mail-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm9.06 8.683L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439z"/>' }, ec = { name: "ri-mail-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"/>' }, tc = { name: "ri-menu-2-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h18v2H3V4zm0 7h12v2H3v-2zm0 7h18v2H3v-2z"/>' }, ac = { name: "ri-menu-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"/>' }, nc = { name: "ri-pause-circle-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM9 9v6h2V9H9zm4 0v6h2V9h-2z"/>' }, rc = { name: "ri-pause-circle-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zM9 9h2v6H9V9zm4 0h2v6h-2V9z"/>' }, lc = { name: "ri-play-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M19.376 12.416L8.777 19.482A.5.5 0 018 19.066V4.934a.5.5 0 01.777-.416l10.599 7.066a.5.5 0 010 .832z"/>' }, sc = { name: "ri-play-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M16.394 12L10 7.737v8.526L16.394 12zm2.982.416L8.777 19.482A.5.5 0 018 19.066V4.934a.5.5 0 01.777-.416l10.599 7.066a.5.5 0 010 .832z"/>' }, oc = { name: "ri-printer-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M7 17h10v5H7v-5zm12 3v-5H5v5H3a1 1 0 01-1-1V9a1 1 0 011-1h18a1 1 0 011 1v10a1 1 0 01-1 1h-2zM5 10v2h3v-2H5zm2-8h10a1 1 0 011 1v3H6V3a1 1 0 011-1z"/>' }, ic = { name: "ri-printer-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M6 19H3a1 1 0 01-1-1V8a1 1 0 011-1h3V3a1 1 0 011-1h10a1 1 0 011 1v4h3a1 1 0 011 1v10a1 1 0 01-1 1h-3v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2zm0-2v-1a1 1 0 011-1h10a1 1 0 011 1v1h2V9H4v8h2zM8 4v3h8V4H8zm0 13v3h8v-3H8zm-3-7h3v2H5v-2z"/>' }, dc = { name: "ri-question-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm2-1.645A3.502 3.502 0 0012 6.5a3.501 3.501 0 00-3.433 2.813l1.962.393A1.5 1.5 0 1112 11.5a1 1 0 00-1 1V14h2v-.645z"/>' }, uc = { name: "ri-question-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 011-1 1.5 1.5 0 10-1.471-1.794l-1.962-.393A3.501 3.501 0 1113 13.355z"/>' }, cc = { name: "ri-save-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M18 21v-8H6v8H4a1 1 0 01-1-1V4a1 1 0 011-1h13l4 4v13a1 1 0 01-1 1h-2zm-2 0H8v-6h8v6z"/>' }, fc = { name: "ri-save-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M7 19v-6h10v6h2V7.828L16.172 5H5v14h2zM4 3h13l4 4v13a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm5 12v4h6v-4H9z"/>' }, pc = { name: "ri-search-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617z"/>' }, hc = { name: "ri-search-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0018 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15z"/>' }, vc = { name: "ri-skip-back-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M8 11.333l10.223-6.815a.5.5 0 01.777.416v14.132a.5.5 0 01-.777.416L8 12.667V19a1 1 0 01-2 0V5a1 1 0 112 0v6.333z"/>' }, mc = { name: "ri-skip-forward-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M16 12.667L5.777 19.482A.5.5 0 015 19.066V4.934a.5.5 0 01.777-.416L16 11.333V5a1 1 0 012 0v14a1 1 0 01-2 0v-6.333z"/>' }, gc = { name: "ri-sort-asc", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M19 3l4 5h-3v12h-2V8h-3l4-5zm-5 15v2H3v-2h11zm0-7v2H3v-2h11zm-2-7v2H3V4h9z"/>' }, bc = { name: "ri-sort-desc", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M20 4v12h3l-4 5-4-5h3V4h2zm-8 14v2H3v-2h9zm2-7v2H3v-2h11zm0-7v2H3V4h11z"/>' }, yc = { name: "ri-subtract-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M5 11h14v2H5z"/>' }, kc = { name: "ri-twitter-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M22.162 5.656a8.384 8.384 0 01-2.402.658A4.196 4.196 0 0021.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 00-7.126 3.814 11.874 11.874 0 01-8.62-4.37 4.168 4.168 0 00-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 01-1.894-.523v.052a4.185 4.185 0 003.355 4.101 4.21 4.21 0 01-1.89.072A4.185 4.185 0 007.97 16.65a8.394 8.394 0 01-6.191 1.732 11.83 11.83 0 006.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 002.087-2.165z"/>' }, wc = { name: "ri-user-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M4 22a8 8 0 1116 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z"/>' }, _c = { name: "ri-user-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M4 22a8 8 0 1116 0h-2a6 6 0 10-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/>' }, $c = { name: "ri-volume-down-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M8.889 16H5a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L8.89 16zm9.974.591l-1.422-1.422A3.993 3.993 0 0019 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0121 12c0 1.842-.83 3.49-2.137 4.591z"/>' }, Dc = { name: "ri-volume-down-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M13 7.22L9.603 10H6v4h3.603L13 16.78V7.22zM8.889 16H5a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L8.89 16zm9.974.591l-1.422-1.422A3.993 3.993 0 0019 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0121 12c0 1.842-.83 3.49-2.137 4.591z"/>' }, Mc = { name: "ri-volume-mute-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M5.889 16H2a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L5.89 16zm14.525-4l3.536 3.536-1.414 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.464l1.414-1.414L19 10.586l3.536-3.536 1.414 1.414L20.414 12z"/>' }, Ic = { name: "ri-volume-mute-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M10 7.22L6.603 10H3v4h3.603L10 16.78V7.22zM5.889 16H2a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L5.89 16zm14.525-4l3.536 3.536-1.414 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.464l1.414-1.414L19 10.586l3.536-3.536 1.414 1.414L20.414 12z"/>' }, Lc = { name: "ri-volume-up-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M5.889 16H2a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L5.89 16zm13.517 4.134l-1.416-1.416A8.978 8.978 0 0021 12a8.982 8.982 0 00-3.304-6.968l1.42-1.42A10.976 10.976 0 0123 12c0 3.223-1.386 6.122-3.594 8.134zm-3.543-3.543l-1.422-1.422A3.993 3.993 0 0016 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0118 12c0 1.842-.83 3.49-2.137 4.591z"/>' }, Cc = { name: "ri-volume-up-line", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M10 7.22L6.603 10H3v4h3.603L10 16.78V7.22zM5.889 16H2a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L5.89 16zm13.517 4.134l-1.416-1.416A8.978 8.978 0 0021 12a8.982 8.982 0 00-3.304-6.968l1.42-1.42A10.976 10.976 0 0123 12c0 3.223-1.386 6.122-3.594 8.134zm-3.543-3.543l-1.422-1.422A3.993 3.993 0 0016 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0118 12c0 1.842-.83 3.49-2.137 4.591z"/>' }, zc = { name: "ri-youtube-fill", minX: 0, minY: 0, width: 24, height: 24, raw: '<path fill="none" d="M0 0h24v24H0z"/><path d="M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5l6-3.5-6-3.5v7z"/>' }, Sc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RiAccountCircleFill: su,
  RiAccountCircleLine: ou,
  RiAddLine: iu,
  RiAlertFill: du,
  RiAlertLine: uu,
  RiArrowDownLine: cu,
  RiArrowDownSLine: fu,
  RiArrowDropDownLine: pu,
  RiArrowLeftLine: hu,
  RiArrowLeftSLine: vu,
  RiArrowRightLine: mu,
  RiArrowRightSLine: gu,
  RiArrowUpLine: bu,
  RiArrowUpSLine: yu,
  RiChat1Line: ku,
  RiChatQuoteLine: wu,
  RiCheckLine: _u,
  RiCheckboxCircleFill: $u,
  RiCheckboxCircleLine: Du,
  RiCloseCircleFill: Mu,
  RiCloseCircleLine: Iu,
  RiCloseLine: Lu,
  RiDeleteBinFill: Cu,
  RiDeleteBinLine: zu,
  RiDoubleQuotesL: Su,
  RiDownloadLine: Tu,
  RiEditFill: Au,
  RiEditLine: Eu,
  RiErrorWarningFill: Hu,
  RiErrorWarningLine: Bu,
  RiExternalLinkLine: Vu,
  RiEyeLine: Ru,
  RiEyeOffLine: Pu,
  RiFacebookCircleFill: Fu,
  RiFileDownloadFill: Nu,
  RiFileDownloadLine: Xu,
  RiFileFill: Yu,
  RiFileLine: Ou,
  RiFilePdfFill: ju,
  RiFilePdfLine: qu,
  RiInformationFill: Qu,
  RiInformationLine: Gu,
  RiInstagramFill: Ku,
  RiLinkedinBoxFill: Wu,
  RiLoader4Line: Uu,
  RiLockFill: Zu,
  RiLockLine: Ju,
  RiMailFill: xu,
  RiMailLine: ec,
  RiMenu2Fill: tc,
  RiMenuFill: ac,
  RiPauseCircleFill: nc,
  RiPauseCircleLine: rc,
  RiPlayFill: lc,
  RiPlayLine: sc,
  RiPrinterFill: oc,
  RiPrinterLine: ic,
  RiQuestionFill: dc,
  RiQuestionLine: uc,
  RiSaveFill: cc,
  RiSaveLine: fc,
  RiSearchFill: pc,
  RiSearchLine: hc,
  RiSkipBackFill: vc,
  RiSkipForwardFill: mc,
  RiSortAsc: gc,
  RiSortDesc: bc,
  RiSubtractLine: yc,
  RiTwitterFill: kc,
  RiUserFill: wc,
  RiUserLine: _c,
  RiVolumeDownFill: $c,
  RiVolumeDownLine: Dc,
  RiVolumeMuteFill: Mc,
  RiVolumeMuteLine: Ic,
  RiVolumeUpFill: Lc,
  RiVolumeUpLine: Cc,
  RiYoutubeFill: zc
}, Symbol.toStringTag, { value: "Module" })), Vc = {
  from: "@gouvminint/vue-dsfr",
  imports: [
    "useScheme",
    "useTabs"
  ]
}, Rc = {
  from: "oh-vue-icons",
  imports: [
    "addIcons",
    "OhVueIcon"
  ]
}, Pc = (s) => {
  if (s === "VIcon" || s === "OhVueIcon")
    return {
      name: "OhVueIcon",
      from: "oh-vue-icons"
    };
  if (s.startsWith("Dsfr"))
    return {
      name: s,
      from: "@gouvminint/vue-dsfr"
    };
}, Fc = {
  install: (s, { icons: e, components: t } = {}) => {
    Object.entries(lu).forEach(([a, n]) => {
      (t === void 0 || t === "all" || t.map(({ name: i }) => i).includes(a)) && s.component(a, n);
    }), Ge(...Object.values(Sc)), e && Ge(...e), s.component("VIcon", le);
  }
};
export {
  _e as DARK_SCHEME,
  fa as DsfrAccordion,
  pa as DsfrAccordionsGroup,
  ba as DsfrAlert,
  ra as DsfrBackToTop,
  ht as DsfrBadge,
  Ma as DsfrBreadcrumb,
  Ae as DsfrButton,
  Ee as DsfrButtonGroup,
  Ta as DsfrCallout,
  qa as DsfrCard,
  vt as DsfrCheckbox,
  an as DsfrCheckboxSet,
  sn as DsfrConsent,
  gn as DsfrErrorPage,
  _n as DsfrFieldset,
  mt as DsfrFileDownload,
  Ln as DsfrFileDownloadList,
  Hn as DsfrFileUpload,
  ar as DsfrFollow,
  Er as DsfrFooter,
  Rr as DsfrFooterLinkList,
  yt as DsfrFooterPartners,
  Yr as DsfrFranceConnect,
  Sl as DsfrHeader,
  kt as DsfrHeaderMenuLink,
  Ne as DsfrHeaderMenuLinks,
  Al as DsfrHighlight,
  qe as DsfrInput,
  Pl as DsfrInputGroup,
  Xe as DsfrLanguageSelector,
  Le as DsfrLogo,
  $s as DsfrModal,
  qs as DsfrNavigation,
  Lt as DsfrNavigationItem,
  Tt as DsfrNavigationMegaMenu,
  St as DsfrNavigationMegaMenuCategory,
  zt as DsfrNavigationMenu,
  Ct as DsfrNavigationMenuItem,
  He as DsfrNavigationMenuLink,
  bt as DsfrNewsLetter,
  Us as DsfrNotice,
  oo as DsfrPagination,
  po as DsfrPicture,
  wo as DsfrQuote,
  At as DsfrRadioButton,
  Po as DsfrRadioButtonSet,
  Wo as DsfrRange,
  Fe as DsfrSearchBar,
  Et as DsfrSegmented,
  li as DsfrSegmentedSet,
  pi as DsfrSelect,
  wi as DsfrShare,
  Si as DsfrSideMenu,
  Bt as DsfrSideMenuButton,
  Ti as DsfrSideMenuLink,
  Vt as DsfrSideMenuList,
  Ht as DsfrSideMenuListItem,
  Vi as DsfrSkipLinks,
  gt as DsfrSocialNetworks,
  Oi as DsfrStepper,
  Ki as DsfrSummary,
  Pt as DsfrTabContent,
  Rt as DsfrTabItem,
  vd as DsfrTable,
  Ft as DsfrTableCell,
  Xt as DsfrTableHeader,
  Yt as DsfrTableHeaders,
  Nt as DsfrTableRow,
  td as DsfrTabs,
  Ot as DsfrTag,
  bd as DsfrTags,
  jt as DsfrTile,
  Ed as DsfrTiles,
  Rd as DsfrToggleSwitch,
  Nd as DsfrTooltip,
  qt as DsfrTranscription,
  ru as DsfrVideo,
  Ie as LIGHT_SCHEME,
  ge as SYSTEM_SCHEME,
  Ke as alphanum,
  Fc as default,
  sa as getRandomAlphaNum,
  j as getRandomId,
  oa as getRandomString,
  Sc as icons,
  Rc as ohVueIconAutoimportPreset,
  Ec as repeatFn,
  ce as useCollapsable,
  Hc as useScheme,
  Bc as useTabs,
  Vc as vueDsfrAutoimportPreset,
  Pc as vueDsfrComponentResolver
};
